/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CalendarDay: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type ActivityMistakeCompaction = {
  __typename?: 'ActivityMistakeCompaction';
  clampedFacts: Scalars['Int']['output'];
  misc: Scalars['Int']['output'];
  possession: Scalars['Int']['output'];
  read: Scalars['Int']['output'];
  release: Scalars['Int']['output'];
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type CalendarDayNullableFilter = {
  equals?: InputMaybe<Scalars['CalendarDay']['input']>;
  gt?: InputMaybe<Scalars['CalendarDay']['input']>;
  gte?: InputMaybe<Scalars['CalendarDay']['input']>;
  in?: InputMaybe<Array<Scalars['CalendarDay']['input']>>;
  lt?: InputMaybe<Scalars['CalendarDay']['input']>;
  lte?: InputMaybe<Scalars['CalendarDay']['input']>;
  not?: InputMaybe<CalendarDayNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['CalendarDay']['input']>>;
};

export type CatalogDeltaPage = {
  __typename?: 'CatalogDeltaPage';
  databaseListConfigs: Array<DatabaseListConfig>;
  databaseListReleaseEntries: Array<DatabaseListReleaseEntry>;
  demographies: Array<Demography>;
  hasMore: Scalars['Boolean']['output'];
  headSeq: Scalars['String']['output'];
  individuals: Array<Individual>;
  jobs: Array<Job>;
  jpPublishers: Array<JpPublisher>;
  magazines: Array<Magazine>;
  materialInfos: Array<MaterialInfo>;
  nextSeq: Scalars['String']['output'];
  novelties: Array<Novelty>;
  publishers: Array<Publisher>;
  releaseEntries: Array<ReleaseEntry>;
  releaseItemCollections: Array<ReleaseItemCollection>;
  releaseItems: Array<ReleaseItem>;
  resyncRequired: Scalars['Boolean']['output'];
  seriesInfos: Array<SeriesInfo>;
  sizeInfos: Array<SizeInfo>;
  staffEntries: Array<StaffEntry>;
  tags: Array<Tag>;
  tombstones: Array<CatalogTombstone>;
  volumeSuffixes: Array<VolumeSuffix>;
};

export type CatalogSubscriptionInput = {
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CatalogTombstone = {
  __typename?: 'CatalogTombstone';
  entity: Scalars['String']['output'];
  rowId: Scalars['ID']['output'];
};

export type ContentReport = {
  __typename?: 'ContentReport';
  handlingState?: Maybe<ContentReportHandlingStateType>;
  id: Scalars['ID']['output'];
  reason?: Maybe<ContentReportReasonType>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  reportedContent?: Maybe<ContentReportReportedContentType>;
  reportedHandle?: Maybe<Scalars['String']['output']>;
  reportedImage?: Maybe<UserImage>;
  reportedUser?: Maybe<User>;
  reporterEmail?: Maybe<Scalars['String']['output']>;
  reporterNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  reporterUser?: Maybe<User>;
  statement?: Maybe<Scalars['String']['output']>;
};

export type ContentReportCreateInput = {
  handlingState?: InputMaybe<ContentReportHandlingStateType>;
  reason?: InputMaybe<ContentReportReasonType>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportedContent?: InputMaybe<ContentReportReportedContentType>;
  reportedHandle?: InputMaybe<Scalars['String']['input']>;
  reportedImage?: InputMaybe<UserImageRelateToOneForCreateInput>;
  reportedUser?: InputMaybe<UserRelateToOneForCreateInput>;
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
  reporterNotifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reporterUser?: InputMaybe<UserRelateToOneForCreateInput>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentReportHandlingStateType {
  ContentRemoved = 'content_removed',
  Dismissed = 'dismissed',
  Escalated = 'escalated',
  Received = 'received'
}

export type ContentReportHandlingStateTypeNullableFilter = {
  equals?: InputMaybe<ContentReportHandlingStateType>;
  in?: InputMaybe<Array<ContentReportHandlingStateType>>;
  not?: InputMaybe<ContentReportHandlingStateTypeNullableFilter>;
  notIn?: InputMaybe<Array<ContentReportHandlingStateType>>;
};

export type ContentReportOrderByInput = {
  handlingState?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  reason?: InputMaybe<OrderDirection>;
  receivedAt?: InputMaybe<OrderDirection>;
  reportedContent?: InputMaybe<OrderDirection>;
  reportedHandle?: InputMaybe<OrderDirection>;
  reporterEmail?: InputMaybe<OrderDirection>;
  reporterNotifiedAt?: InputMaybe<OrderDirection>;
  statement?: InputMaybe<OrderDirection>;
};

export enum ContentReportReasonType {
  CopyrightInfringement = 'copyright_infringement',
  HateOrViolence = 'hate_or_violence',
  IllegalContent = 'illegal_content',
  Other = 'other',
  SexualContent = 'sexual_content'
}

export type ContentReportReasonTypeNullableFilter = {
  equals?: InputMaybe<ContentReportReasonType>;
  in?: InputMaybe<Array<ContentReportReasonType>>;
  not?: InputMaybe<ContentReportReasonTypeNullableFilter>;
  notIn?: InputMaybe<Array<ContentReportReasonType>>;
};

export type ContentReportReceipt = {
  __typename?: 'ContentReportReceipt';
  accepted: Scalars['Boolean']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rejection?: Maybe<Scalars['String']['output']>;
};

export enum ContentReportReportedContentType {
  Avatar = 'avatar',
  Banner = 'banner',
  Bio = 'bio',
  Name = 'name'
}

export type ContentReportReportedContentTypeNullableFilter = {
  equals?: InputMaybe<ContentReportReportedContentType>;
  in?: InputMaybe<Array<ContentReportReportedContentType>>;
  not?: InputMaybe<ContentReportReportedContentTypeNullableFilter>;
  notIn?: InputMaybe<Array<ContentReportReportedContentType>>;
};

export type ContentReportUpdateArgs = {
  data: ContentReportUpdateInput;
  where: ContentReportWhereUniqueInput;
};

export type ContentReportUpdateInput = {
  handlingState?: InputMaybe<ContentReportHandlingStateType>;
  reason?: InputMaybe<ContentReportReasonType>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportedContent?: InputMaybe<ContentReportReportedContentType>;
  reportedHandle?: InputMaybe<Scalars['String']['input']>;
  reportedImage?: InputMaybe<UserImageRelateToOneForUpdateInput>;
  reportedUser?: InputMaybe<UserRelateToOneForUpdateInput>;
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
  reporterNotifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reporterUser?: InputMaybe<UserRelateToOneForUpdateInput>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type ContentReportWhereInput = {
  AND?: InputMaybe<Array<ContentReportWhereInput>>;
  NOT?: InputMaybe<Array<ContentReportWhereInput>>;
  OR?: InputMaybe<Array<ContentReportWhereInput>>;
  handlingState?: InputMaybe<ContentReportHandlingStateTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  reason?: InputMaybe<ContentReportReasonTypeNullableFilter>;
  receivedAt?: InputMaybe<DateTimeNullableFilter>;
  reportedContent?: InputMaybe<ContentReportReportedContentTypeNullableFilter>;
  reportedHandle?: InputMaybe<StringFilter>;
  reportedImage?: InputMaybe<UserImageWhereInput>;
  reportedUser?: InputMaybe<UserWhereInput>;
  reporterEmail?: InputMaybe<StringFilter>;
  reporterNotifiedAt?: InputMaybe<DateTimeNullableFilter>;
  reporterUser?: InputMaybe<UserWhereInput>;
  statement?: InputMaybe<StringFilter>;
};

export type ContentReportWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ConvertItemConversionInput = {
  collectionId: Scalars['ID']['input'];
  sourceVolumeNumber: Scalars['String']['input'];
};

export type ConvertItemsToCollectionsResult = {
  __typename?: 'ConvertItemsToCollectionsResult';
  affectedUsers: Scalars['Int']['output'];
  entryId: Scalars['ID']['output'];
  miscAdded: Scalars['Int']['output'];
  readMigrated: Scalars['Int']['output'];
  statusesUpdated: Scalars['Int']['output'];
  volumesCollected: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID']['output'];
  iso316611alpha2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CountryCreateInput = {
  iso316611alpha2?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CountryOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  iso316611alpha2?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type CountryUpdateArgs = {
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateInput = {
  iso316611alpha2?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  id?: InputMaybe<IdFilter>;
  iso316611alpha2?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CountryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  iso316611alpha2?: InputMaybe<Scalars['String']['input']>;
};

export type CustomNotificationAudience = {
  __typename?: 'CustomNotificationAudience';
  channel: Scalars['String']['output'];
  recipientCount: Scalars['Int']['output'];
  tokenCount: Scalars['Int']['output'];
};

export type CustomNotificationInput = {
  channel: Scalars['String']['input'];
  descriptionDe: Scalars['String']['input'];
  descriptionEn: Scalars['String']['input'];
  linkPath: Scalars['String']['input'];
  titleDe: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type DatabaseListConfig = {
  __typename?: 'DatabaseListConfig';
  curatedEntries?: Maybe<Array<DatabaseListReleaseEntry>>;
  curatedEntriesCount?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  hideSearch?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  ignoredFilterPropsForChangeDetection?: Maybe<Scalars['JSON']['output']>;
  listType?: Maybe<DatabaseListConfigListTypeType>;
  mode?: Maybe<DatabaseListConfigModeType>;
  nameDe?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['JSON']['output']>;
  subtitleDe?: Maybe<Scalars['String']['output']>;
  subtitleEn?: Maybe<Scalars['String']['output']>;
  urlName?: Maybe<Scalars['String']['output']>;
};


export type DatabaseListConfigCuratedEntriesArgs = {
  cursor?: InputMaybe<DatabaseListReleaseEntryWhereUniqueInput>;
  orderBy?: Array<DatabaseListReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DatabaseListReleaseEntryWhereInput;
};


export type DatabaseListConfigCuratedEntriesCountArgs = {
  where?: DatabaseListReleaseEntryWhereInput;
};

export type DatabaseListConfigCreateInput = {
  curatedEntries?: InputMaybe<DatabaseListReleaseEntryRelateToManyForCreateInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  hideSearch?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredFilterPropsForChangeDetection?: InputMaybe<Scalars['JSON']['input']>;
  listType?: InputMaybe<DatabaseListConfigListTypeType>;
  mode?: InputMaybe<DatabaseListConfigModeType>;
  nameDe?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  subtitleDe?: InputMaybe<Scalars['String']['input']>;
  subtitleEn?: InputMaybe<Scalars['String']['input']>;
  urlName?: InputMaybe<Scalars['String']['input']>;
};

export enum DatabaseListConfigListTypeType {
  Explore = 'explore',
  Licenses = 'licenses'
}

export type DatabaseListConfigListTypeTypeNullableFilter = {
  equals?: InputMaybe<DatabaseListConfigListTypeType>;
  in?: InputMaybe<Array<DatabaseListConfigListTypeType>>;
  not?: InputMaybe<DatabaseListConfigListTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<DatabaseListConfigListTypeType>>;
};

export enum DatabaseListConfigModeType {
  Curated = 'curated',
  Filtered = 'filtered'
}

export type DatabaseListConfigModeTypeNullableFilter = {
  equals?: InputMaybe<DatabaseListConfigModeType>;
  in?: InputMaybe<Array<DatabaseListConfigModeType>>;
  not?: InputMaybe<DatabaseListConfigModeTypeNullableFilter>;
  notIn?: InputMaybe<Array<DatabaseListConfigModeType>>;
};

export type DatabaseListConfigOrderByInput = {
  enabled?: InputMaybe<OrderDirection>;
  hideSearch?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  listType?: InputMaybe<OrderDirection>;
  mode?: InputMaybe<OrderDirection>;
  nameDe?: InputMaybe<OrderDirection>;
  nameEn?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  subtitleDe?: InputMaybe<OrderDirection>;
  subtitleEn?: InputMaybe<OrderDirection>;
  urlName?: InputMaybe<OrderDirection>;
};

export type DatabaseListConfigRelateToOneForCreateInput = {
  connect?: InputMaybe<DatabaseListConfigWhereUniqueInput>;
  create?: InputMaybe<DatabaseListConfigCreateInput>;
};

export type DatabaseListConfigRelateToOneForUpdateInput = {
  connect?: InputMaybe<DatabaseListConfigWhereUniqueInput>;
  create?: InputMaybe<DatabaseListConfigCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatabaseListConfigUpdateArgs = {
  data: DatabaseListConfigUpdateInput;
  where: DatabaseListConfigWhereUniqueInput;
};

export type DatabaseListConfigUpdateInput = {
  curatedEntries?: InputMaybe<DatabaseListReleaseEntryRelateToManyForUpdateInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  hideSearch?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredFilterPropsForChangeDetection?: InputMaybe<Scalars['JSON']['input']>;
  listType?: InputMaybe<DatabaseListConfigListTypeType>;
  mode?: InputMaybe<DatabaseListConfigModeType>;
  nameDe?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  subtitleDe?: InputMaybe<Scalars['String']['input']>;
  subtitleEn?: InputMaybe<Scalars['String']['input']>;
  urlName?: InputMaybe<Scalars['String']['input']>;
};

export type DatabaseListConfigWhereInput = {
  AND?: InputMaybe<Array<DatabaseListConfigWhereInput>>;
  NOT?: InputMaybe<Array<DatabaseListConfigWhereInput>>;
  OR?: InputMaybe<Array<DatabaseListConfigWhereInput>>;
  curatedEntries?: InputMaybe<DatabaseListReleaseEntryManyRelationFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  hideSearch?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IdFilter>;
  listType?: InputMaybe<DatabaseListConfigListTypeTypeNullableFilter>;
  mode?: InputMaybe<DatabaseListConfigModeTypeNullableFilter>;
  nameDe?: InputMaybe<StringFilter>;
  nameEn?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  subtitleDe?: InputMaybe<StringFilter>;
  subtitleEn?: InputMaybe<StringFilter>;
  urlName?: InputMaybe<StringFilter>;
};

export type DatabaseListConfigWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  urlName?: InputMaybe<Scalars['String']['input']>;
};

export type DatabaseListReleaseEntry = {
  __typename?: 'DatabaseListReleaseEntry';
  compoundKey?: Maybe<Scalars['String']['output']>;
  databaseList?: Maybe<DatabaseListConfig>;
  id: Scalars['ID']['output'];
  orderNumber?: Maybe<Scalars['Int']['output']>;
  releaseEntry?: Maybe<ReleaseEntry>;
};

export type DatabaseListReleaseEntryCreateInput = {
  databaseList?: InputMaybe<DatabaseListConfigRelateToOneForCreateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
};

export type DatabaseListReleaseEntryManyRelationFilter = {
  every?: InputMaybe<DatabaseListReleaseEntryWhereInput>;
  none?: InputMaybe<DatabaseListReleaseEntryWhereInput>;
  some?: InputMaybe<DatabaseListReleaseEntryWhereInput>;
};

export type DatabaseListReleaseEntryOrderByInput = {
  compoundKey?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  orderNumber?: InputMaybe<OrderDirection>;
};

export type DatabaseListReleaseEntryRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<DatabaseListReleaseEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<DatabaseListReleaseEntryCreateInput>>;
};

export type DatabaseListReleaseEntryRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<DatabaseListReleaseEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<DatabaseListReleaseEntryCreateInput>>;
  disconnect?: InputMaybe<Array<DatabaseListReleaseEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<DatabaseListReleaseEntryWhereUniqueInput>>;
};

export type DatabaseListReleaseEntryUpdateArgs = {
  data: DatabaseListReleaseEntryUpdateInput;
  where: DatabaseListReleaseEntryWhereUniqueInput;
};

export type DatabaseListReleaseEntryUpdateInput = {
  databaseList?: InputMaybe<DatabaseListConfigRelateToOneForUpdateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
};

export type DatabaseListReleaseEntryWhereInput = {
  AND?: InputMaybe<Array<DatabaseListReleaseEntryWhereInput>>;
  NOT?: InputMaybe<Array<DatabaseListReleaseEntryWhereInput>>;
  OR?: InputMaybe<Array<DatabaseListReleaseEntryWhereInput>>;
  compoundKey?: InputMaybe<StringFilter>;
  databaseList?: InputMaybe<DatabaseListConfigWhereInput>;
  id?: InputMaybe<IdFilter>;
  orderNumber?: InputMaybe<IntNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
};

export type DatabaseListReleaseEntryWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<DecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<DecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type Demography = {
  __typename?: 'Demography';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DemographyCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DemographyManyRelationFilter = {
  every?: InputMaybe<DemographyWhereInput>;
  none?: InputMaybe<DemographyWhereInput>;
  some?: InputMaybe<DemographyWhereInput>;
};

export type DemographyOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type DemographyRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<DemographyWhereUniqueInput>>;
  create?: InputMaybe<Array<DemographyCreateInput>>;
};

export type DemographyRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<DemographyWhereUniqueInput>>;
  create?: InputMaybe<Array<DemographyCreateInput>>;
  disconnect?: InputMaybe<Array<DemographyWhereUniqueInput>>;
  set?: InputMaybe<Array<DemographyWhereUniqueInput>>;
};

export type DemographyUpdateArgs = {
  data: DemographyUpdateInput;
  where: DemographyWhereUniqueInput;
};

export type DemographyUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DemographyWhereInput = {
  AND?: InputMaybe<Array<DemographyWhereInput>>;
  NOT?: InputMaybe<Array<DemographyWhereInput>>;
  OR?: InputMaybe<Array<DemographyWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DemographyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Extra = {
  __typename?: 'Extra';
  description?: Maybe<Extra_Description_Document>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ExtraCreateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExtraManyRelationFilter = {
  every?: InputMaybe<ExtraWhereInput>;
  none?: InputMaybe<ExtraWhereInput>;
  some?: InputMaybe<ExtraWhereInput>;
};

export type ExtraOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ExtraRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ExtraWhereUniqueInput>>;
  create?: InputMaybe<Array<ExtraCreateInput>>;
};

export type ExtraRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ExtraWhereUniqueInput>>;
  create?: InputMaybe<Array<ExtraCreateInput>>;
  disconnect?: InputMaybe<Array<ExtraWhereUniqueInput>>;
  set?: InputMaybe<Array<ExtraWhereUniqueInput>>;
};

export type ExtraUpdateArgs = {
  data: ExtraUpdateInput;
  where: ExtraWhereUniqueInput;
};

export type ExtraUpdateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExtraWhereInput = {
  AND?: InputMaybe<Array<ExtraWhereInput>>;
  NOT?: InputMaybe<Array<ExtraWhereInput>>;
  OR?: InputMaybe<Array<ExtraWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ExtraWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Extra_Description_Document = {
  __typename?: 'Extra_description_Document';
  document: Scalars['JSON']['output'];
};


export type Extra_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Feedback = {
  __typename?: 'Feedback';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type FeedbackCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type FeedbackOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  feedback?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type FeedbackUpdateArgs = {
  data: FeedbackUpdateInput;
  where: FeedbackWhereUniqueInput;
};

export type FeedbackUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type FeedbackWhereInput = {
  AND?: InputMaybe<Array<FeedbackWhereInput>>;
  NOT?: InputMaybe<Array<FeedbackWhereInput>>;
  OR?: InputMaybe<Array<FeedbackWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  feedback?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type FeedbackWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Individual = {
  __typename?: 'Individual';
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  disambiguator?: Maybe<Scalars['String']['output']>;
  exId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IndividualCreateInput = {
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  disambiguator?: InputMaybe<Scalars['String']['input']>;
  exId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleNames?: InputMaybe<Scalars['String']['input']>;
};

export type IndividualOrderByInput = {
  birthDate?: InputMaybe<OrderDirection>;
  disambiguator?: InputMaybe<OrderDirection>;
  exId?: InputMaybe<OrderDirection>;
  firstName?: InputMaybe<OrderDirection>;
  handle?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastName?: InputMaybe<OrderDirection>;
  middleNames?: InputMaybe<OrderDirection>;
};

export type IndividualRelateToOneForCreateInput = {
  connect?: InputMaybe<IndividualWhereUniqueInput>;
  create?: InputMaybe<IndividualCreateInput>;
};

export type IndividualRelateToOneForUpdateInput = {
  connect?: InputMaybe<IndividualWhereUniqueInput>;
  create?: InputMaybe<IndividualCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndividualUpdateArgs = {
  data: IndividualUpdateInput;
  where: IndividualWhereUniqueInput;
};

export type IndividualUpdateInput = {
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  disambiguator?: InputMaybe<Scalars['String']['input']>;
  exId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleNames?: InputMaybe<Scalars['String']['input']>;
};

export type IndividualWhereInput = {
  AND?: InputMaybe<Array<IndividualWhereInput>>;
  NOT?: InputMaybe<Array<IndividualWhereInput>>;
  OR?: InputMaybe<Array<IndividualWhereInput>>;
  birthDate?: InputMaybe<DateTimeNullableFilter>;
  disambiguator?: InputMaybe<StringFilter>;
  exId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  handle?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lastName?: InputMaybe<StringFilter>;
  middleNames?: InputMaybe<StringFilter>;
};

export type IndividualWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  vlb71Codes?: Maybe<Scalars['String']['output']>;
};

export type JobCreateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  vlb71Codes?: InputMaybe<Scalars['String']['input']>;
};

export type JobManyRelationFilter = {
  every?: InputMaybe<JobWhereInput>;
  none?: InputMaybe<JobWhereInput>;
  some?: InputMaybe<JobWhereInput>;
};

export type JobOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
  vlb71Codes?: InputMaybe<OrderDirection>;
};

export type JobRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<JobWhereUniqueInput>>;
  create?: InputMaybe<Array<JobCreateInput>>;
};

export type JobRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<JobWhereUniqueInput>>;
  create?: InputMaybe<Array<JobCreateInput>>;
  disconnect?: InputMaybe<Array<JobWhereUniqueInput>>;
  set?: InputMaybe<Array<JobWhereUniqueInput>>;
};

export type JobUpdateArgs = {
  data: JobUpdateInput;
  where: JobWhereUniqueInput;
};

export type JobUpdateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  vlb71Codes?: InputMaybe<Scalars['String']['input']>;
};

export type JobWhereInput = {
  AND?: InputMaybe<Array<JobWhereInput>>;
  NOT?: InputMaybe<Array<JobWhereInput>>;
  OR?: InputMaybe<Array<JobWhereInput>>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
  vlb71Codes?: InputMaybe<StringFilter>;
};

export type JobWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type JpPublisher = {
  __typename?: 'JpPublisher';
  id: Scalars['ID']['output'];
  magazines?: Maybe<Array<Magazine>>;
  magazinesCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seriesInfos?: Maybe<Array<SeriesInfo>>;
  seriesInfosCount?: Maybe<Scalars['Int']['output']>;
};


export type JpPublisherMagazinesArgs = {
  cursor?: InputMaybe<MagazineWhereUniqueInput>;
  orderBy?: Array<MagazineOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MagazineWhereInput;
};


export type JpPublisherMagazinesCountArgs = {
  where?: MagazineWhereInput;
};


export type JpPublisherSeriesInfosArgs = {
  cursor?: InputMaybe<SeriesInfoWhereUniqueInput>;
  orderBy?: Array<SeriesInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SeriesInfoWhereInput;
};


export type JpPublisherSeriesInfosCountArgs = {
  where?: SeriesInfoWhereInput;
};

export type JpPublisherCreateInput = {
  magazines?: InputMaybe<MagazineRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForCreateInput>;
};

export type JpPublisherManyRelationFilter = {
  every?: InputMaybe<JpPublisherWhereInput>;
  none?: InputMaybe<JpPublisherWhereInput>;
  some?: InputMaybe<JpPublisherWhereInput>;
};

export type JpPublisherOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type JpPublisherRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<JpPublisherWhereUniqueInput>>;
  create?: InputMaybe<Array<JpPublisherCreateInput>>;
};

export type JpPublisherRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<JpPublisherWhereUniqueInput>>;
  create?: InputMaybe<Array<JpPublisherCreateInput>>;
  disconnect?: InputMaybe<Array<JpPublisherWhereUniqueInput>>;
  set?: InputMaybe<Array<JpPublisherWhereUniqueInput>>;
};

export type JpPublisherRelateToOneForCreateInput = {
  connect?: InputMaybe<JpPublisherWhereUniqueInput>;
  create?: InputMaybe<JpPublisherCreateInput>;
};

export type JpPublisherRelateToOneForUpdateInput = {
  connect?: InputMaybe<JpPublisherWhereUniqueInput>;
  create?: InputMaybe<JpPublisherCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JpPublisherUpdateArgs = {
  data: JpPublisherUpdateInput;
  where: JpPublisherWhereUniqueInput;
};

export type JpPublisherUpdateInput = {
  magazines?: InputMaybe<MagazineRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForUpdateInput>;
};

export type JpPublisherWhereInput = {
  AND?: InputMaybe<Array<JpPublisherWhereInput>>;
  NOT?: InputMaybe<Array<JpPublisherWhereInput>>;
  OR?: InputMaybe<Array<JpPublisherWhereInput>>;
  id?: InputMaybe<IdFilter>;
  magazines?: InputMaybe<MagazineManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  seriesInfos?: InputMaybe<SeriesInfoManyRelationFilter>;
};

export type JpPublisherWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String']['input'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String']['output'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  isFilterable: Scalars['Boolean']['output'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean']['output'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String']['output'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String']['output'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int']['output'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiGraphQl = {
  __typename?: 'KeystoneAdminUIGraphQL';
  names: KeystoneAdminUiGraphQlNames;
};

export type KeystoneAdminUiGraphQlNames = {
  __typename?: 'KeystoneAdminUIGraphQLNames';
  createInputName: Scalars['String']['output'];
  createManyMutationName: Scalars['String']['output'];
  createMutationName: Scalars['String']['output'];
  deleteManyMutationName: Scalars['String']['output'];
  deleteMutationName: Scalars['String']['output'];
  itemQueryName: Scalars['String']['output'];
  listOrderName: Scalars['String']['output'];
  listQueryCountName: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  outputTypeName: Scalars['String']['output'];
  relateToManyForCreateInputName: Scalars['String']['output'];
  relateToManyForUpdateInputName: Scalars['String']['output'];
  relateToOneForCreateInputName: Scalars['String']['output'];
  relateToOneForUpdateInputName: Scalars['String']['output'];
  updateInputName: Scalars['String']['output'];
  updateManyInputName: Scalars['String']['output'];
  updateManyMutationName: Scalars['String']['output'];
  updateMutationName: Scalars['String']['output'];
  whereInputName: Scalars['String']['output'];
  whereUniqueInputName: Scalars['String']['output'];
};

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  graphql: KeystoneAdminUiGraphQl;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean']['output'];
  hideDelete: Scalars['Boolean']['output'];
  initialColumns: Array<Scalars['String']['output']>;
  initialSearchFields: Array<Scalars['String']['output']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  itemQueryName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelField: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  pageSize: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String']['output'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type Magazine = {
  __typename?: 'Magazine';
  id: Scalars['ID']['output'];
  jpPublisher?: Maybe<JpPublisher>;
  name?: Maybe<Scalars['String']['output']>;
  seriesInfos?: Maybe<Array<SeriesInfo>>;
  seriesInfosCount?: Maybe<Scalars['Int']['output']>;
};


export type MagazineSeriesInfosArgs = {
  cursor?: InputMaybe<SeriesInfoWhereUniqueInput>;
  orderBy?: Array<SeriesInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SeriesInfoWhereInput;
};


export type MagazineSeriesInfosCountArgs = {
  where?: SeriesInfoWhereInput;
};

export type MagazineCreateInput = {
  jpPublisher?: InputMaybe<JpPublisherRelateToOneForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForCreateInput>;
};

export type MagazineManyRelationFilter = {
  every?: InputMaybe<MagazineWhereInput>;
  none?: InputMaybe<MagazineWhereInput>;
  some?: InputMaybe<MagazineWhereInput>;
};

export type MagazineOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type MagazineRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<MagazineWhereUniqueInput>>;
  create?: InputMaybe<Array<MagazineCreateInput>>;
};

export type MagazineRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<MagazineWhereUniqueInput>>;
  create?: InputMaybe<Array<MagazineCreateInput>>;
  disconnect?: InputMaybe<Array<MagazineWhereUniqueInput>>;
  set?: InputMaybe<Array<MagazineWhereUniqueInput>>;
};

export type MagazineUpdateArgs = {
  data: MagazineUpdateInput;
  where: MagazineWhereUniqueInput;
};

export type MagazineUpdateInput = {
  jpPublisher?: InputMaybe<JpPublisherRelateToOneForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForUpdateInput>;
};

export type MagazineWhereInput = {
  AND?: InputMaybe<Array<MagazineWhereInput>>;
  NOT?: InputMaybe<Array<MagazineWhereInput>>;
  OR?: InputMaybe<Array<MagazineWhereInput>>;
  id?: InputMaybe<IdFilter>;
  jpPublisher?: InputMaybe<JpPublisherWhereInput>;
  name?: InputMaybe<StringFilter>;
  seriesInfos?: InputMaybe<SeriesInfoManyRelationFilter>;
};

export type MagazineWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MaterialInfo = {
  __typename?: 'MaterialInfo';
  description?: Maybe<MaterialInfo_Description_Document>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MaterialInfoCreateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialInfoManyRelationFilter = {
  every?: InputMaybe<MaterialInfoWhereInput>;
  none?: InputMaybe<MaterialInfoWhereInput>;
  some?: InputMaybe<MaterialInfoWhereInput>;
};

export type MaterialInfoOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type MaterialInfoRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<MaterialInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<MaterialInfoCreateInput>>;
};

export type MaterialInfoRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<MaterialInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<MaterialInfoCreateInput>>;
  disconnect?: InputMaybe<Array<MaterialInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialInfoWhereUniqueInput>>;
};

export type MaterialInfoUpdateArgs = {
  data: MaterialInfoUpdateInput;
  where: MaterialInfoWhereUniqueInput;
};

export type MaterialInfoUpdateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialInfoWhereInput = {
  AND?: InputMaybe<Array<MaterialInfoWhereInput>>;
  NOT?: InputMaybe<Array<MaterialInfoWhereInput>>;
  OR?: InputMaybe<Array<MaterialInfoWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MaterialInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MaterialInfo_Description_Document = {
  __typename?: 'MaterialInfo_description_Document';
  document: Scalars['JSON']['output'];
};


export type MaterialInfo_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type MergeReleaseItemResult = {
  __typename?: 'MergeReleaseItemResult';
  affectedUsers: Scalars['Int']['output'];
  dstEntryId: Scalars['ID']['output'];
  duplicateActivitiesRemoved: Scalars['Int']['output'];
  itemStatusUpdated: Scalars['Int']['output'];
  possessionActivitiesMigrated: Scalars['Int']['output'];
  readActivitiesMigrated: Scalars['Int']['output'];
  readStatusUpdated: Scalars['Int']['output'];
  sourceEntryDeleted: Scalars['Boolean']['output'];
  sourceItemDeleted: Scalars['Boolean']['output'];
  sourceKey: Scalars['String']['output'];
  sourceReleaseItemId: Scalars['ID']['output'];
  srcEntryId: Scalars['ID']['output'];
  statusesCreated: Scalars['Int']['output'];
  targetKey: Scalars['String']['output'];
  targetReleaseItemId: Scalars['ID']['output'];
  usersSkipped: Scalars['Int']['output'];
};

export type MigrateCopiedReleaseResult = {
  __typename?: 'MigrateCopiedReleaseResult';
  affectedUsers: Scalars['Int']['output'];
  miscAdded: Scalars['Int']['output'];
  readMigrated: Scalars['Int']['output'];
  sourceEntryId: Scalars['ID']['output'];
  statusesCreated: Scalars['Int']['output'];
  usersSkipped: Scalars['Int']['output'];
};

export type MigrateTargetInput = {
  collectionId: Scalars['ID']['input'];
  releaseEntryId: Scalars['ID']['input'];
};

export type MissingHandleBackfillReport = {
  __typename?: 'MissingHandleBackfillReport';
  assigned: Scalars['Int']['output'];
  unassignable: Scalars['Int']['output'];
};

export type MissingIsbn = {
  __typename?: 'MissingIsbn';
  catalogMatchEntry?: Maybe<ReleaseEntry>;
  catalogMatchItemId?: Maybe<Scalars['String']['output']>;
  catalogMatchItemType?: Maybe<Scalars['String']['output']>;
  catalogMatchedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  informedAt?: Maybe<Scalars['DateTime']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userExplanation?: Maybe<Scalars['String']['output']>;
};

export type MissingIsbnCatalogMatchResult = {
  __typename?: 'MissingIsbnCatalogMatchResult';
  isbn: Scalars['String']['output'];
  itemId: Scalars['ID']['output'];
  itemType: Scalars['String']['output'];
  releaseEntryId: Scalars['ID']['output'];
  reportCount: Scalars['Int']['output'];
  reporterCount: Scalars['Int']['output'];
};

export type MissingIsbnCreateInput = {
  catalogMatchEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  catalogMatchItemId?: InputMaybe<Scalars['String']['input']>;
  catalogMatchItemType?: InputMaybe<Scalars['String']['input']>;
  catalogMatchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  informedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  userExplanation?: InputMaybe<Scalars['String']['input']>;
};

export type MissingIsbnManyRelationFilter = {
  every?: InputMaybe<MissingIsbnWhereInput>;
  none?: InputMaybe<MissingIsbnWhereInput>;
  some?: InputMaybe<MissingIsbnWhereInput>;
};

export type MissingIsbnOrderByInput = {
  catalogMatchItemId?: InputMaybe<OrderDirection>;
  catalogMatchItemType?: InputMaybe<OrderDirection>;
  catalogMatchedAt?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  informedAt?: InputMaybe<OrderDirection>;
  isbn?: InputMaybe<OrderDirection>;
  userExplanation?: InputMaybe<OrderDirection>;
};

export type MissingIsbnRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<MissingIsbnWhereUniqueInput>>;
  create?: InputMaybe<Array<MissingIsbnCreateInput>>;
};

export type MissingIsbnRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<MissingIsbnWhereUniqueInput>>;
  create?: InputMaybe<Array<MissingIsbnCreateInput>>;
  disconnect?: InputMaybe<Array<MissingIsbnWhereUniqueInput>>;
  set?: InputMaybe<Array<MissingIsbnWhereUniqueInput>>;
};

export type MissingIsbnUpdateArgs = {
  data: MissingIsbnUpdateInput;
  where: MissingIsbnWhereUniqueInput;
};

export type MissingIsbnUpdateInput = {
  catalogMatchEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  catalogMatchItemId?: InputMaybe<Scalars['String']['input']>;
  catalogMatchItemType?: InputMaybe<Scalars['String']['input']>;
  catalogMatchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  informedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  userExplanation?: InputMaybe<Scalars['String']['input']>;
};

export type MissingIsbnWhereInput = {
  AND?: InputMaybe<Array<MissingIsbnWhereInput>>;
  NOT?: InputMaybe<Array<MissingIsbnWhereInput>>;
  OR?: InputMaybe<Array<MissingIsbnWhereInput>>;
  catalogMatchEntry?: InputMaybe<ReleaseEntryWhereInput>;
  catalogMatchItemId?: InputMaybe<StringFilter>;
  catalogMatchItemType?: InputMaybe<StringNullableFilter>;
  catalogMatchedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  informedAt?: InputMaybe<DateTimeNullableFilter>;
  isbn?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
  userExplanation?: InputMaybe<StringFilter>;
};

export type MissingIsbnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveReleaseItemResult = {
  __typename?: 'MoveReleaseItemResult';
  affectedUsers: Scalars['Int']['output'];
  dstEntryId: Scalars['ID']['output'];
  itemStatusUpdated: Scalars['Int']['output'];
  newKey: Scalars['String']['output'];
  oldKey: Scalars['String']['output'];
  possessionActivitiesMigrated: Scalars['Int']['output'];
  readActivitiesMigrated: Scalars['Int']['output'];
  readStatusUpdated: Scalars['Int']['output'];
  releaseItemId: Scalars['ID']['output'];
  sourceStatusesDeleted: Scalars['Int']['output'];
  srcEntryId: Scalars['ID']['output'];
  statusesCreated: Scalars['Int']['output'];
  usersSkipped: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignMissingUserHandles: MissingHandleBackfillReport;
  claimUserHandle: UserHandleClaimResult;
  compactActivityMistakes: ActivityMistakeCompaction;
  createContentReport?: Maybe<ContentReport>;
  createContentReports?: Maybe<Array<Maybe<ContentReport>>>;
  createCountries?: Maybe<Array<Maybe<Country>>>;
  createCountry?: Maybe<Country>;
  createDatabaseListConfig?: Maybe<DatabaseListConfig>;
  createDatabaseListConfigs?: Maybe<Array<Maybe<DatabaseListConfig>>>;
  createDatabaseListReleaseEntries?: Maybe<Array<Maybe<DatabaseListReleaseEntry>>>;
  createDatabaseListReleaseEntry?: Maybe<DatabaseListReleaseEntry>;
  createDemographies?: Maybe<Array<Maybe<Demography>>>;
  createDemography?: Maybe<Demography>;
  createExtra?: Maybe<Extra>;
  createExtras?: Maybe<Array<Maybe<Extra>>>;
  createFeedback?: Maybe<Feedback>;
  createFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  createIndividual?: Maybe<Individual>;
  createIndividuals?: Maybe<Array<Maybe<Individual>>>;
  createJob?: Maybe<Job>;
  createJobs?: Maybe<Array<Maybe<Job>>>;
  createJpPublisher?: Maybe<JpPublisher>;
  createJpPublishers?: Maybe<Array<Maybe<JpPublisher>>>;
  createMagazine?: Maybe<Magazine>;
  createMagazines?: Maybe<Array<Maybe<Magazine>>>;
  createMaterialInfo?: Maybe<MaterialInfo>;
  createMaterialInfos?: Maybe<Array<Maybe<MaterialInfo>>>;
  createMissingIsbn?: Maybe<MissingIsbn>;
  createMissingIsbns?: Maybe<Array<Maybe<MissingIsbn>>>;
  createNotification?: Maybe<Notification>;
  createNotifications?: Maybe<Array<Maybe<Notification>>>;
  createNovelties?: Maybe<Array<Maybe<Novelty>>>;
  createNovelty?: Maybe<Novelty>;
  createPublisher?: Maybe<Publisher>;
  createPublishers?: Maybe<Array<Maybe<Publisher>>>;
  createReleaseEntries?: Maybe<Array<Maybe<ReleaseEntry>>>;
  createReleaseEntry?: Maybe<ReleaseEntry>;
  createReleaseItem?: Maybe<ReleaseItem>;
  createReleaseItemCollection?: Maybe<ReleaseItemCollection>;
  createReleaseItemCollections?: Maybe<Array<Maybe<ReleaseItemCollection>>>;
  createReleaseItems?: Maybe<Array<Maybe<ReleaseItem>>>;
  createSeriesInfo?: Maybe<SeriesInfo>;
  createSeriesInfos?: Maybe<Array<Maybe<SeriesInfo>>>;
  createSharedReleaseCollection?: Maybe<SharedReleaseCollection>;
  createSharedReleaseCollections?: Maybe<Array<Maybe<SharedReleaseCollection>>>;
  createSizeInfo?: Maybe<SizeInfo>;
  createSizeInfos?: Maybe<Array<Maybe<SizeInfo>>>;
  createSourceLink?: Maybe<SourceLink>;
  createSourceLinks?: Maybe<Array<Maybe<SourceLink>>>;
  createSourceSnapshot?: Maybe<SourceSnapshot>;
  createSourceSnapshots?: Maybe<Array<Maybe<SourceSnapshot>>>;
  createSourceUpdate?: Maybe<SourceUpdate>;
  createSourceUpdates?: Maybe<Array<Maybe<SourceUpdate>>>;
  createStaffEntries?: Maybe<Array<Maybe<StaffEntry>>>;
  createStaffEntry?: Maybe<StaffEntry>;
  createTag?: Maybe<Tag>;
  createTags?: Maybe<Array<Maybe<Tag>>>;
  createUser?: Maybe<User>;
  createUserActiveDay?: Maybe<UserActiveDay>;
  createUserActiveDays?: Maybe<Array<Maybe<UserActiveDay>>>;
  createUserAdmin?: Maybe<UserAdmin>;
  createUserAdmins?: Maybe<Array<Maybe<UserAdmin>>>;
  createUserCollectionStats?: Maybe<UserCollectionStats>;
  createUserCollectionStatsItems?: Maybe<Array<Maybe<UserCollectionStats>>>;
  createUserCustomList?: Maybe<UserCustomList>;
  createUserCustomListNoveltyItem?: Maybe<UserCustomListNoveltyItem>;
  createUserCustomListNoveltyItems?: Maybe<Array<Maybe<UserCustomListNoveltyItem>>>;
  createUserCustomListReleaseEntryItem?: Maybe<UserCustomListReleaseEntryItem>;
  createUserCustomListReleaseEntryItems?: Maybe<Array<Maybe<UserCustomListReleaseEntryItem>>>;
  createUserCustomLists?: Maybe<Array<Maybe<UserCustomList>>>;
  createUserImage?: Maybe<UserImage>;
  createUserImages?: Maybe<Array<Maybe<UserImage>>>;
  createUserMiscPossessionActivities?: Maybe<Array<Maybe<UserMiscPossessionActivity>>>;
  createUserMiscPossessionActivity?: Maybe<UserMiscPossessionActivity>;
  createUserPossessionActivities?: Maybe<Array<Maybe<UserPossessionActivity>>>;
  createUserPossessionActivity?: Maybe<UserPossessionActivity>;
  createUserPremiumChange?: Maybe<UserPremiumChange>;
  createUserPremiumChanges?: Maybe<Array<Maybe<UserPremiumChange>>>;
  createUserReadActivities?: Maybe<Array<Maybe<UserReadActivity>>>;
  createUserReadActivity?: Maybe<UserReadActivity>;
  createUserReleaseActivities?: Maybe<Array<Maybe<UserReleaseActivity>>>;
  createUserReleaseActivity?: Maybe<UserReleaseActivity>;
  createUserReleaseEntryStatus?: Maybe<UserReleaseEntryStatus>;
  createUserReleaseEntryStatuses?: Maybe<Array<Maybe<UserReleaseEntryStatus>>>;
  createUserReleaseReadStatus?: Maybe<UserReleaseReadStatus>;
  createUserReleaseReadStatuses?: Maybe<Array<Maybe<UserReleaseReadStatus>>>;
  createUserStatsDailyFact?: Maybe<UserStatsDailyFact>;
  createUserStatsDailyFacts?: Maybe<Array<Maybe<UserStatsDailyFact>>>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  createVlbUpdateConfig?: Maybe<VlbUpdateConfig>;
  createVlbUpdateConfigs?: Maybe<Array<Maybe<VlbUpdateConfig>>>;
  createVolumeSuffix?: Maybe<VolumeSuffix>;
  createVolumeSuffixes?: Maybe<Array<Maybe<VolumeSuffix>>>;
  deleteContentReport?: Maybe<ContentReport>;
  deleteContentReports?: Maybe<Array<Maybe<ContentReport>>>;
  deleteCountries?: Maybe<Array<Maybe<Country>>>;
  deleteCountry?: Maybe<Country>;
  deleteDatabaseListConfig?: Maybe<DatabaseListConfig>;
  deleteDatabaseListConfigs?: Maybe<Array<Maybe<DatabaseListConfig>>>;
  deleteDatabaseListReleaseEntries?: Maybe<Array<Maybe<DatabaseListReleaseEntry>>>;
  deleteDatabaseListReleaseEntry?: Maybe<DatabaseListReleaseEntry>;
  deleteDemographies?: Maybe<Array<Maybe<Demography>>>;
  deleteDemography?: Maybe<Demography>;
  deleteExtra?: Maybe<Extra>;
  deleteExtras?: Maybe<Array<Maybe<Extra>>>;
  deleteFeedback?: Maybe<Feedback>;
  deleteFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  deleteIndividual?: Maybe<Individual>;
  deleteIndividuals?: Maybe<Array<Maybe<Individual>>>;
  deleteJob?: Maybe<Job>;
  deleteJobs?: Maybe<Array<Maybe<Job>>>;
  deleteJpPublisher?: Maybe<JpPublisher>;
  deleteJpPublishers?: Maybe<Array<Maybe<JpPublisher>>>;
  deleteMagazine?: Maybe<Magazine>;
  deleteMagazines?: Maybe<Array<Maybe<Magazine>>>;
  deleteMaterialInfo?: Maybe<MaterialInfo>;
  deleteMaterialInfos?: Maybe<Array<Maybe<MaterialInfo>>>;
  deleteMissingIsbn?: Maybe<MissingIsbn>;
  deleteMissingIsbns?: Maybe<Array<Maybe<MissingIsbn>>>;
  deleteNotification?: Maybe<Notification>;
  deleteNotifications?: Maybe<Array<Maybe<Notification>>>;
  deleteNovelties?: Maybe<Array<Maybe<Novelty>>>;
  deleteNovelty?: Maybe<Novelty>;
  deletePublisher?: Maybe<Publisher>;
  deletePublishers?: Maybe<Array<Maybe<Publisher>>>;
  deleteReleaseEntries?: Maybe<Array<Maybe<ReleaseEntry>>>;
  deleteReleaseEntry?: Maybe<ReleaseEntry>;
  deleteReleaseItem?: Maybe<ReleaseItem>;
  deleteReleaseItemCollection?: Maybe<ReleaseItemCollection>;
  deleteReleaseItemCollections?: Maybe<Array<Maybe<ReleaseItemCollection>>>;
  deleteReleaseItems?: Maybe<Array<Maybe<ReleaseItem>>>;
  deleteSeriesInfo?: Maybe<SeriesInfo>;
  deleteSeriesInfos?: Maybe<Array<Maybe<SeriesInfo>>>;
  deleteSharedReleaseCollection?: Maybe<SharedReleaseCollection>;
  deleteSharedReleaseCollections?: Maybe<Array<Maybe<SharedReleaseCollection>>>;
  deleteSizeInfo?: Maybe<SizeInfo>;
  deleteSizeInfos?: Maybe<Array<Maybe<SizeInfo>>>;
  deleteSourceLink?: Maybe<SourceLink>;
  deleteSourceLinks?: Maybe<Array<Maybe<SourceLink>>>;
  deleteSourceSnapshot?: Maybe<SourceSnapshot>;
  deleteSourceSnapshots?: Maybe<Array<Maybe<SourceSnapshot>>>;
  deleteSourceUpdate?: Maybe<SourceUpdate>;
  deleteSourceUpdates?: Maybe<Array<Maybe<SourceUpdate>>>;
  deleteStaffEntries?: Maybe<Array<Maybe<StaffEntry>>>;
  deleteStaffEntry?: Maybe<StaffEntry>;
  deleteTag?: Maybe<Tag>;
  deleteTags?: Maybe<Array<Maybe<Tag>>>;
  deleteUser?: Maybe<User>;
  deleteUserActiveDay?: Maybe<UserActiveDay>;
  deleteUserActiveDays?: Maybe<Array<Maybe<UserActiveDay>>>;
  deleteUserAdmin?: Maybe<UserAdmin>;
  deleteUserAdmins?: Maybe<Array<Maybe<UserAdmin>>>;
  deleteUserCollectionStats?: Maybe<UserCollectionStats>;
  deleteUserCollectionStatsItems?: Maybe<Array<Maybe<UserCollectionStats>>>;
  deleteUserCustomList?: Maybe<UserCustomList>;
  deleteUserCustomListNoveltyItem?: Maybe<UserCustomListNoveltyItem>;
  deleteUserCustomListNoveltyItems?: Maybe<Array<Maybe<UserCustomListNoveltyItem>>>;
  deleteUserCustomListReleaseEntryItem?: Maybe<UserCustomListReleaseEntryItem>;
  deleteUserCustomListReleaseEntryItems?: Maybe<Array<Maybe<UserCustomListReleaseEntryItem>>>;
  deleteUserCustomListWithItems?: Maybe<UserCustomList>;
  deleteUserCustomLists?: Maybe<Array<Maybe<UserCustomList>>>;
  deleteUserImage?: Maybe<UserImage>;
  deleteUserImages?: Maybe<Array<Maybe<UserImage>>>;
  deleteUserMiscPossessionActivities?: Maybe<Array<Maybe<UserMiscPossessionActivity>>>;
  deleteUserMiscPossessionActivity?: Maybe<UserMiscPossessionActivity>;
  deleteUserPossessionActivities?: Maybe<Array<Maybe<UserPossessionActivity>>>;
  deleteUserPossessionActivity?: Maybe<UserPossessionActivity>;
  deleteUserPremiumChange?: Maybe<UserPremiumChange>;
  deleteUserPremiumChanges?: Maybe<Array<Maybe<UserPremiumChange>>>;
  deleteUserReadActivities?: Maybe<Array<Maybe<UserReadActivity>>>;
  deleteUserReadActivity?: Maybe<UserReadActivity>;
  deleteUserReleaseActivities?: Maybe<Array<Maybe<UserReleaseActivity>>>;
  deleteUserReleaseActivity?: Maybe<UserReleaseActivity>;
  deleteUserReleaseEntryStatus?: Maybe<UserReleaseEntryStatus>;
  deleteUserReleaseEntryStatusWithEvent?: Maybe<UserReleaseEntryStatus>;
  deleteUserReleaseEntryStatuses?: Maybe<Array<Maybe<UserReleaseEntryStatus>>>;
  deleteUserReleaseReadStatus?: Maybe<UserReleaseReadStatus>;
  deleteUserReleaseReadStatuses?: Maybe<Array<Maybe<UserReleaseReadStatus>>>;
  deleteUserStatsDailyFact?: Maybe<UserStatsDailyFact>;
  deleteUserStatsDailyFacts?: Maybe<Array<Maybe<UserStatsDailyFact>>>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  deleteVlbUpdateConfig?: Maybe<VlbUpdateConfig>;
  deleteVlbUpdateConfigs?: Maybe<Array<Maybe<VlbUpdateConfig>>>;
  deleteVolumeSuffix?: Maybe<VolumeSuffix>;
  deleteVolumeSuffixes?: Maybe<Array<Maybe<VolumeSuffix>>>;
  endSession: Scalars['Boolean']['output'];
  informMissingIsbnReporters: MissingIsbnCatalogMatchResult;
  mergeReleaseItem?: Maybe<MergeReleaseItemResult>;
  migrateConvertedItemsToCollections?: Maybe<ConvertItemsToCollectionsResult>;
  migrateCopiedRelease?: Maybe<MigrateCopiedReleaseResult>;
  moveReleaseItem?: Maybe<MoveReleaseItemResult>;
  purgeReportedUserImageAfterEscalation: Scalars['String']['output'];
  queueCustomNotification: Scalars['String']['output'];
  recordMissingIsbnCatalogMatches: Array<MissingIsbnCatalogMatchResult>;
  recordUserActivity: Scalars['String']['output'];
  removeUserImageFromProfile: Scalars['String']['output'];
  restoreUserImageDismissedAsNotCredible: Scalars['String']['output'];
  sendCustomNotificationTest: Array<SendTestNotificationResult>;
  sendTestNotification: Array<SendTestNotificationResult>;
  submitContentReport: ContentReportReceipt;
  takeReportedUserImageDown: Scalars['String']['output'];
  updateContentReport?: Maybe<ContentReport>;
  updateContentReports?: Maybe<Array<Maybe<ContentReport>>>;
  updateCountries?: Maybe<Array<Maybe<Country>>>;
  updateCountry?: Maybe<Country>;
  updateDatabaseListConfig?: Maybe<DatabaseListConfig>;
  updateDatabaseListConfigs?: Maybe<Array<Maybe<DatabaseListConfig>>>;
  updateDatabaseListReleaseEntries?: Maybe<Array<Maybe<DatabaseListReleaseEntry>>>;
  updateDatabaseListReleaseEntry?: Maybe<DatabaseListReleaseEntry>;
  updateDemographies?: Maybe<Array<Maybe<Demography>>>;
  updateDemography?: Maybe<Demography>;
  updateExtra?: Maybe<Extra>;
  updateExtras?: Maybe<Array<Maybe<Extra>>>;
  updateFeedback?: Maybe<Feedback>;
  updateFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  updateIndividual?: Maybe<Individual>;
  updateIndividuals?: Maybe<Array<Maybe<Individual>>>;
  updateJob?: Maybe<Job>;
  updateJobs?: Maybe<Array<Maybe<Job>>>;
  updateJpPublisher?: Maybe<JpPublisher>;
  updateJpPublishers?: Maybe<Array<Maybe<JpPublisher>>>;
  updateMagazine?: Maybe<Magazine>;
  updateMagazines?: Maybe<Array<Maybe<Magazine>>>;
  updateMaterialInfo?: Maybe<MaterialInfo>;
  updateMaterialInfos?: Maybe<Array<Maybe<MaterialInfo>>>;
  updateMissingIsbn?: Maybe<MissingIsbn>;
  updateMissingIsbns?: Maybe<Array<Maybe<MissingIsbn>>>;
  updateNotification?: Maybe<Notification>;
  updateNotifications?: Maybe<Array<Maybe<Notification>>>;
  updateNovelties?: Maybe<Array<Maybe<Novelty>>>;
  updateNovelty?: Maybe<Novelty>;
  updatePublisher?: Maybe<Publisher>;
  updatePublishers?: Maybe<Array<Maybe<Publisher>>>;
  updateReleaseEntries?: Maybe<Array<Maybe<ReleaseEntry>>>;
  updateReleaseEntry?: Maybe<ReleaseEntry>;
  updateReleaseItem?: Maybe<ReleaseItem>;
  updateReleaseItemCollection?: Maybe<ReleaseItemCollection>;
  updateReleaseItemCollections?: Maybe<Array<Maybe<ReleaseItemCollection>>>;
  updateReleaseItems?: Maybe<Array<Maybe<ReleaseItem>>>;
  updateSeriesInfo?: Maybe<SeriesInfo>;
  updateSeriesInfos?: Maybe<Array<Maybe<SeriesInfo>>>;
  updateSharedReleaseCollection?: Maybe<SharedReleaseCollection>;
  updateSharedReleaseCollections?: Maybe<Array<Maybe<SharedReleaseCollection>>>;
  updateSizeInfo?: Maybe<SizeInfo>;
  updateSizeInfos?: Maybe<Array<Maybe<SizeInfo>>>;
  updateSourceLink?: Maybe<SourceLink>;
  updateSourceLinks?: Maybe<Array<Maybe<SourceLink>>>;
  updateSourceSnapshot?: Maybe<SourceSnapshot>;
  updateSourceSnapshots?: Maybe<Array<Maybe<SourceSnapshot>>>;
  updateSourceUpdate?: Maybe<SourceUpdate>;
  updateSourceUpdates?: Maybe<Array<Maybe<SourceUpdate>>>;
  updateStaffEntries?: Maybe<Array<Maybe<StaffEntry>>>;
  updateStaffEntry?: Maybe<StaffEntry>;
  updateTag?: Maybe<Tag>;
  updateTags?: Maybe<Array<Maybe<Tag>>>;
  updateUser?: Maybe<User>;
  updateUserActiveDay?: Maybe<UserActiveDay>;
  updateUserActiveDays?: Maybe<Array<Maybe<UserActiveDay>>>;
  updateUserAdmin?: Maybe<UserAdmin>;
  updateUserAdmins?: Maybe<Array<Maybe<UserAdmin>>>;
  updateUserCollectionStats?: Maybe<UserCollectionStats>;
  updateUserCollectionStatsItems?: Maybe<Array<Maybe<UserCollectionStats>>>;
  updateUserCustomList?: Maybe<UserCustomList>;
  updateUserCustomListNoveltyItem?: Maybe<UserCustomListNoveltyItem>;
  updateUserCustomListNoveltyItems?: Maybe<Array<Maybe<UserCustomListNoveltyItem>>>;
  updateUserCustomListReleaseEntryItem?: Maybe<UserCustomListReleaseEntryItem>;
  updateUserCustomListReleaseEntryItems?: Maybe<Array<Maybe<UserCustomListReleaseEntryItem>>>;
  updateUserCustomLists?: Maybe<Array<Maybe<UserCustomList>>>;
  updateUserImage?: Maybe<UserImage>;
  updateUserImages?: Maybe<Array<Maybe<UserImage>>>;
  updateUserMiscPossessionActivities?: Maybe<Array<Maybe<UserMiscPossessionActivity>>>;
  updateUserMiscPossessionActivity?: Maybe<UserMiscPossessionActivity>;
  updateUserPossessionActivities?: Maybe<Array<Maybe<UserPossessionActivity>>>;
  updateUserPossessionActivity?: Maybe<UserPossessionActivity>;
  updateUserPremiumChange?: Maybe<UserPremiumChange>;
  updateUserPremiumChanges?: Maybe<Array<Maybe<UserPremiumChange>>>;
  updateUserReadActivities?: Maybe<Array<Maybe<UserReadActivity>>>;
  updateUserReadActivity?: Maybe<UserReadActivity>;
  updateUserReleaseActivities?: Maybe<Array<Maybe<UserReleaseActivity>>>;
  updateUserReleaseActivity?: Maybe<UserReleaseActivity>;
  updateUserReleaseEntryStatus?: Maybe<UserReleaseEntryStatus>;
  updateUserReleaseEntryStatuses?: Maybe<Array<Maybe<UserReleaseEntryStatus>>>;
  updateUserReleaseReadStatus?: Maybe<UserReleaseReadStatus>;
  updateUserReleaseReadStatuses?: Maybe<Array<Maybe<UserReleaseReadStatus>>>;
  updateUserStatsDailyFact?: Maybe<UserStatsDailyFact>;
  updateUserStatsDailyFacts?: Maybe<Array<Maybe<UserStatsDailyFact>>>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  updateVlbUpdateConfig?: Maybe<VlbUpdateConfig>;
  updateVlbUpdateConfigs?: Maybe<Array<Maybe<VlbUpdateConfig>>>;
  updateVolumeSuffix?: Maybe<VolumeSuffix>;
  updateVolumeSuffixes?: Maybe<Array<Maybe<VolumeSuffix>>>;
};


export type MutationAssignMissingUserHandlesArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClaimUserHandleArgs = {
  handle: Scalars['String']['input'];
};


export type MutationCompactActivityMistakesArgs = {
  dryRun?: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateContentReportArgs = {
  data: ContentReportCreateInput;
};


export type MutationCreateContentReportsArgs = {
  data: Array<ContentReportCreateInput>;
};


export type MutationCreateCountriesArgs = {
  data: Array<CountryCreateInput>;
};


export type MutationCreateCountryArgs = {
  data: CountryCreateInput;
};


export type MutationCreateDatabaseListConfigArgs = {
  data: DatabaseListConfigCreateInput;
};


export type MutationCreateDatabaseListConfigsArgs = {
  data: Array<DatabaseListConfigCreateInput>;
};


export type MutationCreateDatabaseListReleaseEntriesArgs = {
  data: Array<DatabaseListReleaseEntryCreateInput>;
};


export type MutationCreateDatabaseListReleaseEntryArgs = {
  data: DatabaseListReleaseEntryCreateInput;
};


export type MutationCreateDemographiesArgs = {
  data: Array<DemographyCreateInput>;
};


export type MutationCreateDemographyArgs = {
  data: DemographyCreateInput;
};


export type MutationCreateExtraArgs = {
  data: ExtraCreateInput;
};


export type MutationCreateExtrasArgs = {
  data: Array<ExtraCreateInput>;
};


export type MutationCreateFeedbackArgs = {
  data: FeedbackCreateInput;
};


export type MutationCreateFeedbacksArgs = {
  data: Array<FeedbackCreateInput>;
};


export type MutationCreateIndividualArgs = {
  data: IndividualCreateInput;
};


export type MutationCreateIndividualsArgs = {
  data: Array<IndividualCreateInput>;
};


export type MutationCreateJobArgs = {
  data: JobCreateInput;
};


export type MutationCreateJobsArgs = {
  data: Array<JobCreateInput>;
};


export type MutationCreateJpPublisherArgs = {
  data: JpPublisherCreateInput;
};


export type MutationCreateJpPublishersArgs = {
  data: Array<JpPublisherCreateInput>;
};


export type MutationCreateMagazineArgs = {
  data: MagazineCreateInput;
};


export type MutationCreateMagazinesArgs = {
  data: Array<MagazineCreateInput>;
};


export type MutationCreateMaterialInfoArgs = {
  data: MaterialInfoCreateInput;
};


export type MutationCreateMaterialInfosArgs = {
  data: Array<MaterialInfoCreateInput>;
};


export type MutationCreateMissingIsbnArgs = {
  data: MissingIsbnCreateInput;
};


export type MutationCreateMissingIsbnsArgs = {
  data: Array<MissingIsbnCreateInput>;
};


export type MutationCreateNotificationArgs = {
  data: NotificationCreateInput;
};


export type MutationCreateNotificationsArgs = {
  data: Array<NotificationCreateInput>;
};


export type MutationCreateNoveltiesArgs = {
  data: Array<NoveltyCreateInput>;
};


export type MutationCreateNoveltyArgs = {
  data: NoveltyCreateInput;
};


export type MutationCreatePublisherArgs = {
  data: PublisherCreateInput;
};


export type MutationCreatePublishersArgs = {
  data: Array<PublisherCreateInput>;
};


export type MutationCreateReleaseEntriesArgs = {
  data: Array<ReleaseEntryCreateInput>;
};


export type MutationCreateReleaseEntryArgs = {
  data: ReleaseEntryCreateInput;
};


export type MutationCreateReleaseItemArgs = {
  data: ReleaseItemCreateInput;
};


export type MutationCreateReleaseItemCollectionArgs = {
  data: ReleaseItemCollectionCreateInput;
};


export type MutationCreateReleaseItemCollectionsArgs = {
  data: Array<ReleaseItemCollectionCreateInput>;
};


export type MutationCreateReleaseItemsArgs = {
  data: Array<ReleaseItemCreateInput>;
};


export type MutationCreateSeriesInfoArgs = {
  data: SeriesInfoCreateInput;
};


export type MutationCreateSeriesInfosArgs = {
  data: Array<SeriesInfoCreateInput>;
};


export type MutationCreateSharedReleaseCollectionArgs = {
  data: SharedReleaseCollectionCreateInput;
};


export type MutationCreateSharedReleaseCollectionsArgs = {
  data: Array<SharedReleaseCollectionCreateInput>;
};


export type MutationCreateSizeInfoArgs = {
  data: SizeInfoCreateInput;
};


export type MutationCreateSizeInfosArgs = {
  data: Array<SizeInfoCreateInput>;
};


export type MutationCreateSourceLinkArgs = {
  data: SourceLinkCreateInput;
};


export type MutationCreateSourceLinksArgs = {
  data: Array<SourceLinkCreateInput>;
};


export type MutationCreateSourceSnapshotArgs = {
  data: SourceSnapshotCreateInput;
};


export type MutationCreateSourceSnapshotsArgs = {
  data: Array<SourceSnapshotCreateInput>;
};


export type MutationCreateSourceUpdateArgs = {
  data: SourceUpdateCreateInput;
};


export type MutationCreateSourceUpdatesArgs = {
  data: Array<SourceUpdateCreateInput>;
};


export type MutationCreateStaffEntriesArgs = {
  data: Array<StaffEntryCreateInput>;
};


export type MutationCreateStaffEntryArgs = {
  data: StaffEntryCreateInput;
};


export type MutationCreateTagArgs = {
  data: TagCreateInput;
};


export type MutationCreateTagsArgs = {
  data: Array<TagCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUserActiveDayArgs = {
  data: UserActiveDayCreateInput;
};


export type MutationCreateUserActiveDaysArgs = {
  data: Array<UserActiveDayCreateInput>;
};


export type MutationCreateUserAdminArgs = {
  data: UserAdminCreateInput;
};


export type MutationCreateUserAdminsArgs = {
  data: Array<UserAdminCreateInput>;
};


export type MutationCreateUserCollectionStatsArgs = {
  data: UserCollectionStatsCreateInput;
};


export type MutationCreateUserCollectionStatsItemsArgs = {
  data: Array<UserCollectionStatsCreateInput>;
};


export type MutationCreateUserCustomListArgs = {
  data: UserCustomListCreateInput;
};


export type MutationCreateUserCustomListNoveltyItemArgs = {
  data: UserCustomListNoveltyItemCreateInput;
};


export type MutationCreateUserCustomListNoveltyItemsArgs = {
  data: Array<UserCustomListNoveltyItemCreateInput>;
};


export type MutationCreateUserCustomListReleaseEntryItemArgs = {
  data: UserCustomListReleaseEntryItemCreateInput;
};


export type MutationCreateUserCustomListReleaseEntryItemsArgs = {
  data: Array<UserCustomListReleaseEntryItemCreateInput>;
};


export type MutationCreateUserCustomListsArgs = {
  data: Array<UserCustomListCreateInput>;
};


export type MutationCreateUserImageArgs = {
  data: UserImageCreateInput;
};


export type MutationCreateUserImagesArgs = {
  data: Array<UserImageCreateInput>;
};


export type MutationCreateUserMiscPossessionActivitiesArgs = {
  data: Array<UserMiscPossessionActivityCreateInput>;
};


export type MutationCreateUserMiscPossessionActivityArgs = {
  data: UserMiscPossessionActivityCreateInput;
};


export type MutationCreateUserPossessionActivitiesArgs = {
  data: Array<UserPossessionActivityCreateInput>;
};


export type MutationCreateUserPossessionActivityArgs = {
  data: UserPossessionActivityCreateInput;
};


export type MutationCreateUserPremiumChangeArgs = {
  data: UserPremiumChangeCreateInput;
};


export type MutationCreateUserPremiumChangesArgs = {
  data: Array<UserPremiumChangeCreateInput>;
};


export type MutationCreateUserReadActivitiesArgs = {
  data: Array<UserReadActivityCreateInput>;
};


export type MutationCreateUserReadActivityArgs = {
  data: UserReadActivityCreateInput;
};


export type MutationCreateUserReleaseActivitiesArgs = {
  data: Array<UserReleaseActivityCreateInput>;
};


export type MutationCreateUserReleaseActivityArgs = {
  data: UserReleaseActivityCreateInput;
};


export type MutationCreateUserReleaseEntryStatusArgs = {
  data: UserReleaseEntryStatusCreateInput;
};


export type MutationCreateUserReleaseEntryStatusesArgs = {
  data: Array<UserReleaseEntryStatusCreateInput>;
};


export type MutationCreateUserReleaseReadStatusArgs = {
  data: UserReleaseReadStatusCreateInput;
};


export type MutationCreateUserReleaseReadStatusesArgs = {
  data: Array<UserReleaseReadStatusCreateInput>;
};


export type MutationCreateUserStatsDailyFactArgs = {
  data: UserStatsDailyFactCreateInput;
};


export type MutationCreateUserStatsDailyFactsArgs = {
  data: Array<UserStatsDailyFactCreateInput>;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationCreateVlbUpdateConfigArgs = {
  data: VlbUpdateConfigCreateInput;
};


export type MutationCreateVlbUpdateConfigsArgs = {
  data: Array<VlbUpdateConfigCreateInput>;
};


export type MutationCreateVolumeSuffixArgs = {
  data: VolumeSuffixCreateInput;
};


export type MutationCreateVolumeSuffixesArgs = {
  data: Array<VolumeSuffixCreateInput>;
};


export type MutationDeleteContentReportArgs = {
  where: ContentReportWhereUniqueInput;
};


export type MutationDeleteContentReportsArgs = {
  where: Array<ContentReportWhereUniqueInput>;
};


export type MutationDeleteCountriesArgs = {
  where: Array<CountryWhereUniqueInput>;
};


export type MutationDeleteCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type MutationDeleteDatabaseListConfigArgs = {
  where: DatabaseListConfigWhereUniqueInput;
};


export type MutationDeleteDatabaseListConfigsArgs = {
  where: Array<DatabaseListConfigWhereUniqueInput>;
};


export type MutationDeleteDatabaseListReleaseEntriesArgs = {
  where: Array<DatabaseListReleaseEntryWhereUniqueInput>;
};


export type MutationDeleteDatabaseListReleaseEntryArgs = {
  where: DatabaseListReleaseEntryWhereUniqueInput;
};


export type MutationDeleteDemographiesArgs = {
  where: Array<DemographyWhereUniqueInput>;
};


export type MutationDeleteDemographyArgs = {
  where: DemographyWhereUniqueInput;
};


export type MutationDeleteExtraArgs = {
  where: ExtraWhereUniqueInput;
};


export type MutationDeleteExtrasArgs = {
  where: Array<ExtraWhereUniqueInput>;
};


export type MutationDeleteFeedbackArgs = {
  where: FeedbackWhereUniqueInput;
};


export type MutationDeleteFeedbacksArgs = {
  where: Array<FeedbackWhereUniqueInput>;
};


export type MutationDeleteIndividualArgs = {
  where: IndividualWhereUniqueInput;
};


export type MutationDeleteIndividualsArgs = {
  where: Array<IndividualWhereUniqueInput>;
};


export type MutationDeleteJobArgs = {
  where: JobWhereUniqueInput;
};


export type MutationDeleteJobsArgs = {
  where: Array<JobWhereUniqueInput>;
};


export type MutationDeleteJpPublisherArgs = {
  where: JpPublisherWhereUniqueInput;
};


export type MutationDeleteJpPublishersArgs = {
  where: Array<JpPublisherWhereUniqueInput>;
};


export type MutationDeleteMagazineArgs = {
  where: MagazineWhereUniqueInput;
};


export type MutationDeleteMagazinesArgs = {
  where: Array<MagazineWhereUniqueInput>;
};


export type MutationDeleteMaterialInfoArgs = {
  where: MaterialInfoWhereUniqueInput;
};


export type MutationDeleteMaterialInfosArgs = {
  where: Array<MaterialInfoWhereUniqueInput>;
};


export type MutationDeleteMissingIsbnArgs = {
  where: MissingIsbnWhereUniqueInput;
};


export type MutationDeleteMissingIsbnsArgs = {
  where: Array<MissingIsbnWhereUniqueInput>;
};


export type MutationDeleteNotificationArgs = {
  where: NotificationWhereUniqueInput;
};


export type MutationDeleteNotificationsArgs = {
  where: Array<NotificationWhereUniqueInput>;
};


export type MutationDeleteNoveltiesArgs = {
  where: Array<NoveltyWhereUniqueInput>;
};


export type MutationDeleteNoveltyArgs = {
  where: NoveltyWhereUniqueInput;
};


export type MutationDeletePublisherArgs = {
  where: PublisherWhereUniqueInput;
};


export type MutationDeletePublishersArgs = {
  where: Array<PublisherWhereUniqueInput>;
};


export type MutationDeleteReleaseEntriesArgs = {
  where: Array<ReleaseEntryWhereUniqueInput>;
};


export type MutationDeleteReleaseEntryArgs = {
  where: ReleaseEntryWhereUniqueInput;
};


export type MutationDeleteReleaseItemArgs = {
  where: ReleaseItemWhereUniqueInput;
};


export type MutationDeleteReleaseItemCollectionArgs = {
  where: ReleaseItemCollectionWhereUniqueInput;
};


export type MutationDeleteReleaseItemCollectionsArgs = {
  where: Array<ReleaseItemCollectionWhereUniqueInput>;
};


export type MutationDeleteReleaseItemsArgs = {
  where: Array<ReleaseItemWhereUniqueInput>;
};


export type MutationDeleteSeriesInfoArgs = {
  where: SeriesInfoWhereUniqueInput;
};


export type MutationDeleteSeriesInfosArgs = {
  where: Array<SeriesInfoWhereUniqueInput>;
};


export type MutationDeleteSharedReleaseCollectionArgs = {
  where: SharedReleaseCollectionWhereUniqueInput;
};


export type MutationDeleteSharedReleaseCollectionsArgs = {
  where: Array<SharedReleaseCollectionWhereUniqueInput>;
};


export type MutationDeleteSizeInfoArgs = {
  where: SizeInfoWhereUniqueInput;
};


export type MutationDeleteSizeInfosArgs = {
  where: Array<SizeInfoWhereUniqueInput>;
};


export type MutationDeleteSourceLinkArgs = {
  where: SourceLinkWhereUniqueInput;
};


export type MutationDeleteSourceLinksArgs = {
  where: Array<SourceLinkWhereUniqueInput>;
};


export type MutationDeleteSourceSnapshotArgs = {
  where: SourceSnapshotWhereUniqueInput;
};


export type MutationDeleteSourceSnapshotsArgs = {
  where: Array<SourceSnapshotWhereUniqueInput>;
};


export type MutationDeleteSourceUpdateArgs = {
  where: SourceUpdateWhereUniqueInput;
};


export type MutationDeleteSourceUpdatesArgs = {
  where: Array<SourceUpdateWhereUniqueInput>;
};


export type MutationDeleteStaffEntriesArgs = {
  where: Array<StaffEntryWhereUniqueInput>;
};


export type MutationDeleteStaffEntryArgs = {
  where: StaffEntryWhereUniqueInput;
};


export type MutationDeleteTagArgs = {
  where: TagWhereUniqueInput;
};


export type MutationDeleteTagsArgs = {
  where: Array<TagWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUserActiveDayArgs = {
  where: UserActiveDayWhereUniqueInput;
};


export type MutationDeleteUserActiveDaysArgs = {
  where: Array<UserActiveDayWhereUniqueInput>;
};


export type MutationDeleteUserAdminArgs = {
  where: UserAdminWhereUniqueInput;
};


export type MutationDeleteUserAdminsArgs = {
  where: Array<UserAdminWhereUniqueInput>;
};


export type MutationDeleteUserCollectionStatsArgs = {
  where: UserCollectionStatsWhereUniqueInput;
};


export type MutationDeleteUserCollectionStatsItemsArgs = {
  where: Array<UserCollectionStatsWhereUniqueInput>;
};


export type MutationDeleteUserCustomListArgs = {
  where: UserCustomListWhereUniqueInput;
};


export type MutationDeleteUserCustomListNoveltyItemArgs = {
  where: UserCustomListNoveltyItemWhereUniqueInput;
};


export type MutationDeleteUserCustomListNoveltyItemsArgs = {
  where: Array<UserCustomListNoveltyItemWhereUniqueInput>;
};


export type MutationDeleteUserCustomListReleaseEntryItemArgs = {
  where: UserCustomListReleaseEntryItemWhereUniqueInput;
};


export type MutationDeleteUserCustomListReleaseEntryItemsArgs = {
  where: Array<UserCustomListReleaseEntryItemWhereUniqueInput>;
};


export type MutationDeleteUserCustomListWithItemsArgs = {
  listId: Scalars['ID']['input'];
};


export type MutationDeleteUserCustomListsArgs = {
  where: Array<UserCustomListWhereUniqueInput>;
};


export type MutationDeleteUserImageArgs = {
  where: UserImageWhereUniqueInput;
};


export type MutationDeleteUserImagesArgs = {
  where: Array<UserImageWhereUniqueInput>;
};


export type MutationDeleteUserMiscPossessionActivitiesArgs = {
  where: Array<UserMiscPossessionActivityWhereUniqueInput>;
};


export type MutationDeleteUserMiscPossessionActivityArgs = {
  where: UserMiscPossessionActivityWhereUniqueInput;
};


export type MutationDeleteUserPossessionActivitiesArgs = {
  where: Array<UserPossessionActivityWhereUniqueInput>;
};


export type MutationDeleteUserPossessionActivityArgs = {
  where: UserPossessionActivityWhereUniqueInput;
};


export type MutationDeleteUserPremiumChangeArgs = {
  where: UserPremiumChangeWhereUniqueInput;
};


export type MutationDeleteUserPremiumChangesArgs = {
  where: Array<UserPremiumChangeWhereUniqueInput>;
};


export type MutationDeleteUserReadActivitiesArgs = {
  where: Array<UserReadActivityWhereUniqueInput>;
};


export type MutationDeleteUserReadActivityArgs = {
  where: UserReadActivityWhereUniqueInput;
};


export type MutationDeleteUserReleaseActivitiesArgs = {
  where: Array<UserReleaseActivityWhereUniqueInput>;
};


export type MutationDeleteUserReleaseActivityArgs = {
  where: UserReleaseActivityWhereUniqueInput;
};


export type MutationDeleteUserReleaseEntryStatusArgs = {
  where: UserReleaseEntryStatusWhereUniqueInput;
};


export type MutationDeleteUserReleaseEntryStatusWithEventArgs = {
  eventDate: Scalars['DateTime']['input'];
  where: UserReleaseEntryStatusWhereUniqueInput;
};


export type MutationDeleteUserReleaseEntryStatusesArgs = {
  where: Array<UserReleaseEntryStatusWhereUniqueInput>;
};


export type MutationDeleteUserReleaseReadStatusArgs = {
  where: UserReleaseReadStatusWhereUniqueInput;
};


export type MutationDeleteUserReleaseReadStatusesArgs = {
  where: Array<UserReleaseReadStatusWhereUniqueInput>;
};


export type MutationDeleteUserStatsDailyFactArgs = {
  where: UserStatsDailyFactWhereUniqueInput;
};


export type MutationDeleteUserStatsDailyFactsArgs = {
  where: Array<UserStatsDailyFactWhereUniqueInput>;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationDeleteVlbUpdateConfigArgs = {
  where: VlbUpdateConfigWhereUniqueInput;
};


export type MutationDeleteVlbUpdateConfigsArgs = {
  where: Array<VlbUpdateConfigWhereUniqueInput>;
};


export type MutationDeleteVolumeSuffixArgs = {
  where: VolumeSuffixWhereUniqueInput;
};


export type MutationDeleteVolumeSuffixesArgs = {
  where: Array<VolumeSuffixWhereUniqueInput>;
};


export type MutationInformMissingIsbnReportersArgs = {
  isbn: Scalars['String']['input'];
};


export type MutationMergeReleaseItemArgs = {
  deleteEmptySourceEntry?: InputMaybe<Scalars['Boolean']['input']>;
  sourceReleaseItemId: Scalars['ID']['input'];
  targetReleaseItemId: Scalars['ID']['input'];
};


export type MutationMigrateConvertedItemsToCollectionsArgs = {
  conversions: Array<ConvertItemConversionInput>;
  entryId: Scalars['ID']['input'];
};


export type MutationMigrateCopiedReleaseArgs = {
  canonicalCollectionId: Scalars['ID']['input'];
  copiedFromId: Scalars['ID']['input'];
  copiedFromKind: Scalars['String']['input'];
  sourceEntryId: Scalars['ID']['input'];
  targets: Array<MigrateTargetInput>;
};


export type MutationMoveReleaseItemArgs = {
  newNumber: Scalars['String']['input'];
  newVolumeSuffix?: InputMaybe<Scalars['String']['input']>;
  releaseItemId: Scalars['ID']['input'];
  targetReleaseEntryId: Scalars['ID']['input'];
};


export type MutationPurgeReportedUserImageAfterEscalationArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationQueueCustomNotificationArgs = {
  input: CustomNotificationInput;
};


export type MutationRecordMissingIsbnCatalogMatchesArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationRemoveUserImageFromProfileArgs = {
  kind: Scalars['String']['input'];
};


export type MutationRestoreUserImageDismissedAsNotCredibleArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationSendCustomNotificationTestArgs = {
  input: CustomNotificationInput;
};


export type MutationSendTestNotificationArgs = {
  collectionKind?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newDate?: InputMaybe<Scalars['String']['input']>;
  newDateAccuracy?: InputMaybe<Scalars['String']['input']>;
  oldDate?: InputMaybe<Scalars['String']['input']>;
  oldDateAccuracy?: InputMaybe<Scalars['String']['input']>;
  persistNotification?: Scalars['Boolean']['input'];
  releaseEntryId?: InputMaybe<Scalars['ID']['input']>;
  scannedItems?: InputMaybe<Array<SendTestScannedItemInput>>;
  sendPush?: Scalars['Boolean']['input'];
  subscriptionKind?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  template: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['ID']['input']>;
  volumeSuffixId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSubmitContentReportArgs = {
  content: Scalars['String']['input'];
  handle: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
  statement: Scalars['String']['input'];
};


export type MutationTakeReportedUserImageDownArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationUpdateContentReportArgs = {
  data: ContentReportUpdateInput;
  where: ContentReportWhereUniqueInput;
};


export type MutationUpdateContentReportsArgs = {
  data: Array<ContentReportUpdateArgs>;
};


export type MutationUpdateCountriesArgs = {
  data: Array<CountryUpdateArgs>;
};


export type MutationUpdateCountryArgs = {
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};


export type MutationUpdateDatabaseListConfigArgs = {
  data: DatabaseListConfigUpdateInput;
  where: DatabaseListConfigWhereUniqueInput;
};


export type MutationUpdateDatabaseListConfigsArgs = {
  data: Array<DatabaseListConfigUpdateArgs>;
};


export type MutationUpdateDatabaseListReleaseEntriesArgs = {
  data: Array<DatabaseListReleaseEntryUpdateArgs>;
};


export type MutationUpdateDatabaseListReleaseEntryArgs = {
  data: DatabaseListReleaseEntryUpdateInput;
  where: DatabaseListReleaseEntryWhereUniqueInput;
};


export type MutationUpdateDemographiesArgs = {
  data: Array<DemographyUpdateArgs>;
};


export type MutationUpdateDemographyArgs = {
  data: DemographyUpdateInput;
  where: DemographyWhereUniqueInput;
};


export type MutationUpdateExtraArgs = {
  data: ExtraUpdateInput;
  where: ExtraWhereUniqueInput;
};


export type MutationUpdateExtrasArgs = {
  data: Array<ExtraUpdateArgs>;
};


export type MutationUpdateFeedbackArgs = {
  data: FeedbackUpdateInput;
  where: FeedbackWhereUniqueInput;
};


export type MutationUpdateFeedbacksArgs = {
  data: Array<FeedbackUpdateArgs>;
};


export type MutationUpdateIndividualArgs = {
  data: IndividualUpdateInput;
  where: IndividualWhereUniqueInput;
};


export type MutationUpdateIndividualsArgs = {
  data: Array<IndividualUpdateArgs>;
};


export type MutationUpdateJobArgs = {
  data: JobUpdateInput;
  where: JobWhereUniqueInput;
};


export type MutationUpdateJobsArgs = {
  data: Array<JobUpdateArgs>;
};


export type MutationUpdateJpPublisherArgs = {
  data: JpPublisherUpdateInput;
  where: JpPublisherWhereUniqueInput;
};


export type MutationUpdateJpPublishersArgs = {
  data: Array<JpPublisherUpdateArgs>;
};


export type MutationUpdateMagazineArgs = {
  data: MagazineUpdateInput;
  where: MagazineWhereUniqueInput;
};


export type MutationUpdateMagazinesArgs = {
  data: Array<MagazineUpdateArgs>;
};


export type MutationUpdateMaterialInfoArgs = {
  data: MaterialInfoUpdateInput;
  where: MaterialInfoWhereUniqueInput;
};


export type MutationUpdateMaterialInfosArgs = {
  data: Array<MaterialInfoUpdateArgs>;
};


export type MutationUpdateMissingIsbnArgs = {
  data: MissingIsbnUpdateInput;
  where: MissingIsbnWhereUniqueInput;
};


export type MutationUpdateMissingIsbnsArgs = {
  data: Array<MissingIsbnUpdateArgs>;
};


export type MutationUpdateNotificationArgs = {
  data: NotificationUpdateInput;
  where: NotificationWhereUniqueInput;
};


export type MutationUpdateNotificationsArgs = {
  data: Array<NotificationUpdateArgs>;
};


export type MutationUpdateNoveltiesArgs = {
  data: Array<NoveltyUpdateArgs>;
};


export type MutationUpdateNoveltyArgs = {
  data: NoveltyUpdateInput;
  where: NoveltyWhereUniqueInput;
};


export type MutationUpdatePublisherArgs = {
  data: PublisherUpdateInput;
  where: PublisherWhereUniqueInput;
};


export type MutationUpdatePublishersArgs = {
  data: Array<PublisherUpdateArgs>;
};


export type MutationUpdateReleaseEntriesArgs = {
  data: Array<ReleaseEntryUpdateArgs>;
};


export type MutationUpdateReleaseEntryArgs = {
  data: ReleaseEntryUpdateInput;
  where: ReleaseEntryWhereUniqueInput;
};


export type MutationUpdateReleaseItemArgs = {
  data: ReleaseItemUpdateInput;
  where: ReleaseItemWhereUniqueInput;
};


export type MutationUpdateReleaseItemCollectionArgs = {
  data: ReleaseItemCollectionUpdateInput;
  where: ReleaseItemCollectionWhereUniqueInput;
};


export type MutationUpdateReleaseItemCollectionsArgs = {
  data: Array<ReleaseItemCollectionUpdateArgs>;
};


export type MutationUpdateReleaseItemsArgs = {
  data: Array<ReleaseItemUpdateArgs>;
};


export type MutationUpdateSeriesInfoArgs = {
  data: SeriesInfoUpdateInput;
  where: SeriesInfoWhereUniqueInput;
};


export type MutationUpdateSeriesInfosArgs = {
  data: Array<SeriesInfoUpdateArgs>;
};


export type MutationUpdateSharedReleaseCollectionArgs = {
  data: SharedReleaseCollectionUpdateInput;
  where: SharedReleaseCollectionWhereUniqueInput;
};


export type MutationUpdateSharedReleaseCollectionsArgs = {
  data: Array<SharedReleaseCollectionUpdateArgs>;
};


export type MutationUpdateSizeInfoArgs = {
  data: SizeInfoUpdateInput;
  where: SizeInfoWhereUniqueInput;
};


export type MutationUpdateSizeInfosArgs = {
  data: Array<SizeInfoUpdateArgs>;
};


export type MutationUpdateSourceLinkArgs = {
  data: SourceLinkUpdateInput;
  where: SourceLinkWhereUniqueInput;
};


export type MutationUpdateSourceLinksArgs = {
  data: Array<SourceLinkUpdateArgs>;
};


export type MutationUpdateSourceSnapshotArgs = {
  data: SourceSnapshotUpdateInput;
  where: SourceSnapshotWhereUniqueInput;
};


export type MutationUpdateSourceSnapshotsArgs = {
  data: Array<SourceSnapshotUpdateArgs>;
};


export type MutationUpdateSourceUpdateArgs = {
  data: SourceUpdateUpdateInput;
  where: SourceUpdateWhereUniqueInput;
};


export type MutationUpdateSourceUpdatesArgs = {
  data: Array<SourceUpdateUpdateArgs>;
};


export type MutationUpdateStaffEntriesArgs = {
  data: Array<StaffEntryUpdateArgs>;
};


export type MutationUpdateStaffEntryArgs = {
  data: StaffEntryUpdateInput;
  where: StaffEntryWhereUniqueInput;
};


export type MutationUpdateTagArgs = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpdateTagsArgs = {
  data: Array<TagUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserActiveDayArgs = {
  data: UserActiveDayUpdateInput;
  where: UserActiveDayWhereUniqueInput;
};


export type MutationUpdateUserActiveDaysArgs = {
  data: Array<UserActiveDayUpdateArgs>;
};


export type MutationUpdateUserAdminArgs = {
  data: UserAdminUpdateInput;
  where: UserAdminWhereUniqueInput;
};


export type MutationUpdateUserAdminsArgs = {
  data: Array<UserAdminUpdateArgs>;
};


export type MutationUpdateUserCollectionStatsArgs = {
  data: UserCollectionStatsUpdateInput;
  where: UserCollectionStatsWhereUniqueInput;
};


export type MutationUpdateUserCollectionStatsItemsArgs = {
  data: Array<UserCollectionStatsUpdateArgs>;
};


export type MutationUpdateUserCustomListArgs = {
  data: UserCustomListUpdateInput;
  where: UserCustomListWhereUniqueInput;
};


export type MutationUpdateUserCustomListNoveltyItemArgs = {
  data: UserCustomListNoveltyItemUpdateInput;
  where: UserCustomListNoveltyItemWhereUniqueInput;
};


export type MutationUpdateUserCustomListNoveltyItemsArgs = {
  data: Array<UserCustomListNoveltyItemUpdateArgs>;
};


export type MutationUpdateUserCustomListReleaseEntryItemArgs = {
  data: UserCustomListReleaseEntryItemUpdateInput;
  where: UserCustomListReleaseEntryItemWhereUniqueInput;
};


export type MutationUpdateUserCustomListReleaseEntryItemsArgs = {
  data: Array<UserCustomListReleaseEntryItemUpdateArgs>;
};


export type MutationUpdateUserCustomListsArgs = {
  data: Array<UserCustomListUpdateArgs>;
};


export type MutationUpdateUserImageArgs = {
  data: UserImageUpdateInput;
  where: UserImageWhereUniqueInput;
};


export type MutationUpdateUserImagesArgs = {
  data: Array<UserImageUpdateArgs>;
};


export type MutationUpdateUserMiscPossessionActivitiesArgs = {
  data: Array<UserMiscPossessionActivityUpdateArgs>;
};


export type MutationUpdateUserMiscPossessionActivityArgs = {
  data: UserMiscPossessionActivityUpdateInput;
  where: UserMiscPossessionActivityWhereUniqueInput;
};


export type MutationUpdateUserPossessionActivitiesArgs = {
  data: Array<UserPossessionActivityUpdateArgs>;
};


export type MutationUpdateUserPossessionActivityArgs = {
  data: UserPossessionActivityUpdateInput;
  where: UserPossessionActivityWhereUniqueInput;
};


export type MutationUpdateUserPremiumChangeArgs = {
  data: UserPremiumChangeUpdateInput;
  where: UserPremiumChangeWhereUniqueInput;
};


export type MutationUpdateUserPremiumChangesArgs = {
  data: Array<UserPremiumChangeUpdateArgs>;
};


export type MutationUpdateUserReadActivitiesArgs = {
  data: Array<UserReadActivityUpdateArgs>;
};


export type MutationUpdateUserReadActivityArgs = {
  data: UserReadActivityUpdateInput;
  where: UserReadActivityWhereUniqueInput;
};


export type MutationUpdateUserReleaseActivitiesArgs = {
  data: Array<UserReleaseActivityUpdateArgs>;
};


export type MutationUpdateUserReleaseActivityArgs = {
  data: UserReleaseActivityUpdateInput;
  where: UserReleaseActivityWhereUniqueInput;
};


export type MutationUpdateUserReleaseEntryStatusArgs = {
  data: UserReleaseEntryStatusUpdateInput;
  where: UserReleaseEntryStatusWhereUniqueInput;
};


export type MutationUpdateUserReleaseEntryStatusesArgs = {
  data: Array<UserReleaseEntryStatusUpdateArgs>;
};


export type MutationUpdateUserReleaseReadStatusArgs = {
  data: UserReleaseReadStatusUpdateInput;
  where: UserReleaseReadStatusWhereUniqueInput;
};


export type MutationUpdateUserReleaseReadStatusesArgs = {
  data: Array<UserReleaseReadStatusUpdateArgs>;
};


export type MutationUpdateUserStatsDailyFactArgs = {
  data: UserStatsDailyFactUpdateInput;
  where: UserStatsDailyFactWhereUniqueInput;
};


export type MutationUpdateUserStatsDailyFactsArgs = {
  data: Array<UserStatsDailyFactUpdateArgs>;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationUpdateVlbUpdateConfigArgs = {
  data: VlbUpdateConfigUpdateInput;
  where: VlbUpdateConfigWhereUniqueInput;
};


export type MutationUpdateVlbUpdateConfigsArgs = {
  data: Array<VlbUpdateConfigUpdateArgs>;
};


export type MutationUpdateVolumeSuffixArgs = {
  data: VolumeSuffixUpdateInput;
  where: VolumeSuffixWhereUniqueInput;
};


export type MutationUpdateVolumeSuffixesArgs = {
  data: Array<VolumeSuffixUpdateArgs>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  timeRead?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type NotificationChannelOption = {
  __typename?: 'NotificationChannelOption';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationCreateInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeRead?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationManyRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  timeRead?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type NotificationRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  create?: InputMaybe<Array<NotificationCreateInput>>;
};

export type NotificationRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  create?: InputMaybe<Array<NotificationCreateInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
};

export type NotificationUpdateArgs = {
  data: NotificationUpdateInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeRead?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  timeRead?: InputMaybe<DateTimeNullableFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Novelty = {
  __typename?: 'Novelty';
  collectionVolumeInfo?: Maybe<NoveltyCollectionVolumeInfo>;
  cover?: Maybe<Scalars['String']['output']>;
  curatedListMemberships?: Maybe<Array<UserCustomListNoveltyItem>>;
  curatedListMembershipsCount?: Maybe<Scalars['Int']['output']>;
  demographySearchField?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  localizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  relationId?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<NoveltyRelationTypeType>;
  releaseDate?: Maybe<Scalars['CalendarDay']['output']>;
  releaseDateAccuracy?: Maybe<Scalars['String']['output']>;
  releaseItems?: Maybe<Scalars['JSON']['output']>;
  releaseMonth?: Maybe<Scalars['Int']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  romanizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  tagSearchField?: Maybe<Scalars['String']['output']>;
  thumbHash?: Maybe<Scalars['String']['output']>;
  titleSearch?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  volumeSuffix?: Maybe<Scalars['String']['output']>;
};


export type NoveltyCuratedListMembershipsArgs = {
  cursor?: InputMaybe<UserCustomListNoveltyItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListNoveltyItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListNoveltyItemWhereInput;
};


export type NoveltyCuratedListMembershipsCountArgs = {
  where?: UserCustomListNoveltyItemWhereInput;
};

export type NoveltyCollectionVolumeInfo = {
  __typename?: 'NoveltyCollectionVolumeInfo';
  kind: Scalars['String']['output'];
  spansEntries: Scalars['Boolean']['output'];
  volumeCount: Scalars['Int']['output'];
};

export type NoveltyCreateInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  curatedListMemberships?: InputMaybe<UserCustomListNoveltyItemRelateToManyForCreateInput>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  relationId?: InputMaybe<Scalars['String']['input']>;
  relationType?: InputMaybe<NoveltyRelationTypeType>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<Scalars['String']['input']>;
  releaseItems?: InputMaybe<Scalars['JSON']['input']>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type NoveltyOrderByInput = {
  cover?: InputMaybe<OrderDirection>;
  demographySearchField?: InputMaybe<OrderDirection>;
  disabled?: InputMaybe<OrderDirection>;
  entryId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isbn?: InputMaybe<OrderDirection>;
  localizedSeriesTitle?: InputMaybe<OrderDirection>;
  number?: InputMaybe<OrderDirection>;
  price?: InputMaybe<OrderDirection>;
  publisherName?: InputMaybe<OrderDirection>;
  relationId?: InputMaybe<OrderDirection>;
  relationType?: InputMaybe<OrderDirection>;
  releaseDate?: InputMaybe<OrderDirection>;
  releaseDateAccuracy?: InputMaybe<OrderDirection>;
  releaseMonth?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  romanizedSeriesTitle?: InputMaybe<OrderDirection>;
  tagSearchField?: InputMaybe<OrderDirection>;
  thumbHash?: InputMaybe<OrderDirection>;
  titleSearch?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  volumeSuffix?: InputMaybe<OrderDirection>;
};

export type NoveltyRelateToOneForCreateInput = {
  connect?: InputMaybe<NoveltyWhereUniqueInput>;
  create?: InputMaybe<NoveltyCreateInput>;
};

export type NoveltyRelateToOneForUpdateInput = {
  connect?: InputMaybe<NoveltyWhereUniqueInput>;
  create?: InputMaybe<NoveltyCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NoveltyRelationTypeType {
  Collection = 'collection',
  Extra = 'extra',
  Volume = 'volume'
}

export type NoveltyRelationTypeTypeNullableFilter = {
  equals?: InputMaybe<NoveltyRelationTypeType>;
  in?: InputMaybe<Array<NoveltyRelationTypeType>>;
  not?: InputMaybe<NoveltyRelationTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<NoveltyRelationTypeType>>;
};

export type NoveltyUpdateArgs = {
  data: NoveltyUpdateInput;
  where: NoveltyWhereUniqueInput;
};

export type NoveltyUpdateInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  curatedListMemberships?: InputMaybe<UserCustomListNoveltyItemRelateToManyForUpdateInput>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  relationId?: InputMaybe<Scalars['String']['input']>;
  relationType?: InputMaybe<NoveltyRelationTypeType>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<Scalars['String']['input']>;
  releaseItems?: InputMaybe<Scalars['JSON']['input']>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type NoveltyWhereInput = {
  AND?: InputMaybe<Array<NoveltyWhereInput>>;
  NOT?: InputMaybe<Array<NoveltyWhereInput>>;
  OR?: InputMaybe<Array<NoveltyWhereInput>>;
  cover?: InputMaybe<StringFilter>;
  curatedListMemberships?: InputMaybe<UserCustomListNoveltyItemManyRelationFilter>;
  demographySearchField?: InputMaybe<StringFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  entryId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isbn?: InputMaybe<StringNullableFilter>;
  localizedSeriesTitle?: InputMaybe<StringFilter>;
  number?: InputMaybe<DecimalNullableFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  publisherName?: InputMaybe<StringFilter>;
  relationId?: InputMaybe<StringFilter>;
  relationType?: InputMaybe<NoveltyRelationTypeTypeNullableFilter>;
  releaseDate?: InputMaybe<CalendarDayNullableFilter>;
  releaseDateAccuracy?: InputMaybe<StringFilter>;
  releaseMonth?: InputMaybe<IntNullableFilter>;
  releaseYear?: InputMaybe<IntNullableFilter>;
  romanizedSeriesTitle?: InputMaybe<StringFilter>;
  tagSearchField?: InputMaybe<StringFilter>;
  thumbHash?: InputMaybe<StringNullableFilter>;
  titleSearch?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  volumeSuffix?: InputMaybe<StringNullableFilter>;
};

export type NoveltyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ProfileStatistics = {
  __typename?: 'ProfileStatistics';
  readPercent: Scalars['Int']['output'];
  series: Scalars['Int']['output'];
  volumes: Scalars['Int']['output'];
};

export type PublicProfile = {
  __typename?: 'PublicProfile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  memberSince?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<ProfileStatistics>;
};

export type Publisher = {
  __typename?: 'Publisher';
  betterCoverProvider?: Maybe<Scalars['String']['output']>;
  colorDarkTheme?: Maybe<Scalars['String']['output']>;
  colorLightTheme?: Maybe<Scalars['String']['output']>;
  connector?: Maybe<Scalars['String']['output']>;
  defaultVlbTextTypeCodes?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imprints?: Maybe<Array<Publisher>>;
  imprintsCount?: Maybe<Scalars['Int']['output']>;
  lastUpdateRun?: Maybe<Scalars['CalendarDay']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentPublisher?: Maybe<Publisher>;
  publisherChangeEvents?: Maybe<Scalars['JSON']['output']>;
  releaseEntries?: Maybe<Array<ReleaseEntry>>;
  releaseEntriesCount?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vlbId?: Maybe<Scalars['String']['output']>;
  vlbImprint?: Maybe<Scalars['String']['output']>;
  vlbKeyword?: Maybe<Scalars['String']['output']>;
  vlbSubjectFilter?: Maybe<Scalars['String']['output']>;
  vlbTitleFilter?: Maybe<Scalars['String']['output']>;
};


export type PublisherImprintsArgs = {
  cursor?: InputMaybe<PublisherWhereUniqueInput>;
  orderBy?: Array<PublisherOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PublisherWhereInput;
};


export type PublisherImprintsCountArgs = {
  where?: PublisherWhereInput;
};


export type PublisherReleaseEntriesArgs = {
  cursor?: InputMaybe<ReleaseEntryWhereUniqueInput>;
  orderBy?: Array<ReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseEntryWhereInput;
};


export type PublisherReleaseEntriesCountArgs = {
  where?: ReleaseEntryWhereInput;
};

export type PublisherCreateInput = {
  betterCoverProvider?: InputMaybe<Scalars['String']['input']>;
  colorDarkTheme?: InputMaybe<Scalars['String']['input']>;
  colorLightTheme?: InputMaybe<Scalars['String']['input']>;
  connector?: InputMaybe<Scalars['String']['input']>;
  defaultVlbTextTypeCodes?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  imprints?: InputMaybe<PublisherRelateToManyForCreateInput>;
  lastUpdateRun?: InputMaybe<Scalars['CalendarDay']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentPublisher?: InputMaybe<PublisherRelateToOneForCreateInput>;
  publisherChangeEvents?: InputMaybe<Scalars['JSON']['input']>;
  releaseEntries?: InputMaybe<ReleaseEntryRelateToManyForCreateInput>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vlbId?: InputMaybe<Scalars['String']['input']>;
  vlbImprint?: InputMaybe<Scalars['String']['input']>;
  vlbKeyword?: InputMaybe<Scalars['String']['input']>;
  vlbSubjectFilter?: InputMaybe<Scalars['String']['input']>;
  vlbTitleFilter?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherManyRelationFilter = {
  every?: InputMaybe<PublisherWhereInput>;
  none?: InputMaybe<PublisherWhereInput>;
  some?: InputMaybe<PublisherWhereInput>;
};

export type PublisherOrderByInput = {
  betterCoverProvider?: InputMaybe<OrderDirection>;
  colorDarkTheme?: InputMaybe<OrderDirection>;
  colorLightTheme?: InputMaybe<OrderDirection>;
  connector?: InputMaybe<OrderDirection>;
  defaultVlbTextTypeCodes?: InputMaybe<OrderDirection>;
  disabled?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastUpdateRun?: InputMaybe<OrderDirection>;
  longName?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  sortOrder?: InputMaybe<OrderDirection>;
  url?: InputMaybe<OrderDirection>;
  vlbId?: InputMaybe<OrderDirection>;
  vlbImprint?: InputMaybe<OrderDirection>;
  vlbKeyword?: InputMaybe<OrderDirection>;
  vlbSubjectFilter?: InputMaybe<OrderDirection>;
  vlbTitleFilter?: InputMaybe<OrderDirection>;
};

export type PublisherRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PublisherWhereUniqueInput>>;
  create?: InputMaybe<Array<PublisherCreateInput>>;
};

export type PublisherRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PublisherWhereUniqueInput>>;
  create?: InputMaybe<Array<PublisherCreateInput>>;
  disconnect?: InputMaybe<Array<PublisherWhereUniqueInput>>;
  set?: InputMaybe<Array<PublisherWhereUniqueInput>>;
};

export type PublisherRelateToOneForCreateInput = {
  connect?: InputMaybe<PublisherWhereUniqueInput>;
  create?: InputMaybe<PublisherCreateInput>;
};

export type PublisherRelateToOneForUpdateInput = {
  connect?: InputMaybe<PublisherWhereUniqueInput>;
  create?: InputMaybe<PublisherCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublisherUpdateArgs = {
  data: PublisherUpdateInput;
  where: PublisherWhereUniqueInput;
};

export type PublisherUpdateInput = {
  betterCoverProvider?: InputMaybe<Scalars['String']['input']>;
  colorDarkTheme?: InputMaybe<Scalars['String']['input']>;
  colorLightTheme?: InputMaybe<Scalars['String']['input']>;
  connector?: InputMaybe<Scalars['String']['input']>;
  defaultVlbTextTypeCodes?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  imprints?: InputMaybe<PublisherRelateToManyForUpdateInput>;
  lastUpdateRun?: InputMaybe<Scalars['CalendarDay']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentPublisher?: InputMaybe<PublisherRelateToOneForUpdateInput>;
  publisherChangeEvents?: InputMaybe<Scalars['JSON']['input']>;
  releaseEntries?: InputMaybe<ReleaseEntryRelateToManyForUpdateInput>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vlbId?: InputMaybe<Scalars['String']['input']>;
  vlbImprint?: InputMaybe<Scalars['String']['input']>;
  vlbKeyword?: InputMaybe<Scalars['String']['input']>;
  vlbSubjectFilter?: InputMaybe<Scalars['String']['input']>;
  vlbTitleFilter?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherWhereInput = {
  AND?: InputMaybe<Array<PublisherWhereInput>>;
  NOT?: InputMaybe<Array<PublisherWhereInput>>;
  OR?: InputMaybe<Array<PublisherWhereInput>>;
  betterCoverProvider?: InputMaybe<StringNullableFilter>;
  colorDarkTheme?: InputMaybe<StringFilter>;
  colorLightTheme?: InputMaybe<StringFilter>;
  connector?: InputMaybe<StringFilter>;
  defaultVlbTextTypeCodes?: InputMaybe<StringFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IdFilter>;
  imprints?: InputMaybe<PublisherManyRelationFilter>;
  lastUpdateRun?: InputMaybe<CalendarDayNullableFilter>;
  longName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  parentPublisher?: InputMaybe<PublisherWhereInput>;
  releaseEntries?: InputMaybe<ReleaseEntryManyRelationFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  url?: InputMaybe<StringFilter>;
  vlbId?: InputMaybe<StringFilter>;
  vlbImprint?: InputMaybe<StringFilter>;
  vlbKeyword?: InputMaybe<StringFilter>;
  vlbSubjectFilter?: InputMaybe<StringFilter>;
  vlbTitleFilter?: InputMaybe<StringFilter>;
};

export type PublisherWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QaStats = {
  __typename?: 'QaStats';
  activePublishers: Scalars['Int']['output'];
  activeReleaseEntries: Scalars['Int']['output'];
  activeReleaseItemCollections: Scalars['Int']['output'];
  activeReleaseItems: Scalars['Int']['output'];
  activeUsers30d: Scalars['Int']['output'];
  activeUsersOverTime: Array<QaStatsActivePoint>;
  activeUsersPrevious30d: Scalars['Int']['output'];
  activityCollectionStart?: Maybe<Scalars['String']['output']>;
  dailyActiveUsersOverTime: Array<QaStatsActivePoint>;
  notificationsSentOverTime: Array<QaStatsActivePoint>;
  notificationsSentTotal: Scalars['Int']['output'];
  premiumOverTime: Array<QaStatsSignupPoint>;
  releasesInCollections: Scalars['Int']['output'];
  signupsOverTime: Array<QaStatsSignupPoint>;
  totalUsers: Scalars['Int']['output'];
  volumesInCollections: Scalars['Int']['output'];
  volumesRead: Scalars['Int']['output'];
};

export type QaStatsActivePoint = {
  __typename?: 'QaStatsActivePoint';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type QaStatsSignupPoint = {
  __typename?: 'QaStatsSignupPoint';
  count: Scalars['Int']['output'];
  cumulative: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type QaUser = {
  __typename?: 'QaUser';
  email?: Maybe<Scalars['String']['output']>;
  fcmTokenCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem: Scalars['Boolean']['output'];
  notificationNewReleasesFromAuthors: Scalars['Boolean']['output'];
  notificationNewReleasesFromPublishers: Scalars['Boolean']['output'];
  notificationReleaseCollectionItemAvailable: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  catalogChanges?: Maybe<CatalogDeltaPage>;
  contentReport?: Maybe<ContentReport>;
  contentReports?: Maybe<Array<ContentReport>>;
  contentReportsCount?: Maybe<Scalars['Int']['output']>;
  countries?: Maybe<Array<Country>>;
  countriesCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  customNotificationAudience: CustomNotificationAudience;
  databaseListConfig?: Maybe<DatabaseListConfig>;
  databaseListConfigs?: Maybe<Array<DatabaseListConfig>>;
  databaseListConfigsCount?: Maybe<Scalars['Int']['output']>;
  databaseListReleaseEntries?: Maybe<Array<DatabaseListReleaseEntry>>;
  databaseListReleaseEntriesCount?: Maybe<Scalars['Int']['output']>;
  databaseListReleaseEntry?: Maybe<DatabaseListReleaseEntry>;
  demographies?: Maybe<Array<Demography>>;
  demographiesCount?: Maybe<Scalars['Int']['output']>;
  demography?: Maybe<Demography>;
  extra?: Maybe<Extra>;
  extras?: Maybe<Array<Extra>>;
  extrasCount?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Feedback>;
  feedbacks?: Maybe<Array<Feedback>>;
  feedbacksCount?: Maybe<Scalars['Int']['output']>;
  filteredCustomListNovelties?: Maybe<Array<Novelty>>;
  filteredNovelties?: Maybe<Array<Novelty>>;
  filteredReleaseEntries?: Maybe<Array<ReleaseEntry>>;
  filteredUserReleaseEntryStatuses?: Maybe<Array<UserReleaseEntryStatus>>;
  individual?: Maybe<Individual>;
  individuals?: Maybe<Array<Individual>>;
  individualsCount?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  jobs?: Maybe<Array<Job>>;
  jobsCount?: Maybe<Scalars['Int']['output']>;
  jpPublisher?: Maybe<JpPublisher>;
  jpPublishers?: Maybe<Array<JpPublisher>>;
  jpPublishersCount?: Maybe<Scalars['Int']['output']>;
  keystone: KeystoneMeta;
  magazine?: Maybe<Magazine>;
  magazines?: Maybe<Array<Magazine>>;
  magazinesCount?: Maybe<Scalars['Int']['output']>;
  materialInfo?: Maybe<MaterialInfo>;
  materialInfos?: Maybe<Array<MaterialInfo>>;
  materialInfosCount?: Maybe<Scalars['Int']['output']>;
  missingIsbn?: Maybe<MissingIsbn>;
  missingIsbns?: Maybe<Array<MissingIsbn>>;
  missingIsbnsCount?: Maybe<Scalars['Int']['output']>;
  myProfileStatistics: ProfileStatistics;
  notification?: Maybe<Notification>;
  notificationChannels: Array<NotificationChannelOption>;
  notifications?: Maybe<Array<Notification>>;
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  novelties?: Maybe<Array<Novelty>>;
  noveltiesCount?: Maybe<Scalars['Int']['output']>;
  novelty?: Maybe<Novelty>;
  publicProfile?: Maybe<PublicProfile>;
  publishedDatabaseListConfigs?: Maybe<Array<DatabaseListConfig>>;
  publisher?: Maybe<Publisher>;
  publishers?: Maybe<Array<Publisher>>;
  publishersCount?: Maybe<Scalars['Int']['output']>;
  qaStats?: Maybe<QaStats>;
  qaUserSearch: Array<QaUser>;
  readRecommendations?: Maybe<Array<ReadRecommendation>>;
  releaseEntries?: Maybe<Array<ReleaseEntry>>;
  releaseEntriesCount?: Maybe<Scalars['Int']['output']>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseItem?: Maybe<ReleaseItem>;
  releaseItemCollection?: Maybe<ReleaseItemCollection>;
  releaseItemCollections?: Maybe<Array<ReleaseItemCollection>>;
  releaseItemCollectionsCount?: Maybe<Scalars['Int']['output']>;
  releaseItems?: Maybe<Array<ReleaseItem>>;
  releaseItemsCount?: Maybe<Scalars['Int']['output']>;
  seriesInfo?: Maybe<SeriesInfo>;
  seriesInfos?: Maybe<Array<SeriesInfo>>;
  seriesInfosCount?: Maybe<Scalars['Int']['output']>;
  sharedReleaseCollection?: Maybe<SharedReleaseCollection>;
  sharedReleaseCollections?: Maybe<Array<SharedReleaseCollection>>;
  sharedReleaseCollectionsCount?: Maybe<Scalars['Int']['output']>;
  sizeInfo?: Maybe<SizeInfo>;
  sizeInfos?: Maybe<Array<SizeInfo>>;
  sizeInfosCount?: Maybe<Scalars['Int']['output']>;
  sourceLink?: Maybe<SourceLink>;
  sourceLinks?: Maybe<Array<SourceLink>>;
  sourceLinksCount?: Maybe<Scalars['Int']['output']>;
  sourceSnapshot?: Maybe<SourceSnapshot>;
  sourceSnapshots?: Maybe<Array<SourceSnapshot>>;
  sourceSnapshotsCount?: Maybe<Scalars['Int']['output']>;
  sourceUpdate?: Maybe<SourceUpdate>;
  sourceUpdates?: Maybe<Array<SourceUpdate>>;
  sourceUpdatesCount?: Maybe<Scalars['Int']['output']>;
  staffEntries?: Maybe<Array<StaffEntry>>;
  staffEntriesCount?: Maybe<Scalars['Int']['output']>;
  staffEntry?: Maybe<StaffEntry>;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Tag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userActiveDay?: Maybe<UserActiveDay>;
  userActiveDays?: Maybe<Array<UserActiveDay>>;
  userActiveDaysCount?: Maybe<Scalars['Int']['output']>;
  userAdmin?: Maybe<UserAdmin>;
  userAdmins?: Maybe<Array<UserAdmin>>;
  userAdminsCount?: Maybe<Scalars['Int']['output']>;
  userChanges?: Maybe<UserDeltaPage>;
  userCollectionBreakdown?: Maybe<Array<UserCollectionBreakdownBucket>>;
  userCollectionStats?: Maybe<UserCollectionStats>;
  userCollectionStatsItems?: Maybe<Array<UserCollectionStats>>;
  userCollectionStatsItemsCount?: Maybe<Scalars['Int']['output']>;
  userCustomList?: Maybe<UserCustomList>;
  userCustomListNoveltyItem?: Maybe<UserCustomListNoveltyItem>;
  userCustomListNoveltyItems?: Maybe<Array<UserCustomListNoveltyItem>>;
  userCustomListNoveltyItemsCount?: Maybe<Scalars['Int']['output']>;
  userCustomListReleaseEntryItem?: Maybe<UserCustomListReleaseEntryItem>;
  userCustomListReleaseEntryItems?: Maybe<Array<UserCustomListReleaseEntryItem>>;
  userCustomListReleaseEntryItemsCount?: Maybe<Scalars['Int']['output']>;
  userCustomListStats?: Maybe<UserCustomListStats>;
  userCustomLists?: Maybe<Array<UserCustomList>>;
  userCustomListsCount?: Maybe<Scalars['Int']['output']>;
  userImage?: Maybe<UserImage>;
  userImages?: Maybe<Array<UserImage>>;
  userImagesCount?: Maybe<Scalars['Int']['output']>;
  userMiscPossessionActivities?: Maybe<Array<UserMiscPossessionActivity>>;
  userMiscPossessionActivitiesCount?: Maybe<Scalars['Int']['output']>;
  userMiscPossessionActivity?: Maybe<UserMiscPossessionActivity>;
  userPossessionActivities?: Maybe<Array<UserPossessionActivity>>;
  userPossessionActivitiesCount?: Maybe<Scalars['Int']['output']>;
  userPossessionActivity?: Maybe<UserPossessionActivity>;
  userPremiumChange?: Maybe<UserPremiumChange>;
  userPremiumChanges?: Maybe<Array<UserPremiumChange>>;
  userPremiumChangesCount?: Maybe<Scalars['Int']['output']>;
  userReadActivities?: Maybe<Array<UserReadActivity>>;
  userReadActivitiesCount?: Maybe<Scalars['Int']['output']>;
  userReadActivity?: Maybe<UserReadActivity>;
  userReleaseActivities?: Maybe<Array<UserReleaseActivity>>;
  userReleaseActivitiesCount?: Maybe<Scalars['Int']['output']>;
  userReleaseActivity?: Maybe<UserReleaseActivity>;
  userReleaseEntryStatus?: Maybe<UserReleaseEntryStatus>;
  userReleaseEntryStatuses?: Maybe<Array<UserReleaseEntryStatus>>;
  userReleaseEntryStatusesCount?: Maybe<Scalars['Int']['output']>;
  userReleaseReadStatus?: Maybe<UserReleaseReadStatus>;
  userReleaseReadStatuses?: Maybe<Array<UserReleaseReadStatus>>;
  userReleaseReadStatusesCount?: Maybe<Scalars['Int']['output']>;
  userStatsDailyFact?: Maybe<UserStatsDailyFact>;
  userStatsDailyFacts?: Maybe<Array<UserStatsDailyFact>>;
  userStatsDailyFactsCount?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  vlbUpdateConfig?: Maybe<VlbUpdateConfig>;
  vlbUpdateConfigs?: Maybe<Array<VlbUpdateConfig>>;
  vlbUpdateConfigsCount?: Maybe<Scalars['Int']['output']>;
  volumeSuffix?: Maybe<VolumeSuffix>;
  volumeSuffixes?: Maybe<Array<VolumeSuffix>>;
  volumeSuffixesCount?: Maybe<Scalars['Int']['output']>;
};


export type QueryCatalogChangesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceSeq: Scalars['String']['input'];
  subscription: CatalogSubscriptionInput;
};


export type QueryContentReportArgs = {
  where: ContentReportWhereUniqueInput;
};


export type QueryContentReportsArgs = {
  cursor?: InputMaybe<ContentReportWhereUniqueInput>;
  orderBy?: Array<ContentReportOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ContentReportWhereInput;
};


export type QueryContentReportsCountArgs = {
  where?: ContentReportWhereInput;
};


export type QueryCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  orderBy?: Array<CountryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CountryWhereInput;
};


export type QueryCountriesCountArgs = {
  where?: CountryWhereInput;
};


export type QueryCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryCustomNotificationAudienceArgs = {
  channel: Scalars['String']['input'];
};


export type QueryDatabaseListConfigArgs = {
  where: DatabaseListConfigWhereUniqueInput;
};


export type QueryDatabaseListConfigsArgs = {
  cursor?: InputMaybe<DatabaseListConfigWhereUniqueInput>;
  orderBy?: Array<DatabaseListConfigOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DatabaseListConfigWhereInput;
};


export type QueryDatabaseListConfigsCountArgs = {
  where?: DatabaseListConfigWhereInput;
};


export type QueryDatabaseListReleaseEntriesArgs = {
  cursor?: InputMaybe<DatabaseListReleaseEntryWhereUniqueInput>;
  orderBy?: Array<DatabaseListReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DatabaseListReleaseEntryWhereInput;
};


export type QueryDatabaseListReleaseEntriesCountArgs = {
  where?: DatabaseListReleaseEntryWhereInput;
};


export type QueryDatabaseListReleaseEntryArgs = {
  where: DatabaseListReleaseEntryWhereUniqueInput;
};


export type QueryDemographiesArgs = {
  cursor?: InputMaybe<DemographyWhereUniqueInput>;
  orderBy?: Array<DemographyOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DemographyWhereInput;
};


export type QueryDemographiesCountArgs = {
  where?: DemographyWhereInput;
};


export type QueryDemographyArgs = {
  where: DemographyWhereUniqueInput;
};


export type QueryExtraArgs = {
  where: ExtraWhereUniqueInput;
};


export type QueryExtrasArgs = {
  cursor?: InputMaybe<ExtraWhereUniqueInput>;
  orderBy?: Array<ExtraOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ExtraWhereInput;
};


export type QueryExtrasCountArgs = {
  where?: ExtraWhereInput;
};


export type QueryFeedbackArgs = {
  where: FeedbackWhereUniqueInput;
};


export type QueryFeedbacksArgs = {
  cursor?: InputMaybe<FeedbackWhereUniqueInput>;
  orderBy?: Array<FeedbackOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: FeedbackWhereInput;
};


export type QueryFeedbacksCountArgs = {
  where?: FeedbackWhereInput;
};


export type QueryFilteredCustomListNoveltiesArgs = {
  filterMode?: InputMaybe<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
  orderBy: Array<NoveltyOrderByInput>;
  skip: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where: NoveltyWhereInput;
};


export type QueryFilteredNoveltiesArgs = {
  filterMode?: InputMaybe<Scalars['String']['input']>;
  orderBy: Array<NoveltyOrderByInput>;
  skip: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where: NoveltyWhereInput;
};


export type QueryFilteredReleaseEntriesArgs = {
  filterMode?: InputMaybe<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
  orderBy: Array<ReleaseEntryOrderByInput>;
  skip: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where: ReleaseEntryWhereInput;
};


export type QueryFilteredUserReleaseEntryStatusesArgs = {
  filterMode?: InputMaybe<Scalars['String']['input']>;
  orderBy: Array<UserReleaseEntryStatusOrderByInput>;
  skip: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where: UserReleaseEntryStatusWhereInput;
};


export type QueryIndividualArgs = {
  where: IndividualWhereUniqueInput;
};


export type QueryIndividualsArgs = {
  cursor?: InputMaybe<IndividualWhereUniqueInput>;
  orderBy?: Array<IndividualOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: IndividualWhereInput;
};


export type QueryIndividualsCountArgs = {
  where?: IndividualWhereInput;
};


export type QueryJobArgs = {
  where: JobWhereUniqueInput;
};


export type QueryJobsArgs = {
  cursor?: InputMaybe<JobWhereUniqueInput>;
  orderBy?: Array<JobOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: JobWhereInput;
};


export type QueryJobsCountArgs = {
  where?: JobWhereInput;
};


export type QueryJpPublisherArgs = {
  where: JpPublisherWhereUniqueInput;
};


export type QueryJpPublishersArgs = {
  cursor?: InputMaybe<JpPublisherWhereUniqueInput>;
  orderBy?: Array<JpPublisherOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: JpPublisherWhereInput;
};


export type QueryJpPublishersCountArgs = {
  where?: JpPublisherWhereInput;
};


export type QueryMagazineArgs = {
  where: MagazineWhereUniqueInput;
};


export type QueryMagazinesArgs = {
  cursor?: InputMaybe<MagazineWhereUniqueInput>;
  orderBy?: Array<MagazineOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MagazineWhereInput;
};


export type QueryMagazinesCountArgs = {
  where?: MagazineWhereInput;
};


export type QueryMaterialInfoArgs = {
  where: MaterialInfoWhereUniqueInput;
};


export type QueryMaterialInfosArgs = {
  cursor?: InputMaybe<MaterialInfoWhereUniqueInput>;
  orderBy?: Array<MaterialInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MaterialInfoWhereInput;
};


export type QueryMaterialInfosCountArgs = {
  where?: MaterialInfoWhereInput;
};


export type QueryMissingIsbnArgs = {
  where: MissingIsbnWhereUniqueInput;
};


export type QueryMissingIsbnsArgs = {
  cursor?: InputMaybe<MissingIsbnWhereUniqueInput>;
  orderBy?: Array<MissingIsbnOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MissingIsbnWhereInput;
};


export type QueryMissingIsbnsCountArgs = {
  where?: MissingIsbnWhereInput;
};


export type QueryNotificationArgs = {
  where: NotificationWhereUniqueInput;
};


export type QueryNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  orderBy?: Array<NotificationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: NotificationWhereInput;
};


export type QueryNotificationsCountArgs = {
  where?: NotificationWhereInput;
};


export type QueryNoveltiesArgs = {
  cursor?: InputMaybe<NoveltyWhereUniqueInput>;
  orderBy?: Array<NoveltyOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: NoveltyWhereInput;
};


export type QueryNoveltiesCountArgs = {
  where?: NoveltyWhereInput;
};


export type QueryNoveltyArgs = {
  where: NoveltyWhereUniqueInput;
};


export type QueryPublicProfileArgs = {
  handle: Scalars['String']['input'];
};


export type QueryPublisherArgs = {
  where: PublisherWhereUniqueInput;
};


export type QueryPublishersArgs = {
  cursor?: InputMaybe<PublisherWhereUniqueInput>;
  orderBy?: Array<PublisherOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PublisherWhereInput;
};


export type QueryPublishersCountArgs = {
  where?: PublisherWhereInput;
};


export type QueryQaUserSearchArgs = {
  search: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReadRecommendationsArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  ignoreOwned?: InputMaybe<Scalars['Boolean']['input']>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  selectionMode?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserReleaseEntryStatusWhereInput>;
};


export type QueryReleaseEntriesArgs = {
  cursor?: InputMaybe<ReleaseEntryWhereUniqueInput>;
  orderBy?: Array<ReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseEntryWhereInput;
};


export type QueryReleaseEntriesCountArgs = {
  where?: ReleaseEntryWhereInput;
};


export type QueryReleaseEntryArgs = {
  where: ReleaseEntryWhereUniqueInput;
};


export type QueryReleaseItemArgs = {
  where: ReleaseItemWhereUniqueInput;
};


export type QueryReleaseItemCollectionArgs = {
  where: ReleaseItemCollectionWhereUniqueInput;
};


export type QueryReleaseItemCollectionsArgs = {
  cursor?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  orderBy?: Array<ReleaseItemCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemCollectionWhereInput;
};


export type QueryReleaseItemCollectionsCountArgs = {
  where?: ReleaseItemCollectionWhereInput;
};


export type QueryReleaseItemsArgs = {
  cursor?: InputMaybe<ReleaseItemWhereUniqueInput>;
  orderBy?: Array<ReleaseItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemWhereInput;
};


export type QueryReleaseItemsCountArgs = {
  where?: ReleaseItemWhereInput;
};


export type QuerySeriesInfoArgs = {
  where: SeriesInfoWhereUniqueInput;
};


export type QuerySeriesInfosArgs = {
  cursor?: InputMaybe<SeriesInfoWhereUniqueInput>;
  orderBy?: Array<SeriesInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SeriesInfoWhereInput;
};


export type QuerySeriesInfosCountArgs = {
  where?: SeriesInfoWhereInput;
};


export type QuerySharedReleaseCollectionArgs = {
  where: SharedReleaseCollectionWhereUniqueInput;
};


export type QuerySharedReleaseCollectionsArgs = {
  cursor?: InputMaybe<SharedReleaseCollectionWhereUniqueInput>;
  orderBy?: Array<SharedReleaseCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SharedReleaseCollectionWhereInput;
};


export type QuerySharedReleaseCollectionsCountArgs = {
  where?: SharedReleaseCollectionWhereInput;
};


export type QuerySizeInfoArgs = {
  where: SizeInfoWhereUniqueInput;
};


export type QuerySizeInfosArgs = {
  cursor?: InputMaybe<SizeInfoWhereUniqueInput>;
  orderBy?: Array<SizeInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SizeInfoWhereInput;
};


export type QuerySizeInfosCountArgs = {
  where?: SizeInfoWhereInput;
};


export type QuerySourceLinkArgs = {
  where: SourceLinkWhereUniqueInput;
};


export type QuerySourceLinksArgs = {
  cursor?: InputMaybe<SourceLinkWhereUniqueInput>;
  orderBy?: Array<SourceLinkOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SourceLinkWhereInput;
};


export type QuerySourceLinksCountArgs = {
  where?: SourceLinkWhereInput;
};


export type QuerySourceSnapshotArgs = {
  where: SourceSnapshotWhereUniqueInput;
};


export type QuerySourceSnapshotsArgs = {
  cursor?: InputMaybe<SourceSnapshotWhereUniqueInput>;
  orderBy?: Array<SourceSnapshotOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SourceSnapshotWhereInput;
};


export type QuerySourceSnapshotsCountArgs = {
  where?: SourceSnapshotWhereInput;
};


export type QuerySourceUpdateArgs = {
  where: SourceUpdateWhereUniqueInput;
};


export type QuerySourceUpdatesArgs = {
  cursor?: InputMaybe<SourceUpdateWhereUniqueInput>;
  orderBy?: Array<SourceUpdateOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SourceUpdateWhereInput;
};


export type QuerySourceUpdatesCountArgs = {
  where?: SourceUpdateWhereInput;
};


export type QueryStaffEntriesArgs = {
  cursor?: InputMaybe<StaffEntryWhereUniqueInput>;
  orderBy?: Array<StaffEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StaffEntryWhereInput;
};


export type QueryStaffEntriesCountArgs = {
  where?: StaffEntryWhereInput;
};


export type QueryStaffEntryArgs = {
  where: StaffEntryWhereUniqueInput;
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: Array<TagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: TagWhereInput;
};


export type QueryTagsCountArgs = {
  where?: TagWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserActiveDayArgs = {
  where: UserActiveDayWhereUniqueInput;
};


export type QueryUserActiveDaysArgs = {
  cursor?: InputMaybe<UserActiveDayWhereUniqueInput>;
  orderBy?: Array<UserActiveDayOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserActiveDayWhereInput;
};


export type QueryUserActiveDaysCountArgs = {
  where?: UserActiveDayWhereInput;
};


export type QueryUserAdminArgs = {
  where: UserAdminWhereUniqueInput;
};


export type QueryUserAdminsArgs = {
  cursor?: InputMaybe<UserAdminWhereUniqueInput>;
  orderBy?: Array<UserAdminOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserAdminWhereInput;
};


export type QueryUserAdminsCountArgs = {
  where?: UserAdminWhereInput;
};


export type QueryUserChangesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceSeq: Scalars['String']['input'];
};


export type QueryUserCollectionStatsArgs = {
  where: UserCollectionStatsWhereUniqueInput;
};


export type QueryUserCollectionStatsItemsArgs = {
  cursor?: InputMaybe<UserCollectionStatsWhereUniqueInput>;
  orderBy?: Array<UserCollectionStatsOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCollectionStatsWhereInput;
};


export type QueryUserCollectionStatsItemsCountArgs = {
  where?: UserCollectionStatsWhereInput;
};


export type QueryUserCustomListArgs = {
  where: UserCustomListWhereUniqueInput;
};


export type QueryUserCustomListNoveltyItemArgs = {
  where: UserCustomListNoveltyItemWhereUniqueInput;
};


export type QueryUserCustomListNoveltyItemsArgs = {
  cursor?: InputMaybe<UserCustomListNoveltyItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListNoveltyItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListNoveltyItemWhereInput;
};


export type QueryUserCustomListNoveltyItemsCountArgs = {
  where?: UserCustomListNoveltyItemWhereInput;
};


export type QueryUserCustomListReleaseEntryItemArgs = {
  where: UserCustomListReleaseEntryItemWhereUniqueInput;
};


export type QueryUserCustomListReleaseEntryItemsArgs = {
  cursor?: InputMaybe<UserCustomListReleaseEntryItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListReleaseEntryItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListReleaseEntryItemWhereInput;
};


export type QueryUserCustomListReleaseEntryItemsCountArgs = {
  where?: UserCustomListReleaseEntryItemWhereInput;
};


export type QueryUserCustomListStatsArgs = {
  listId: Scalars['ID']['input'];
};


export type QueryUserCustomListsArgs = {
  cursor?: InputMaybe<UserCustomListWhereUniqueInput>;
  orderBy?: Array<UserCustomListOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListWhereInput;
};


export type QueryUserCustomListsCountArgs = {
  where?: UserCustomListWhereInput;
};


export type QueryUserImageArgs = {
  where: UserImageWhereUniqueInput;
};


export type QueryUserImagesArgs = {
  cursor?: InputMaybe<UserImageWhereUniqueInput>;
  orderBy?: Array<UserImageOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserImageWhereInput;
};


export type QueryUserImagesCountArgs = {
  where?: UserImageWhereInput;
};


export type QueryUserMiscPossessionActivitiesArgs = {
  cursor?: InputMaybe<UserMiscPossessionActivityWhereUniqueInput>;
  orderBy?: Array<UserMiscPossessionActivityOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserMiscPossessionActivityWhereInput;
};


export type QueryUserMiscPossessionActivitiesCountArgs = {
  where?: UserMiscPossessionActivityWhereInput;
};


export type QueryUserMiscPossessionActivityArgs = {
  where: UserMiscPossessionActivityWhereUniqueInput;
};


export type QueryUserPossessionActivitiesArgs = {
  cursor?: InputMaybe<UserPossessionActivityWhereUniqueInput>;
  orderBy?: Array<UserPossessionActivityOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserPossessionActivityWhereInput;
};


export type QueryUserPossessionActivitiesCountArgs = {
  where?: UserPossessionActivityWhereInput;
};


export type QueryUserPossessionActivityArgs = {
  where: UserPossessionActivityWhereUniqueInput;
};


export type QueryUserPremiumChangeArgs = {
  where: UserPremiumChangeWhereUniqueInput;
};


export type QueryUserPremiumChangesArgs = {
  cursor?: InputMaybe<UserPremiumChangeWhereUniqueInput>;
  orderBy?: Array<UserPremiumChangeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserPremiumChangeWhereInput;
};


export type QueryUserPremiumChangesCountArgs = {
  where?: UserPremiumChangeWhereInput;
};


export type QueryUserReadActivitiesArgs = {
  cursor?: InputMaybe<UserReadActivityWhereUniqueInput>;
  orderBy?: Array<UserReadActivityOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReadActivityWhereInput;
};


export type QueryUserReadActivitiesCountArgs = {
  where?: UserReadActivityWhereInput;
};


export type QueryUserReadActivityArgs = {
  where: UserReadActivityWhereUniqueInput;
};


export type QueryUserReleaseActivitiesArgs = {
  cursor?: InputMaybe<UserReleaseActivityWhereUniqueInput>;
  orderBy?: Array<UserReleaseActivityOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReleaseActivityWhereInput;
};


export type QueryUserReleaseActivitiesCountArgs = {
  where?: UserReleaseActivityWhereInput;
};


export type QueryUserReleaseActivityArgs = {
  where: UserReleaseActivityWhereUniqueInput;
};


export type QueryUserReleaseEntryStatusArgs = {
  where: UserReleaseEntryStatusWhereUniqueInput;
};


export type QueryUserReleaseEntryStatusesArgs = {
  cursor?: InputMaybe<UserReleaseEntryStatusWhereUniqueInput>;
  orderBy?: Array<UserReleaseEntryStatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReleaseEntryStatusWhereInput;
};


export type QueryUserReleaseEntryStatusesCountArgs = {
  where?: UserReleaseEntryStatusWhereInput;
};


export type QueryUserReleaseReadStatusArgs = {
  where: UserReleaseReadStatusWhereUniqueInput;
};


export type QueryUserReleaseReadStatusesArgs = {
  cursor?: InputMaybe<UserReleaseReadStatusWhereUniqueInput>;
  orderBy?: Array<UserReleaseReadStatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReleaseReadStatusWhereInput;
};


export type QueryUserReleaseReadStatusesCountArgs = {
  where?: UserReleaseReadStatusWhereInput;
};


export type QueryUserStatsDailyFactArgs = {
  where: UserStatsDailyFactWhereUniqueInput;
};


export type QueryUserStatsDailyFactsArgs = {
  cursor?: InputMaybe<UserStatsDailyFactWhereUniqueInput>;
  orderBy?: Array<UserStatsDailyFactOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserStatsDailyFactWhereInput;
};


export type QueryUserStatsDailyFactsCountArgs = {
  where?: UserStatsDailyFactWhereInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryVlbUpdateConfigArgs = {
  where: VlbUpdateConfigWhereUniqueInput;
};


export type QueryVlbUpdateConfigsArgs = {
  cursor?: InputMaybe<VlbUpdateConfigWhereUniqueInput>;
  orderBy?: Array<VlbUpdateConfigOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: VlbUpdateConfigWhereInput;
};


export type QueryVlbUpdateConfigsCountArgs = {
  where?: VlbUpdateConfigWhereInput;
};


export type QueryVolumeSuffixArgs = {
  where: VolumeSuffixWhereUniqueInput;
};


export type QueryVolumeSuffixesArgs = {
  cursor?: InputMaybe<VolumeSuffixWhereUniqueInput>;
  orderBy?: Array<VolumeSuffixOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: VolumeSuffixWhereInput;
};


export type QueryVolumeSuffixesCountArgs = {
  where?: VolumeSuffixWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type ReadRecommendation = {
  __typename?: 'ReadRecommendation';
  entryId: Scalars['ID']['output'];
  statusId: Scalars['ID']['output'];
  volumeNumbers: Array<Scalars['String']['output']>;
};

export type ReleaseEntry = {
  __typename?: 'ReleaseEntry';
  cover?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  curatedListMemberships?: Maybe<Array<DatabaseListReleaseEntry>>;
  curatedListMembershipsCount?: Maybe<Scalars['Int']['output']>;
  demographySearchField?: Maybe<Scalars['String']['output']>;
  description?: Maybe<ReleaseEntry_Description_Document>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['CalendarDay']['output']>;
  firstVolumeNumber?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Array<MaterialInfo>>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  needsToBeCheckedReason?: Maybe<Scalars['String']['output']>;
  notReleasedVolumeNumbers?: Maybe<Scalars['JSON']['output']>;
  popularityScore?: Maybe<Scalars['Decimal']['output']>;
  publisher?: Maybe<Publisher>;
  publisherHistory?: Maybe<Scalars['JSON']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  recommendationScore?: Maybe<Scalars['Decimal']['output']>;
  releaseCollections?: Maybe<Array<ReleaseItemCollection>>;
  releaseCollectionsCount?: Maybe<Scalars['Int']['output']>;
  releaseItems?: Maybe<Array<ReleaseItem>>;
  releaseItemsCount?: Maybe<Scalars['Int']['output']>;
  releaseMonth?: Maybe<Scalars['Int']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seriesInfo?: Maybe<SeriesInfo>;
  size?: Maybe<SizeInfo>;
  sortedVolumeNumbers?: Maybe<Scalars['JSON']['output']>;
  staffs?: Maybe<Array<StaffEntry>>;
  staffsCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['CalendarDay']['output']>;
  status?: Maybe<ReleaseEntryStatusType>;
  tagSearchField?: Maybe<Scalars['String']['output']>;
  thumbHash?: Maybe<Scalars['String']['output']>;
  titleSearch?: Maybe<Scalars['String']['output']>;
  totalNotReleasedVolumes?: Maybe<Scalars['Int']['output']>;
  totalReleasedVolumes?: Maybe<Scalars['Int']['output']>;
  totalVolumes?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ReleaseEntryTypeType>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  userCuratedListMemberships?: Maybe<Array<UserCustomListReleaseEntryItem>>;
  userCuratedListMembershipsCount?: Maybe<Scalars['Int']['output']>;
  yearMonthKey?: Maybe<Scalars['String']['output']>;
};


export type ReleaseEntryCuratedListMembershipsArgs = {
  cursor?: InputMaybe<DatabaseListReleaseEntryWhereUniqueInput>;
  orderBy?: Array<DatabaseListReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DatabaseListReleaseEntryWhereInput;
};


export type ReleaseEntryCuratedListMembershipsCountArgs = {
  where?: DatabaseListReleaseEntryWhereInput;
};


export type ReleaseEntryMaterialArgs = {
  cursor?: InputMaybe<MaterialInfoWhereUniqueInput>;
  orderBy?: Array<MaterialInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MaterialInfoWhereInput;
};


export type ReleaseEntryMaterialCountArgs = {
  where?: MaterialInfoWhereInput;
};


export type ReleaseEntryReleaseCollectionsArgs = {
  cursor?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  orderBy?: Array<ReleaseItemCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemCollectionWhereInput;
};


export type ReleaseEntryReleaseCollectionsCountArgs = {
  where?: ReleaseItemCollectionWhereInput;
};


export type ReleaseEntryReleaseItemsArgs = {
  cursor?: InputMaybe<ReleaseItemWhereUniqueInput>;
  orderBy?: Array<ReleaseItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemWhereInput;
};


export type ReleaseEntryReleaseItemsCountArgs = {
  where?: ReleaseItemWhereInput;
};


export type ReleaseEntryStaffsArgs = {
  cursor?: InputMaybe<StaffEntryWhereUniqueInput>;
  orderBy?: Array<StaffEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StaffEntryWhereInput;
};


export type ReleaseEntryStaffsCountArgs = {
  where?: StaffEntryWhereInput;
};


export type ReleaseEntryUserCuratedListMembershipsArgs = {
  cursor?: InputMaybe<UserCustomListReleaseEntryItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListReleaseEntryItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListReleaseEntryItemWhereInput;
};


export type ReleaseEntryUserCuratedListMembershipsCountArgs = {
  where?: UserCustomListReleaseEntryItemWhereInput;
};

export type ReleaseEntryCreateInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  curatedListMemberships?: InputMaybe<DatabaseListReleaseEntryRelateToManyForCreateInput>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  firstVolumeNumber?: InputMaybe<Scalars['Decimal']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<MaterialInfoRelateToManyForCreateInput>;
  needsToBeCheckedReason?: InputMaybe<Scalars['String']['input']>;
  notReleasedVolumeNumbers?: InputMaybe<Scalars['JSON']['input']>;
  popularityScore?: InputMaybe<Scalars['Decimal']['input']>;
  publisher?: InputMaybe<PublisherRelateToOneForCreateInput>;
  publisherHistory?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  recommendationScore?: InputMaybe<Scalars['Decimal']['input']>;
  releaseCollections?: InputMaybe<ReleaseItemCollectionRelateToManyForCreateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForCreateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  seriesInfo?: InputMaybe<SeriesInfoRelateToOneForCreateInput>;
  size?: InputMaybe<SizeInfoRelateToOneForCreateInput>;
  sortedVolumeNumbers?: InputMaybe<Scalars['JSON']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForCreateInput>;
  startDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  status?: InputMaybe<ReleaseEntryStatusType>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  totalNotReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalVolumes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReleaseEntryTypeType>;
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  userCuratedListMemberships?: InputMaybe<UserCustomListReleaseEntryItemRelateToManyForCreateInput>;
  yearMonthKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseEntryManyRelationFilter = {
  every?: InputMaybe<ReleaseEntryWhereInput>;
  none?: InputMaybe<ReleaseEntryWhereInput>;
  some?: InputMaybe<ReleaseEntryWhereInput>;
};

export type ReleaseEntryOrderByInput = {
  cover?: InputMaybe<OrderDirection>;
  creationDate?: InputMaybe<OrderDirection>;
  demographySearchField?: InputMaybe<OrderDirection>;
  disabled?: InputMaybe<OrderDirection>;
  endDate?: InputMaybe<OrderDirection>;
  firstVolumeNumber?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  internalName?: InputMaybe<OrderDirection>;
  needsToBeCheckedReason?: InputMaybe<OrderDirection>;
  popularityScore?: InputMaybe<OrderDirection>;
  publisherName?: InputMaybe<OrderDirection>;
  recommendationScore?: InputMaybe<OrderDirection>;
  releaseMonth?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  startDate?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  tagSearchField?: InputMaybe<OrderDirection>;
  thumbHash?: InputMaybe<OrderDirection>;
  titleSearch?: InputMaybe<OrderDirection>;
  totalNotReleasedVolumes?: InputMaybe<OrderDirection>;
  totalReleasedVolumes?: InputMaybe<OrderDirection>;
  totalVolumes?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  updatedDate?: InputMaybe<OrderDirection>;
  yearMonthKey?: InputMaybe<OrderDirection>;
};

export type ReleaseEntryRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ReleaseEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseEntryCreateInput>>;
};

export type ReleaseEntryRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ReleaseEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseEntryCreateInput>>;
  disconnect?: InputMaybe<Array<ReleaseEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<ReleaseEntryWhereUniqueInput>>;
};

export type ReleaseEntryRelateToOneForCreateInput = {
  connect?: InputMaybe<ReleaseEntryWhereUniqueInput>;
  create?: InputMaybe<ReleaseEntryCreateInput>;
};

export type ReleaseEntryRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReleaseEntryWhereUniqueInput>;
  create?: InputMaybe<ReleaseEntryCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReleaseEntryStatusType {
  Canceled = 'canceled',
  Done = 'done',
  Paused = 'paused',
  Running = 'running'
}

export type ReleaseEntryStatusTypeNullableFilter = {
  equals?: InputMaybe<ReleaseEntryStatusType>;
  in?: InputMaybe<Array<ReleaseEntryStatusType>>;
  not?: InputMaybe<ReleaseEntryStatusTypeNullableFilter>;
  notIn?: InputMaybe<Array<ReleaseEntryStatusType>>;
};

export enum ReleaseEntryTypeType {
  AnimeComic = 'animeComic',
  Artbook = 'artbook',
  Lnovel = 'lnovel',
  Magazine = 'magazine',
  Manga = 'manga',
  Manhua = 'manhua',
  Manhwa = 'manhwa'
}

export type ReleaseEntryTypeTypeNullableFilter = {
  equals?: InputMaybe<ReleaseEntryTypeType>;
  in?: InputMaybe<Array<ReleaseEntryTypeType>>;
  not?: InputMaybe<ReleaseEntryTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<ReleaseEntryTypeType>>;
};

export type ReleaseEntryUpdateArgs = {
  data: ReleaseEntryUpdateInput;
  where: ReleaseEntryWhereUniqueInput;
};

export type ReleaseEntryUpdateInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  curatedListMemberships?: InputMaybe<DatabaseListReleaseEntryRelateToManyForUpdateInput>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  firstVolumeNumber?: InputMaybe<Scalars['Decimal']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<MaterialInfoRelateToManyForUpdateInput>;
  needsToBeCheckedReason?: InputMaybe<Scalars['String']['input']>;
  notReleasedVolumeNumbers?: InputMaybe<Scalars['JSON']['input']>;
  popularityScore?: InputMaybe<Scalars['Decimal']['input']>;
  publisher?: InputMaybe<PublisherRelateToOneForUpdateInput>;
  publisherHistory?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  recommendationScore?: InputMaybe<Scalars['Decimal']['input']>;
  releaseCollections?: InputMaybe<ReleaseItemCollectionRelateToManyForUpdateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForUpdateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  seriesInfo?: InputMaybe<SeriesInfoRelateToOneForUpdateInput>;
  size?: InputMaybe<SizeInfoRelateToOneForUpdateInput>;
  sortedVolumeNumbers?: InputMaybe<Scalars['JSON']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForUpdateInput>;
  startDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  status?: InputMaybe<ReleaseEntryStatusType>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  totalNotReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalVolumes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReleaseEntryTypeType>;
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  userCuratedListMemberships?: InputMaybe<UserCustomListReleaseEntryItemRelateToManyForUpdateInput>;
  yearMonthKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseEntryWhereInput = {
  AND?: InputMaybe<Array<ReleaseEntryWhereInput>>;
  NOT?: InputMaybe<Array<ReleaseEntryWhereInput>>;
  OR?: InputMaybe<Array<ReleaseEntryWhereInput>>;
  cover?: InputMaybe<StringFilter>;
  creationDate?: InputMaybe<DateTimeNullableFilter>;
  curatedListMemberships?: InputMaybe<DatabaseListReleaseEntryManyRelationFilter>;
  demographySearchField?: InputMaybe<StringFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  endDate?: InputMaybe<CalendarDayNullableFilter>;
  firstVolumeNumber?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IdFilter>;
  internalName?: InputMaybe<StringFilter>;
  material?: InputMaybe<MaterialInfoManyRelationFilter>;
  needsToBeCheckedReason?: InputMaybe<StringNullableFilter>;
  popularityScore?: InputMaybe<DecimalNullableFilter>;
  publisher?: InputMaybe<PublisherWhereInput>;
  publisherName?: InputMaybe<StringFilter>;
  recommendationScore?: InputMaybe<DecimalNullableFilter>;
  releaseCollections?: InputMaybe<ReleaseItemCollectionManyRelationFilter>;
  releaseItems?: InputMaybe<ReleaseItemManyRelationFilter>;
  releaseMonth?: InputMaybe<IntNullableFilter>;
  releaseYear?: InputMaybe<IntNullableFilter>;
  seriesInfo?: InputMaybe<SeriesInfoWhereInput>;
  size?: InputMaybe<SizeInfoWhereInput>;
  staffs?: InputMaybe<StaffEntryManyRelationFilter>;
  startDate?: InputMaybe<CalendarDayNullableFilter>;
  status?: InputMaybe<ReleaseEntryStatusTypeNullableFilter>;
  tagSearchField?: InputMaybe<StringFilter>;
  thumbHash?: InputMaybe<StringNullableFilter>;
  titleSearch?: InputMaybe<StringFilter>;
  totalNotReleasedVolumes?: InputMaybe<IntNullableFilter>;
  totalReleasedVolumes?: InputMaybe<IntNullableFilter>;
  totalVolumes?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<ReleaseEntryTypeTypeNullableFilter>;
  updatedDate?: InputMaybe<DateTimeNullableFilter>;
  userCuratedListMemberships?: InputMaybe<UserCustomListReleaseEntryItemManyRelationFilter>;
  yearMonthKey?: InputMaybe<StringFilter>;
};

export type ReleaseEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReleaseEntry_Description_Document = {
  __typename?: 'ReleaseEntry_description_Document';
  document: Scalars['JSON']['output'];
};


export type ReleaseEntry_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type ReleaseItem = {
  __typename?: 'ReleaseItem';
  collections?: Maybe<Array<ReleaseItemCollection>>;
  collectionsCount?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  currentEditionNumber?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<ReleaseItem_Description_Document>;
  disableNovelty?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Extra>>;
  extrasCount?: Maybe<Scalars['Int']['output']>;
  extrasNote?: Maybe<Scalars['String']['output']>;
  extrasOnlyOnFirstEdition?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  localizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  needsToBeCheckedReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Decimal']['output']>;
  originalCover?: Maybe<Scalars['String']['output']>;
  originalIsbn?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  publisherDescription?: Maybe<ReleaseItem_PublisherDescription_Document>;
  publisherName?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['CalendarDay']['output']>;
  releaseDateAccuracy?: Maybe<ReleaseItemReleaseDateAccuracyType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseMonth?: Maybe<Scalars['Int']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  romanizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  staffs?: Maybe<Array<StaffEntry>>;
  staffsCount?: Maybe<Scalars['Int']['output']>;
  tagSearchField?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
  thumbHash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  volumeSuffix?: Maybe<Scalars['String']['output']>;
  yearMonthKey?: Maybe<Scalars['String']['output']>;
};


export type ReleaseItemCollectionsArgs = {
  cursor?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  orderBy?: Array<ReleaseItemCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemCollectionWhereInput;
};


export type ReleaseItemCollectionsCountArgs = {
  where?: ReleaseItemCollectionWhereInput;
};


export type ReleaseItemExtrasArgs = {
  cursor?: InputMaybe<ExtraWhereUniqueInput>;
  orderBy?: Array<ExtraOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ExtraWhereInput;
};


export type ReleaseItemExtrasCountArgs = {
  where?: ExtraWhereInput;
};


export type ReleaseItemStaffsArgs = {
  cursor?: InputMaybe<StaffEntryWhereUniqueInput>;
  orderBy?: Array<StaffEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StaffEntryWhereInput;
};


export type ReleaseItemStaffsCountArgs = {
  where?: StaffEntryWhereInput;
};


export type ReleaseItemTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: Array<TagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: TagWhereInput;
};


export type ReleaseItemTagsCountArgs = {
  where?: TagWhereInput;
};

export type ReleaseItemCollection = {
  __typename?: 'ReleaseItemCollection';
  color?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  currentEditionNumber?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<ReleaseItemCollection_Description_Document>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  extrasNote?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  itemsOnlyExistInThisCollection?: Maybe<Scalars['Boolean']['output']>;
  localizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Decimal']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  publisherDescription?: Maybe<ReleaseItemCollection_PublisherDescription_Document>;
  publisherName?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['CalendarDay']['output']>;
  releaseDateAccuracy?: Maybe<ReleaseItemCollectionReleaseDateAccuracyType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseItems?: Maybe<Array<ReleaseItem>>;
  releaseItemsCount?: Maybe<Scalars['Int']['output']>;
  releaseMonth?: Maybe<Scalars['Int']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  romanizedSeriesTitle?: Maybe<Scalars['String']['output']>;
  sharedGroup?: Maybe<SharedReleaseCollection>;
  size?: Maybe<Scalars['String']['output']>;
  tagSearchField?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
  thumbHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  volumeSuffix?: Maybe<Scalars['String']['output']>;
};


export type ReleaseItemCollectionReleaseItemsArgs = {
  cursor?: InputMaybe<ReleaseItemWhereUniqueInput>;
  orderBy?: Array<ReleaseItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemWhereInput;
};


export type ReleaseItemCollectionReleaseItemsCountArgs = {
  where?: ReleaseItemWhereInput;
};


export type ReleaseItemCollectionTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: Array<TagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: TagWhereInput;
};


export type ReleaseItemCollectionTagsCountArgs = {
  where?: TagWhereInput;
};

export type ReleaseItemCollectionCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  currentEditionNumber?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  extrasNote?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  itemsOnlyExistInThisCollection?: InputMaybe<Scalars['Boolean']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherDescription?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemCollectionReleaseDateAccuracyType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForCreateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  sharedGroup?: InputMaybe<SharedReleaseCollectionRelateToOneForCreateInput>;
  size?: InputMaybe<Scalars['String']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagRelateToManyForCreateInput>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseItemCollectionManyRelationFilter = {
  every?: InputMaybe<ReleaseItemCollectionWhereInput>;
  none?: InputMaybe<ReleaseItemCollectionWhereInput>;
  some?: InputMaybe<ReleaseItemCollectionWhereInput>;
};

export type ReleaseItemCollectionOrderByInput = {
  color?: InputMaybe<OrderDirection>;
  cover?: InputMaybe<OrderDirection>;
  currentEditionNumber?: InputMaybe<OrderDirection>;
  disabled?: InputMaybe<OrderDirection>;
  entryId?: InputMaybe<OrderDirection>;
  extrasNote?: InputMaybe<OrderDirection>;
  format?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isbn?: InputMaybe<OrderDirection>;
  itemsOnlyExistInThisCollection?: InputMaybe<OrderDirection>;
  localizedSeriesTitle?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  notes?: InputMaybe<OrderDirection>;
  number?: InputMaybe<OrderDirection>;
  pages?: InputMaybe<OrderDirection>;
  price?: InputMaybe<OrderDirection>;
  publisherName?: InputMaybe<OrderDirection>;
  releaseDate?: InputMaybe<OrderDirection>;
  releaseDateAccuracy?: InputMaybe<OrderDirection>;
  releaseMonth?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  romanizedSeriesTitle?: InputMaybe<OrderDirection>;
  size?: InputMaybe<OrderDirection>;
  tagSearchField?: InputMaybe<OrderDirection>;
  thumbHash?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  volumeSuffix?: InputMaybe<OrderDirection>;
};

export type ReleaseItemCollectionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ReleaseItemCollectionWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseItemCollectionCreateInput>>;
};

export type ReleaseItemCollectionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ReleaseItemCollectionWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseItemCollectionCreateInput>>;
  disconnect?: InputMaybe<Array<ReleaseItemCollectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ReleaseItemCollectionWhereUniqueInput>>;
};

export type ReleaseItemCollectionRelateToOneForCreateInput = {
  connect?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  create?: InputMaybe<ReleaseItemCollectionCreateInput>;
};

export type ReleaseItemCollectionRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  create?: InputMaybe<ReleaseItemCollectionCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReleaseItemCollectionReleaseDateAccuracyType {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}

export type ReleaseItemCollectionReleaseDateAccuracyTypeNullableFilter = {
  equals?: InputMaybe<ReleaseItemCollectionReleaseDateAccuracyType>;
  in?: InputMaybe<Array<ReleaseItemCollectionReleaseDateAccuracyType>>;
  not?: InputMaybe<ReleaseItemCollectionReleaseDateAccuracyTypeNullableFilter>;
  notIn?: InputMaybe<Array<ReleaseItemCollectionReleaseDateAccuracyType>>;
};

export type ReleaseItemCollectionUpdateArgs = {
  data: ReleaseItemCollectionUpdateInput;
  where: ReleaseItemCollectionWhereUniqueInput;
};

export type ReleaseItemCollectionUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  currentEditionNumber?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  extrasNote?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  itemsOnlyExistInThisCollection?: InputMaybe<Scalars['Boolean']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherDescription?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemCollectionReleaseDateAccuracyType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForUpdateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  sharedGroup?: InputMaybe<SharedReleaseCollectionRelateToOneForUpdateInput>;
  size?: InputMaybe<Scalars['String']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagRelateToManyForUpdateInput>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseItemCollectionWhereInput = {
  AND?: InputMaybe<Array<ReleaseItemCollectionWhereInput>>;
  NOT?: InputMaybe<Array<ReleaseItemCollectionWhereInput>>;
  OR?: InputMaybe<Array<ReleaseItemCollectionWhereInput>>;
  color?: InputMaybe<StringFilter>;
  cover?: InputMaybe<StringFilter>;
  currentEditionNumber?: InputMaybe<IntNullableFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  entryId?: InputMaybe<StringFilter>;
  extrasNote?: InputMaybe<StringFilter>;
  format?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isbn?: InputMaybe<StringFilter>;
  itemsOnlyExistInThisCollection?: InputMaybe<BooleanFilter>;
  localizedSeriesTitle?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringFilter>;
  number?: InputMaybe<DecimalNullableFilter>;
  pages?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  publisherName?: InputMaybe<StringFilter>;
  releaseDate?: InputMaybe<CalendarDayNullableFilter>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemCollectionReleaseDateAccuracyTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  releaseItems?: InputMaybe<ReleaseItemManyRelationFilter>;
  releaseMonth?: InputMaybe<IntNullableFilter>;
  releaseYear?: InputMaybe<IntNullableFilter>;
  romanizedSeriesTitle?: InputMaybe<StringFilter>;
  sharedGroup?: InputMaybe<SharedReleaseCollectionWhereInput>;
  size?: InputMaybe<StringFilter>;
  tagSearchField?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagManyRelationFilter>;
  thumbHash?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  volumeSuffix?: InputMaybe<StringNullableFilter>;
};

export type ReleaseItemCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReleaseItemCollection_Description_Document = {
  __typename?: 'ReleaseItemCollection_description_Document';
  document: Scalars['JSON']['output'];
};


export type ReleaseItemCollection_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type ReleaseItemCollection_PublisherDescription_Document = {
  __typename?: 'ReleaseItemCollection_publisherDescription_Document';
  document: Scalars['JSON']['output'];
};


export type ReleaseItemCollection_PublisherDescription_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type ReleaseItemCreateInput = {
  collections?: InputMaybe<ReleaseItemCollectionRelateToManyForCreateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentEditionNumber?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disableNovelty?: InputMaybe<Scalars['Boolean']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<ExtraRelateToManyForCreateInput>;
  extrasNote?: InputMaybe<Scalars['String']['input']>;
  extrasOnlyOnFirstEdition?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  needsToBeCheckedReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  originalCover?: InputMaybe<Scalars['String']['input']>;
  originalIsbn?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherDescription?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemReleaseDateAccuracyType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForCreateInput>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagRelateToManyForCreateInput>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
  yearMonthKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseItemManyRelationFilter = {
  every?: InputMaybe<ReleaseItemWhereInput>;
  none?: InputMaybe<ReleaseItemWhereInput>;
  some?: InputMaybe<ReleaseItemWhereInput>;
};

export type ReleaseItemOrderByInput = {
  color?: InputMaybe<OrderDirection>;
  cover?: InputMaybe<OrderDirection>;
  creationDate?: InputMaybe<OrderDirection>;
  currentEditionNumber?: InputMaybe<OrderDirection>;
  disableNovelty?: InputMaybe<OrderDirection>;
  disabled?: InputMaybe<OrderDirection>;
  entryId?: InputMaybe<OrderDirection>;
  extrasNote?: InputMaybe<OrderDirection>;
  extrasOnlyOnFirstEdition?: InputMaybe<OrderDirection>;
  format?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isbn?: InputMaybe<OrderDirection>;
  localizedSeriesTitle?: InputMaybe<OrderDirection>;
  needsToBeCheckedReason?: InputMaybe<OrderDirection>;
  notes?: InputMaybe<OrderDirection>;
  number?: InputMaybe<OrderDirection>;
  originalCover?: InputMaybe<OrderDirection>;
  originalIsbn?: InputMaybe<OrderDirection>;
  pages?: InputMaybe<OrderDirection>;
  price?: InputMaybe<OrderDirection>;
  publisherName?: InputMaybe<OrderDirection>;
  releaseDate?: InputMaybe<OrderDirection>;
  releaseDateAccuracy?: InputMaybe<OrderDirection>;
  releaseMonth?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  romanizedSeriesTitle?: InputMaybe<OrderDirection>;
  size?: InputMaybe<OrderDirection>;
  tagSearchField?: InputMaybe<OrderDirection>;
  thumbHash?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  updatedDate?: InputMaybe<OrderDirection>;
  volumeSuffix?: InputMaybe<OrderDirection>;
  yearMonthKey?: InputMaybe<OrderDirection>;
};

export type ReleaseItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ReleaseItemWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseItemCreateInput>>;
};

export type ReleaseItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ReleaseItemWhereUniqueInput>>;
  create?: InputMaybe<Array<ReleaseItemCreateInput>>;
  disconnect?: InputMaybe<Array<ReleaseItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ReleaseItemWhereUniqueInput>>;
};

export enum ReleaseItemReleaseDateAccuracyType {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}

export type ReleaseItemReleaseDateAccuracyTypeNullableFilter = {
  equals?: InputMaybe<ReleaseItemReleaseDateAccuracyType>;
  in?: InputMaybe<Array<ReleaseItemReleaseDateAccuracyType>>;
  not?: InputMaybe<ReleaseItemReleaseDateAccuracyTypeNullableFilter>;
  notIn?: InputMaybe<Array<ReleaseItemReleaseDateAccuracyType>>;
};

export type ReleaseItemUpdateArgs = {
  data: ReleaseItemUpdateInput;
  where: ReleaseItemWhereUniqueInput;
};

export type ReleaseItemUpdateInput = {
  collections?: InputMaybe<ReleaseItemCollectionRelateToManyForUpdateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentEditionNumber?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disableNovelty?: InputMaybe<Scalars['Boolean']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<ExtraRelateToManyForUpdateInput>;
  extrasNote?: InputMaybe<Scalars['String']['input']>;
  extrasOnlyOnFirstEdition?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  localizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  needsToBeCheckedReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  originalCover?: InputMaybe<Scalars['String']['input']>;
  originalIsbn?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherDescription?: InputMaybe<Scalars['JSON']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemReleaseDateAccuracyType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  releaseMonth?: InputMaybe<Scalars['Int']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  romanizedSeriesTitle?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForUpdateInput>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagRelateToManyForUpdateInput>;
  thumbHash?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  volumeSuffix?: InputMaybe<Scalars['String']['input']>;
  yearMonthKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseItemWhereInput = {
  AND?: InputMaybe<Array<ReleaseItemWhereInput>>;
  NOT?: InputMaybe<Array<ReleaseItemWhereInput>>;
  OR?: InputMaybe<Array<ReleaseItemWhereInput>>;
  collections?: InputMaybe<ReleaseItemCollectionManyRelationFilter>;
  color?: InputMaybe<StringFilter>;
  cover?: InputMaybe<StringFilter>;
  creationDate?: InputMaybe<DateTimeNullableFilter>;
  currentEditionNumber?: InputMaybe<IntNullableFilter>;
  disableNovelty?: InputMaybe<BooleanFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  entryId?: InputMaybe<StringFilter>;
  extras?: InputMaybe<ExtraManyRelationFilter>;
  extrasNote?: InputMaybe<StringFilter>;
  extrasOnlyOnFirstEdition?: InputMaybe<BooleanFilter>;
  format?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isbn?: InputMaybe<StringFilter>;
  localizedSeriesTitle?: InputMaybe<StringFilter>;
  needsToBeCheckedReason?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringFilter>;
  number?: InputMaybe<DecimalFilter>;
  originalCover?: InputMaybe<StringFilter>;
  originalIsbn?: InputMaybe<StringFilter>;
  pages?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  publisherName?: InputMaybe<StringFilter>;
  releaseDate?: InputMaybe<CalendarDayNullableFilter>;
  releaseDateAccuracy?: InputMaybe<ReleaseItemReleaseDateAccuracyTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  releaseMonth?: InputMaybe<IntNullableFilter>;
  releaseYear?: InputMaybe<IntNullableFilter>;
  romanizedSeriesTitle?: InputMaybe<StringFilter>;
  size?: InputMaybe<StringFilter>;
  staffs?: InputMaybe<StaffEntryManyRelationFilter>;
  tagSearchField?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagManyRelationFilter>;
  thumbHash?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DateTimeNullableFilter>;
  volumeSuffix?: InputMaybe<StringNullableFilter>;
  yearMonthKey?: InputMaybe<StringFilter>;
};

export type ReleaseItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReleaseItem_Description_Document = {
  __typename?: 'ReleaseItem_description_Document';
  document: Scalars['JSON']['output'];
};


export type ReleaseItem_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type ReleaseItem_PublisherDescription_Document = {
  __typename?: 'ReleaseItem_publisherDescription_Document';
  document: Scalars['JSON']['output'];
};


export type ReleaseItem_PublisherDescription_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type SendTestNotificationResult = {
  __typename?: 'SendTestNotificationResult';
  description: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  invalidTokensRemoved: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  notificationCreated: Scalars['Boolean']['output'];
  pushSent: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  tokenCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type SendTestScannedItemInput = {
  collectionKind?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
  itemNumber: Scalars['String']['input'];
  itemType: Scalars['String']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
  volumeSuffixId?: InputMaybe<Scalars['ID']['input']>;
};

export type SeriesInfo = {
  __typename?: 'SeriesInfo';
  country?: Maybe<Scalars['String']['output']>;
  demography?: Maybe<Array<Demography>>;
  demographyCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<SeriesInfo_Description_Document>;
  id: Scalars['ID']['output'];
  jpPublishers?: Maybe<Array<JpPublisher>>;
  jpPublishersCount?: Maybe<Scalars['Int']['output']>;
  magazines?: Maybe<Array<Magazine>>;
  magazinesCount?: Maybe<Scalars['Int']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  releases?: Maybe<Array<ReleaseEntry>>;
  releasesCount?: Maybe<Scalars['Int']['output']>;
  romanizedTitle?: Maybe<Scalars['String']['output']>;
  staffs?: Maybe<Array<StaffEntry>>;
  staffsCount?: Maybe<Scalars['Int']['output']>;
  startYear?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SeriesInfoStatusType>;
  tags?: Maybe<Array<Tag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<SeriesInfoTypeType>;
};


export type SeriesInfoDemographyArgs = {
  cursor?: InputMaybe<DemographyWhereUniqueInput>;
  orderBy?: Array<DemographyOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DemographyWhereInput;
};


export type SeriesInfoDemographyCountArgs = {
  where?: DemographyWhereInput;
};


export type SeriesInfoJpPublishersArgs = {
  cursor?: InputMaybe<JpPublisherWhereUniqueInput>;
  orderBy?: Array<JpPublisherOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: JpPublisherWhereInput;
};


export type SeriesInfoJpPublishersCountArgs = {
  where?: JpPublisherWhereInput;
};


export type SeriesInfoMagazinesArgs = {
  cursor?: InputMaybe<MagazineWhereUniqueInput>;
  orderBy?: Array<MagazineOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MagazineWhereInput;
};


export type SeriesInfoMagazinesCountArgs = {
  where?: MagazineWhereInput;
};


export type SeriesInfoReleasesArgs = {
  cursor?: InputMaybe<ReleaseEntryWhereUniqueInput>;
  orderBy?: Array<ReleaseEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseEntryWhereInput;
};


export type SeriesInfoReleasesCountArgs = {
  where?: ReleaseEntryWhereInput;
};


export type SeriesInfoStaffsArgs = {
  cursor?: InputMaybe<StaffEntryWhereUniqueInput>;
  orderBy?: Array<StaffEntryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StaffEntryWhereInput;
};


export type SeriesInfoStaffsCountArgs = {
  where?: StaffEntryWhereInput;
};


export type SeriesInfoTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: Array<TagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: TagWhereInput;
};


export type SeriesInfoTagsCountArgs = {
  where?: TagWhereInput;
};

export type SeriesInfoCreateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  demography?: InputMaybe<DemographyRelateToManyForCreateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  jpPublishers?: InputMaybe<JpPublisherRelateToManyForCreateInput>;
  magazines?: InputMaybe<MagazineRelateToManyForCreateInput>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  releases?: InputMaybe<ReleaseEntryRelateToManyForCreateInput>;
  romanizedTitle?: InputMaybe<Scalars['String']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForCreateInput>;
  startYear?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SeriesInfoStatusType>;
  tags?: InputMaybe<TagRelateToManyForCreateInput>;
  type?: InputMaybe<SeriesInfoTypeType>;
};

export type SeriesInfoManyRelationFilter = {
  every?: InputMaybe<SeriesInfoWhereInput>;
  none?: InputMaybe<SeriesInfoWhereInput>;
  some?: InputMaybe<SeriesInfoWhereInput>;
};

export type SeriesInfoOrderByInput = {
  country?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  originalTitle?: InputMaybe<OrderDirection>;
  romanizedTitle?: InputMaybe<OrderDirection>;
  startYear?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type SeriesInfoRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<SeriesInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<SeriesInfoCreateInput>>;
};

export type SeriesInfoRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<SeriesInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<SeriesInfoCreateInput>>;
  disconnect?: InputMaybe<Array<SeriesInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<SeriesInfoWhereUniqueInput>>;
};

export type SeriesInfoRelateToOneForCreateInput = {
  connect?: InputMaybe<SeriesInfoWhereUniqueInput>;
  create?: InputMaybe<SeriesInfoCreateInput>;
};

export type SeriesInfoRelateToOneForUpdateInput = {
  connect?: InputMaybe<SeriesInfoWhereUniqueInput>;
  create?: InputMaybe<SeriesInfoCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SeriesInfoStatusType {
  Canceled = 'canceled',
  Completed = 'completed',
  Running = 'running'
}

export type SeriesInfoStatusTypeNullableFilter = {
  equals?: InputMaybe<SeriesInfoStatusType>;
  in?: InputMaybe<Array<SeriesInfoStatusType>>;
  not?: InputMaybe<SeriesInfoStatusTypeNullableFilter>;
  notIn?: InputMaybe<Array<SeriesInfoStatusType>>;
};

export enum SeriesInfoTypeType {
  AnimeComic = 'animeComic',
  Artbook = 'artbook',
  Lnovel = 'lnovel',
  Magazine = 'magazine',
  Manga = 'manga',
  Manhua = 'manhua',
  Manhwa = 'manhwa'
}

export type SeriesInfoTypeTypeNullableFilter = {
  equals?: InputMaybe<SeriesInfoTypeType>;
  in?: InputMaybe<Array<SeriesInfoTypeType>>;
  not?: InputMaybe<SeriesInfoTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<SeriesInfoTypeType>>;
};

export type SeriesInfoUpdateArgs = {
  data: SeriesInfoUpdateInput;
  where: SeriesInfoWhereUniqueInput;
};

export type SeriesInfoUpdateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  demography?: InputMaybe<DemographyRelateToManyForUpdateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  jpPublishers?: InputMaybe<JpPublisherRelateToManyForUpdateInput>;
  magazines?: InputMaybe<MagazineRelateToManyForUpdateInput>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  releases?: InputMaybe<ReleaseEntryRelateToManyForUpdateInput>;
  romanizedTitle?: InputMaybe<Scalars['String']['input']>;
  staffs?: InputMaybe<StaffEntryRelateToManyForUpdateInput>;
  startYear?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SeriesInfoStatusType>;
  tags?: InputMaybe<TagRelateToManyForUpdateInput>;
  type?: InputMaybe<SeriesInfoTypeType>;
};

export type SeriesInfoWhereInput = {
  AND?: InputMaybe<Array<SeriesInfoWhereInput>>;
  NOT?: InputMaybe<Array<SeriesInfoWhereInput>>;
  OR?: InputMaybe<Array<SeriesInfoWhereInput>>;
  country?: InputMaybe<StringFilter>;
  demography?: InputMaybe<DemographyManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  jpPublishers?: InputMaybe<JpPublisherManyRelationFilter>;
  magazines?: InputMaybe<MagazineManyRelationFilter>;
  originalTitle?: InputMaybe<StringFilter>;
  releases?: InputMaybe<ReleaseEntryManyRelationFilter>;
  romanizedTitle?: InputMaybe<StringFilter>;
  staffs?: InputMaybe<StaffEntryManyRelationFilter>;
  startYear?: InputMaybe<StringFilter>;
  status?: InputMaybe<SeriesInfoStatusTypeNullableFilter>;
  tags?: InputMaybe<TagManyRelationFilter>;
  type?: InputMaybe<SeriesInfoTypeTypeNullableFilter>;
};

export type SeriesInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SeriesInfo_Description_Document = {
  __typename?: 'SeriesInfo_description_Document';
  document: Scalars['JSON']['output'];
};


export type SeriesInfo_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type SharedReleaseCollection = {
  __typename?: 'SharedReleaseCollection';
  canonicalCollection?: Maybe<ReleaseItemCollection>;
  collections?: Maybe<Array<ReleaseItemCollection>>;
  collectionsCount?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<SharedReleaseCollection_Description_Document>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type SharedReleaseCollectionCollectionsArgs = {
  cursor?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  orderBy?: Array<ReleaseItemCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemCollectionWhereInput;
};


export type SharedReleaseCollectionCollectionsCountArgs = {
  where?: ReleaseItemCollectionWhereInput;
};

export type SharedReleaseCollectionCreateInput = {
  canonicalCollection?: InputMaybe<ReleaseItemCollectionRelateToOneForCreateInput>;
  collections?: InputMaybe<ReleaseItemCollectionRelateToManyForCreateInput>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SharedReleaseCollectionOrderByInput = {
  cover?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type SharedReleaseCollectionRelateToOneForCreateInput = {
  connect?: InputMaybe<SharedReleaseCollectionWhereUniqueInput>;
  create?: InputMaybe<SharedReleaseCollectionCreateInput>;
};

export type SharedReleaseCollectionRelateToOneForUpdateInput = {
  connect?: InputMaybe<SharedReleaseCollectionWhereUniqueInput>;
  create?: InputMaybe<SharedReleaseCollectionCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedReleaseCollectionUpdateArgs = {
  data: SharedReleaseCollectionUpdateInput;
  where: SharedReleaseCollectionWhereUniqueInput;
};

export type SharedReleaseCollectionUpdateInput = {
  canonicalCollection?: InputMaybe<ReleaseItemCollectionRelateToOneForUpdateInput>;
  collections?: InputMaybe<ReleaseItemCollectionRelateToManyForUpdateInput>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SharedReleaseCollectionWhereInput = {
  AND?: InputMaybe<Array<SharedReleaseCollectionWhereInput>>;
  NOT?: InputMaybe<Array<SharedReleaseCollectionWhereInput>>;
  OR?: InputMaybe<Array<SharedReleaseCollectionWhereInput>>;
  canonicalCollection?: InputMaybe<ReleaseItemCollectionWhereInput>;
  collections?: InputMaybe<ReleaseItemCollectionManyRelationFilter>;
  cover?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type SharedReleaseCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SharedReleaseCollection_Description_Document = {
  __typename?: 'SharedReleaseCollection_description_Document';
  document: Scalars['JSON']['output'];
};


export type SharedReleaseCollection_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type SizeInfo = {
  __typename?: 'SizeInfo';
  depth?: Maybe<Scalars['Decimal']['output']>;
  height?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sizeAliasName?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
};

export type SizeInfoCreateInput = {
  depth?: InputMaybe<Scalars['Decimal']['input']>;
  height?: InputMaybe<Scalars['Decimal']['input']>;
  sizeAliasName?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SizeInfoOrderByInput = {
  depth?: InputMaybe<OrderDirection>;
  height?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  sizeAliasName?: InputMaybe<OrderDirection>;
  width?: InputMaybe<OrderDirection>;
};

export type SizeInfoRelateToOneForCreateInput = {
  connect?: InputMaybe<SizeInfoWhereUniqueInput>;
  create?: InputMaybe<SizeInfoCreateInput>;
};

export type SizeInfoRelateToOneForUpdateInput = {
  connect?: InputMaybe<SizeInfoWhereUniqueInput>;
  create?: InputMaybe<SizeInfoCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SizeInfoUpdateArgs = {
  data: SizeInfoUpdateInput;
  where: SizeInfoWhereUniqueInput;
};

export type SizeInfoUpdateInput = {
  depth?: InputMaybe<Scalars['Decimal']['input']>;
  height?: InputMaybe<Scalars['Decimal']['input']>;
  sizeAliasName?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SizeInfoWhereInput = {
  AND?: InputMaybe<Array<SizeInfoWhereInput>>;
  NOT?: InputMaybe<Array<SizeInfoWhereInput>>;
  OR?: InputMaybe<Array<SizeInfoWhereInput>>;
  depth?: InputMaybe<DecimalNullableFilter>;
  height?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IdFilter>;
  sizeAliasName?: InputMaybe<StringFilter>;
  width?: InputMaybe<DecimalNullableFilter>;
};

export type SizeInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceLink = {
  __typename?: 'SourceLink';
  correctionBatchVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  ignore?: Maybe<Scalars['Boolean']['output']>;
  ignoreCoverUpdates?: Maybe<Scalars['Boolean']['output']>;
  ignoredDescription?: Maybe<Scalars['String']['output']>;
  ignoredIsbn?: Maybe<Scalars['String']['output']>;
  ignoredMd5Hash?: Maybe<Scalars['String']['output']>;
  ignoredPrice?: Maybe<Scalars['String']['output']>;
  ignoredPublicationDate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['JSON']['output']>;
  relationId?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<SourceLinkRelationTypeType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  sourceCoverSha256Hash?: Maybe<Scalars['String']['output']>;
  sourceCoverUrl?: Maybe<Scalars['String']['output']>;
  sourceCreationDate?: Maybe<Scalars['String']['output']>;
  sourceLastModificationDate?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceProductId?: Maybe<Scalars['String']['output']>;
  sourcePublicationDate?: Maybe<Scalars['String']['output']>;
  sourcePublishingStatus?: Maybe<Scalars['String']['output']>;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  syncError?: Maybe<Scalars['String']['output']>;
  syncErrorAdditionalInfo?: Maybe<Scalars['String']['output']>;
};

export type SourceLinkCreateInput = {
  correctionBatchVersion?: InputMaybe<Scalars['Int']['input']>;
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCoverUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredDescription?: InputMaybe<Scalars['String']['input']>;
  ignoredIsbn?: InputMaybe<Scalars['String']['input']>;
  ignoredMd5Hash?: InputMaybe<Scalars['String']['input']>;
  ignoredPrice?: InputMaybe<Scalars['String']['input']>;
  ignoredPublicationDate?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['JSON']['input']>;
  relationId?: InputMaybe<Scalars['String']['input']>;
  relationType?: InputMaybe<SourceLinkRelationTypeType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  sourceCoverSha256Hash?: InputMaybe<Scalars['String']['input']>;
  sourceCoverUrl?: InputMaybe<Scalars['String']['input']>;
  sourceCreationDate?: InputMaybe<Scalars['String']['input']>;
  sourceLastModificationDate?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
  sourcePublicationDate?: InputMaybe<Scalars['String']['input']>;
  sourcePublishingStatus?: InputMaybe<Scalars['String']['input']>;
  sourceTitle?: InputMaybe<Scalars['String']['input']>;
  syncError?: InputMaybe<Scalars['String']['input']>;
  syncErrorAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
};

export type SourceLinkOrderByInput = {
  correctionBatchVersion?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  ignore?: InputMaybe<OrderDirection>;
  ignoreCoverUpdates?: InputMaybe<OrderDirection>;
  ignoredDescription?: InputMaybe<OrderDirection>;
  ignoredIsbn?: InputMaybe<OrderDirection>;
  ignoredMd5Hash?: InputMaybe<OrderDirection>;
  ignoredPrice?: InputMaybe<OrderDirection>;
  ignoredPublicationDate?: InputMaybe<OrderDirection>;
  relationId?: InputMaybe<OrderDirection>;
  relationType?: InputMaybe<OrderDirection>;
  sourceCoverSha256Hash?: InputMaybe<OrderDirection>;
  sourceCoverUrl?: InputMaybe<OrderDirection>;
  sourceCreationDate?: InputMaybe<OrderDirection>;
  sourceLastModificationDate?: InputMaybe<OrderDirection>;
  sourceName?: InputMaybe<OrderDirection>;
  sourceProductId?: InputMaybe<OrderDirection>;
  sourcePublicationDate?: InputMaybe<OrderDirection>;
  sourcePublishingStatus?: InputMaybe<OrderDirection>;
  sourceTitle?: InputMaybe<OrderDirection>;
  syncError?: InputMaybe<OrderDirection>;
  syncErrorAdditionalInfo?: InputMaybe<OrderDirection>;
};

export enum SourceLinkRelationTypeType {
  Collection = 'collection',
  Extra = 'extra',
  Volume = 'volume'
}

export type SourceLinkRelationTypeTypeNullableFilter = {
  equals?: InputMaybe<SourceLinkRelationTypeType>;
  in?: InputMaybe<Array<SourceLinkRelationTypeType>>;
  not?: InputMaybe<SourceLinkRelationTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<SourceLinkRelationTypeType>>;
};

export type SourceLinkUpdateArgs = {
  data: SourceLinkUpdateInput;
  where: SourceLinkWhereUniqueInput;
};

export type SourceLinkUpdateInput = {
  correctionBatchVersion?: InputMaybe<Scalars['Int']['input']>;
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCoverUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredDescription?: InputMaybe<Scalars['String']['input']>;
  ignoredIsbn?: InputMaybe<Scalars['String']['input']>;
  ignoredMd5Hash?: InputMaybe<Scalars['String']['input']>;
  ignoredPrice?: InputMaybe<Scalars['String']['input']>;
  ignoredPublicationDate?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['JSON']['input']>;
  relationId?: InputMaybe<Scalars['String']['input']>;
  relationType?: InputMaybe<SourceLinkRelationTypeType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  sourceCoverSha256Hash?: InputMaybe<Scalars['String']['input']>;
  sourceCoverUrl?: InputMaybe<Scalars['String']['input']>;
  sourceCreationDate?: InputMaybe<Scalars['String']['input']>;
  sourceLastModificationDate?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
  sourcePublicationDate?: InputMaybe<Scalars['String']['input']>;
  sourcePublishingStatus?: InputMaybe<Scalars['String']['input']>;
  sourceTitle?: InputMaybe<Scalars['String']['input']>;
  syncError?: InputMaybe<Scalars['String']['input']>;
  syncErrorAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
};

export type SourceLinkWhereInput = {
  AND?: InputMaybe<Array<SourceLinkWhereInput>>;
  NOT?: InputMaybe<Array<SourceLinkWhereInput>>;
  OR?: InputMaybe<Array<SourceLinkWhereInput>>;
  correctionBatchVersion?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IdFilter>;
  ignore?: InputMaybe<BooleanFilter>;
  ignoreCoverUpdates?: InputMaybe<BooleanFilter>;
  ignoredDescription?: InputMaybe<StringNullableFilter>;
  ignoredIsbn?: InputMaybe<StringNullableFilter>;
  ignoredMd5Hash?: InputMaybe<StringNullableFilter>;
  ignoredPrice?: InputMaybe<StringNullableFilter>;
  ignoredPublicationDate?: InputMaybe<StringNullableFilter>;
  relationId?: InputMaybe<StringNullableFilter>;
  relationType?: InputMaybe<SourceLinkRelationTypeTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  sourceCoverSha256Hash?: InputMaybe<StringNullableFilter>;
  sourceCoverUrl?: InputMaybe<StringNullableFilter>;
  sourceCreationDate?: InputMaybe<StringFilter>;
  sourceLastModificationDate?: InputMaybe<StringFilter>;
  sourceName?: InputMaybe<StringFilter>;
  sourceProductId?: InputMaybe<StringFilter>;
  sourcePublicationDate?: InputMaybe<StringFilter>;
  sourcePublishingStatus?: InputMaybe<StringFilter>;
  sourceTitle?: InputMaybe<StringFilter>;
  syncError?: InputMaybe<StringFilter>;
  syncErrorAdditionalInfo?: InputMaybe<StringFilter>;
};

export type SourceLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceSnapshot = {
  __typename?: 'SourceSnapshot';
  contentHash?: Maybe<Scalars['String']['output']>;
  coverStamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isbn13?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  missingSince?: Maybe<Scalars['DateTime']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceProductId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SourceSnapshotCreateInput = {
  contentHash?: InputMaybe<Scalars['String']['input']>;
  coverStamp?: InputMaybe<Scalars['String']['input']>;
  isbn13?: InputMaybe<Scalars['String']['input']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  missingSince?: InputMaybe<Scalars['DateTime']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SourceSnapshotOrderByInput = {
  contentHash?: InputMaybe<OrderDirection>;
  coverStamp?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isbn13?: InputMaybe<OrderDirection>;
  lastSeenAt?: InputMaybe<OrderDirection>;
  missingSince?: InputMaybe<OrderDirection>;
  publisherId?: InputMaybe<OrderDirection>;
  sourceName?: InputMaybe<OrderDirection>;
  sourceProductId?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type SourceSnapshotUpdateArgs = {
  data: SourceSnapshotUpdateInput;
  where: SourceSnapshotWhereUniqueInput;
};

export type SourceSnapshotUpdateInput = {
  contentHash?: InputMaybe<Scalars['String']['input']>;
  coverStamp?: InputMaybe<Scalars['String']['input']>;
  isbn13?: InputMaybe<Scalars['String']['input']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  missingSince?: InputMaybe<Scalars['DateTime']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SourceSnapshotWhereInput = {
  AND?: InputMaybe<Array<SourceSnapshotWhereInput>>;
  NOT?: InputMaybe<Array<SourceSnapshotWhereInput>>;
  OR?: InputMaybe<Array<SourceSnapshotWhereInput>>;
  contentHash?: InputMaybe<StringFilter>;
  coverStamp?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IdFilter>;
  isbn13?: InputMaybe<StringNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  missingSince?: InputMaybe<DateTimeNullableFilter>;
  publisherId?: InputMaybe<StringFilter>;
  sourceName?: InputMaybe<StringFilter>;
  sourceProductId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type SourceSnapshotWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceUpdate = {
  __typename?: 'SourceUpdate';
  id: Scalars['ID']['output'];
  isbn13?: Maybe<Scalars['String']['output']>;
  modificationDate?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceProductId?: Maybe<Scalars['String']['output']>;
};

export type SourceUpdateCreateInput = {
  isbn13?: InputMaybe<Scalars['String']['input']>;
  modificationDate?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
};

export type SourceUpdateOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  isbn13?: InputMaybe<OrderDirection>;
  modificationDate?: InputMaybe<OrderDirection>;
  publisherId?: InputMaybe<OrderDirection>;
  sourceName?: InputMaybe<OrderDirection>;
  sourceProductId?: InputMaybe<OrderDirection>;
};

export type SourceUpdateUpdateArgs = {
  data: SourceUpdateUpdateInput;
  where: SourceUpdateWhereUniqueInput;
};

export type SourceUpdateUpdateInput = {
  isbn13?: InputMaybe<Scalars['String']['input']>;
  modificationDate?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceProductId?: InputMaybe<Scalars['String']['input']>;
};

export type SourceUpdateWhereInput = {
  AND?: InputMaybe<Array<SourceUpdateWhereInput>>;
  NOT?: InputMaybe<Array<SourceUpdateWhereInput>>;
  OR?: InputMaybe<Array<SourceUpdateWhereInput>>;
  id?: InputMaybe<IdFilter>;
  isbn13?: InputMaybe<StringNullableFilter>;
  modificationDate?: InputMaybe<StringFilter>;
  publisherId?: InputMaybe<StringFilter>;
  sourceName?: InputMaybe<StringFilter>;
  sourceProductId?: InputMaybe<StringFilter>;
};

export type SourceUpdateWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StaffEntry = {
  __typename?: 'StaffEntry';
  id: Scalars['ID']['output'];
  individual?: Maybe<Individual>;
  job?: Maybe<Array<Job>>;
  jobCount?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  originalVlb71Code?: Maybe<Scalars['String']['output']>;
};


export type StaffEntryJobArgs = {
  cursor?: InputMaybe<JobWhereUniqueInput>;
  orderBy?: Array<JobOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: JobWhereInput;
};


export type StaffEntryJobCountArgs = {
  where?: JobWhereInput;
};

export type StaffEntryCreateInput = {
  individual?: InputMaybe<IndividualRelateToOneForCreateInput>;
  job?: InputMaybe<JobRelateToManyForCreateInput>;
  originalVlb71Code?: InputMaybe<Scalars['String']['input']>;
};

export type StaffEntryManyRelationFilter = {
  every?: InputMaybe<StaffEntryWhereInput>;
  none?: InputMaybe<StaffEntryWhereInput>;
  some?: InputMaybe<StaffEntryWhereInput>;
};

export type StaffEntryOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  originalVlb71Code?: InputMaybe<OrderDirection>;
};

export type StaffEntryRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<StaffEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<StaffEntryCreateInput>>;
};

export type StaffEntryRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<StaffEntryWhereUniqueInput>>;
  create?: InputMaybe<Array<StaffEntryCreateInput>>;
  disconnect?: InputMaybe<Array<StaffEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<StaffEntryWhereUniqueInput>>;
};

export type StaffEntryUpdateArgs = {
  data: StaffEntryUpdateInput;
  where: StaffEntryWhereUniqueInput;
};

export type StaffEntryUpdateInput = {
  individual?: InputMaybe<IndividualRelateToOneForUpdateInput>;
  job?: InputMaybe<JobRelateToManyForUpdateInput>;
  originalVlb71Code?: InputMaybe<Scalars['String']['input']>;
};

export type StaffEntryWhereInput = {
  AND?: InputMaybe<Array<StaffEntryWhereInput>>;
  NOT?: InputMaybe<Array<StaffEntryWhereInput>>;
  OR?: InputMaybe<Array<StaffEntryWhereInput>>;
  id?: InputMaybe<IdFilter>;
  individual?: InputMaybe<IndividualWhereInput>;
  job?: InputMaybe<JobManyRelationFilter>;
  originalVlb71Code?: InputMaybe<StringFilter>;
};

export type StaffEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<StringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  promotionEndDate?: Maybe<Scalars['CalendarDay']['output']>;
  promotionStartDate?: Maybe<Scalars['CalendarDay']['output']>;
  releaseItemCollections?: Maybe<Array<ReleaseItemCollection>>;
  releaseItemCollectionsCount?: Maybe<Scalars['Int']['output']>;
  releaseItems?: Maybe<Array<ReleaseItem>>;
  releaseItemsCount?: Maybe<Scalars['Int']['output']>;
  seriesInfos?: Maybe<Array<SeriesInfo>>;
  seriesInfosCount?: Maybe<Scalars['Int']['output']>;
  sortNumber?: Maybe<Scalars['Int']['output']>;
  tagType?: Maybe<TagTagTypeType>;
};


export type TagReleaseItemCollectionsArgs = {
  cursor?: InputMaybe<ReleaseItemCollectionWhereUniqueInput>;
  orderBy?: Array<ReleaseItemCollectionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemCollectionWhereInput;
};


export type TagReleaseItemCollectionsCountArgs = {
  where?: ReleaseItemCollectionWhereInput;
};


export type TagReleaseItemsArgs = {
  cursor?: InputMaybe<ReleaseItemWhereUniqueInput>;
  orderBy?: Array<ReleaseItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReleaseItemWhereInput;
};


export type TagReleaseItemsCountArgs = {
  where?: ReleaseItemWhereInput;
};


export type TagSeriesInfosArgs = {
  cursor?: InputMaybe<SeriesInfoWhereUniqueInput>;
  orderBy?: Array<SeriesInfoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SeriesInfoWhereInput;
};


export type TagSeriesInfosCountArgs = {
  where?: SeriesInfoWhereInput;
};

export type TagCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  promotionEndDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  promotionStartDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseItemCollections?: InputMaybe<ReleaseItemCollectionRelateToManyForCreateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForCreateInput>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForCreateInput>;
  sortNumber?: InputMaybe<Scalars['Int']['input']>;
  tagType?: InputMaybe<TagTagTypeType>;
};

export type TagManyRelationFilter = {
  every?: InputMaybe<TagWhereInput>;
  none?: InputMaybe<TagWhereInput>;
  some?: InputMaybe<TagWhereInput>;
};

export type TagOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  promotionEndDate?: InputMaybe<OrderDirection>;
  promotionStartDate?: InputMaybe<OrderDirection>;
  sortNumber?: InputMaybe<OrderDirection>;
  tagType?: InputMaybe<OrderDirection>;
};

export type TagRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  create?: InputMaybe<Array<TagCreateInput>>;
};

export type TagRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  create?: InputMaybe<Array<TagCreateInput>>;
  disconnect?: InputMaybe<Array<TagWhereUniqueInput>>;
  set?: InputMaybe<Array<TagWhereUniqueInput>>;
};

export enum TagTagTypeType {
  Promoted = 'promoted',
  Standard = 'standard'
}

export type TagTagTypeTypeNullableFilter = {
  equals?: InputMaybe<TagTagTypeType>;
  in?: InputMaybe<Array<TagTagTypeType>>;
  not?: InputMaybe<TagTagTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<TagTagTypeType>>;
};

export type TagUpdateArgs = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type TagUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  promotionEndDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  promotionStartDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  releaseItemCollections?: InputMaybe<ReleaseItemCollectionRelateToManyForUpdateInput>;
  releaseItems?: InputMaybe<ReleaseItemRelateToManyForUpdateInput>;
  seriesInfos?: InputMaybe<SeriesInfoRelateToManyForUpdateInput>;
  sortNumber?: InputMaybe<Scalars['Int']['input']>;
  tagType?: InputMaybe<TagTagTypeType>;
};

export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  promotionEndDate?: InputMaybe<CalendarDayNullableFilter>;
  promotionStartDate?: InputMaybe<CalendarDayNullableFilter>;
  releaseItemCollections?: InputMaybe<ReleaseItemCollectionManyRelationFilter>;
  releaseItems?: InputMaybe<ReleaseItemManyRelationFilter>;
  seriesInfos?: InputMaybe<SeriesInfoManyRelationFilter>;
  sortNumber?: InputMaybe<IntNullableFilter>;
  tagType?: InputMaybe<TagTagTypeTypeNullableFilter>;
};

export type TagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  __typename?: 'User';
  admin?: Maybe<UserAdmin>;
  avatarImage?: Maybe<UserImage>;
  bannerImage?: Maybe<UserImage>;
  bio?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<Array<UserReleaseEntryStatus>>;
  collectionCount?: Maybe<Scalars['Int']['output']>;
  customLists?: Maybe<Array<UserCustomList>>;
  customListsCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  handleChangedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<UserImage>>;
  imagesCount?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<UserLanguageType>;
  missingIsbns?: Maybe<Array<MissingIsbn>>;
  missingIsbnsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationAddedReleaseDateToExistingReleaseCollectionItem?: Maybe<Scalars['Boolean']['output']>;
  notificationAtsumeRecommendations?: Maybe<Scalars['Boolean']['output']>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem?: Maybe<Scalars['Boolean']['output']>;
  notificationFcmTokens?: Maybe<Scalars['String']['output']>;
  notificationNewReleasesFromAuthors?: Maybe<Scalars['Boolean']['output']>;
  notificationNewReleasesFromAuthorsList?: Maybe<Scalars['String']['output']>;
  notificationNewReleasesFromPublishers?: Maybe<Scalars['Boolean']['output']>;
  notificationNewReleasesFromPublishersList?: Maybe<Scalars['String']['output']>;
  notificationReleaseCollectionItemAlternativeVersionRelease?: Maybe<Scalars['Boolean']['output']>;
  notificationReleaseCollectionItemAvailable?: Maybe<Scalars['Boolean']['output']>;
  notificationScannedItemAvailable?: Maybe<Scalars['Boolean']['output']>;
  notifications?: Maybe<Array<Notification>>;
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  profilePublic?: Maybe<Scalars['Boolean']['output']>;
  profileVisibility?: Maybe<UserProfileVisibilityType>;
  showProfileStatistics?: Maybe<Scalars['Boolean']['output']>;
};


export type UserCollectionArgs = {
  cursor?: InputMaybe<UserReleaseEntryStatusWhereUniqueInput>;
  orderBy?: Array<UserReleaseEntryStatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReleaseEntryStatusWhereInput;
};


export type UserCollectionCountArgs = {
  where?: UserReleaseEntryStatusWhereInput;
};


export type UserCustomListsArgs = {
  cursor?: InputMaybe<UserCustomListWhereUniqueInput>;
  orderBy?: Array<UserCustomListOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListWhereInput;
};


export type UserCustomListsCountArgs = {
  where?: UserCustomListWhereInput;
};


export type UserImagesArgs = {
  cursor?: InputMaybe<UserImageWhereUniqueInput>;
  orderBy?: Array<UserImageOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserImageWhereInput;
};


export type UserImagesCountArgs = {
  where?: UserImageWhereInput;
};


export type UserMissingIsbnsArgs = {
  cursor?: InputMaybe<MissingIsbnWhereUniqueInput>;
  orderBy?: Array<MissingIsbnOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: MissingIsbnWhereInput;
};


export type UserMissingIsbnsCountArgs = {
  where?: MissingIsbnWhereInput;
};


export type UserNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  orderBy?: Array<NotificationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: NotificationWhereInput;
};


export type UserNotificationsCountArgs = {
  where?: NotificationWhereInput;
};

export type UserActiveDay = {
  __typename?: 'UserActiveDay';
  compoundKey?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['CalendarDay']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type UserActiveDayCreateInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['CalendarDay']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type UserActiveDayOrderByInput = {
  compoundKey?: InputMaybe<OrderDirection>;
  day?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type UserActiveDayUpdateArgs = {
  data: UserActiveDayUpdateInput;
  where: UserActiveDayWhereUniqueInput;
};

export type UserActiveDayUpdateInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['CalendarDay']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type UserActiveDayWhereInput = {
  AND?: InputMaybe<Array<UserActiveDayWhereInput>>;
  NOT?: InputMaybe<Array<UserActiveDayWhereInput>>;
  OR?: InputMaybe<Array<UserActiveDayWhereInput>>;
  compoundKey?: InputMaybe<StringFilter>;
  day?: InputMaybe<CalendarDayNullableFilter>;
  id?: InputMaybe<IdFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserActiveDayWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserAdmin = {
  __typename?: 'UserAdmin';
  adSkipTokens?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  googleProviderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagramProviderId?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  isTester?: Maybe<Scalars['Boolean']['output']>;
  premiumLastRenewalDate?: Maybe<Scalars['DateTime']['output']>;
  premiumStartDate?: Maybe<Scalars['DateTime']['output']>;
  premiumTier?: Maybe<Scalars['String']['output']>;
  twitterProviderId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserAdminCreateInput = {
  adSkipTokens?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleProviderId?: InputMaybe<Scalars['String']['input']>;
  instagramProviderId?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  isTester?: InputMaybe<Scalars['Boolean']['input']>;
  premiumLastRenewalDate?: InputMaybe<Scalars['DateTime']['input']>;
  premiumStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  premiumTier?: InputMaybe<Scalars['String']['input']>;
  twitterProviderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdminOrderByInput = {
  adSkipTokens?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  googleProviderId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  instagramProviderId?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  isGuest?: InputMaybe<OrderDirection>;
  isTester?: InputMaybe<OrderDirection>;
  premiumLastRenewalDate?: InputMaybe<OrderDirection>;
  premiumStartDate?: InputMaybe<OrderDirection>;
  premiumTier?: InputMaybe<OrderDirection>;
  twitterProviderId?: InputMaybe<OrderDirection>;
  userId?: InputMaybe<OrderDirection>;
};

export type UserAdminRelateToOneForCreateInput = {
  connect?: InputMaybe<UserAdminWhereUniqueInput>;
  create?: InputMaybe<UserAdminCreateInput>;
};

export type UserAdminRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserAdminWhereUniqueInput>;
  create?: InputMaybe<UserAdminCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAdminUpdateArgs = {
  data: UserAdminUpdateInput;
  where: UserAdminWhereUniqueInput;
};

export type UserAdminUpdateInput = {
  adSkipTokens?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleProviderId?: InputMaybe<Scalars['String']['input']>;
  instagramProviderId?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  isTester?: InputMaybe<Scalars['Boolean']['input']>;
  premiumLastRenewalDate?: InputMaybe<Scalars['DateTime']['input']>;
  premiumStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  premiumTier?: InputMaybe<Scalars['String']['input']>;
  twitterProviderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdminWhereInput = {
  AND?: InputMaybe<Array<UserAdminWhereInput>>;
  NOT?: InputMaybe<Array<UserAdminWhereInput>>;
  OR?: InputMaybe<Array<UserAdminWhereInput>>;
  adSkipTokens?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  googleProviderId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IdFilter>;
  instagramProviderId?: InputMaybe<StringNullableFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  isGuest?: InputMaybe<BooleanFilter>;
  isTester?: InputMaybe<BooleanFilter>;
  premiumLastRenewalDate?: InputMaybe<DateTimeNullableFilter>;
  premiumStartDate?: InputMaybe<DateTimeNullableFilter>;
  premiumTier?: InputMaybe<StringNullableFilter>;
  twitterProviderId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAdminWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserCollectionBreakdownBucket = {
  __typename?: 'UserCollectionBreakdownBucket';
  bucket: Scalars['String']['output'];
  dimension: Scalars['String']['output'];
  readSeries: Scalars['Int']['output'];
  readVolumes: Scalars['Int']['output'];
  series: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  volumes: Scalars['Int']['output'];
};

export type UserCollectionStats = {
  __typename?: 'UserCollectionStats';
  collectedVolumes?: Maybe<Scalars['Int']['output']>;
  firstActivityAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastRecomputedAt?: Maybe<Scalars['DateTime']['output']>;
  readByPublisher?: Maybe<Scalars['JSON']['output']>;
  readByReleaseYear?: Maybe<Scalars['JSON']['output']>;
  readByType?: Maybe<Scalars['JSON']['output']>;
  readVolumes?: Maybe<Scalars['Int']['output']>;
  releasesByPublisher?: Maybe<Scalars['JSON']['output']>;
  releasesByReleaseYear?: Maybe<Scalars['JSON']['output']>;
  releasesByStatus?: Maybe<Scalars['JSON']['output']>;
  releasesByType?: Maybe<Scalars['JSON']['output']>;
  soldByPublisher?: Maybe<Scalars['JSON']['output']>;
  soldByReleaseYear?: Maybe<Scalars['JSON']['output']>;
  soldByType?: Maybe<Scalars['JSON']['output']>;
  soldValue?: Maybe<Scalars['Decimal']['output']>;
  soldVolumes?: Maybe<Scalars['Int']['output']>;
  totalListPrice?: Maybe<Scalars['Decimal']['output']>;
  user?: Maybe<User>;
  userKey?: Maybe<Scalars['String']['output']>;
  valueByPublisher?: Maybe<Scalars['JSON']['output']>;
  valueByReleaseYear?: Maybe<Scalars['JSON']['output']>;
  valueByType?: Maybe<Scalars['JSON']['output']>;
  volumesByPublisher?: Maybe<Scalars['JSON']['output']>;
  volumesByReleaseYear?: Maybe<Scalars['JSON']['output']>;
  volumesByType?: Maybe<Scalars['JSON']['output']>;
};

export type UserCollectionStatsCreateInput = {
  collectedVolumes?: InputMaybe<Scalars['Int']['input']>;
  firstActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastRecomputedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  readByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  readByType?: InputMaybe<Scalars['JSON']['input']>;
  readVolumes?: InputMaybe<Scalars['Int']['input']>;
  releasesByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  releasesByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  releasesByStatus?: InputMaybe<Scalars['JSON']['input']>;
  releasesByType?: InputMaybe<Scalars['JSON']['input']>;
  soldByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  soldByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  soldByType?: InputMaybe<Scalars['JSON']['input']>;
  soldValue?: InputMaybe<Scalars['Decimal']['input']>;
  soldVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalListPrice?: InputMaybe<Scalars['Decimal']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
  userKey?: InputMaybe<Scalars['String']['input']>;
  valueByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  valueByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  valueByType?: InputMaybe<Scalars['JSON']['input']>;
  volumesByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  volumesByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  volumesByType?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserCollectionStatsOrderByInput = {
  collectedVolumes?: InputMaybe<OrderDirection>;
  firstActivityAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastRecomputedAt?: InputMaybe<OrderDirection>;
  readVolumes?: InputMaybe<OrderDirection>;
  soldValue?: InputMaybe<OrderDirection>;
  soldVolumes?: InputMaybe<OrderDirection>;
  totalListPrice?: InputMaybe<OrderDirection>;
  userKey?: InputMaybe<OrderDirection>;
};

export type UserCollectionStatsUpdateArgs = {
  data: UserCollectionStatsUpdateInput;
  where: UserCollectionStatsWhereUniqueInput;
};

export type UserCollectionStatsUpdateInput = {
  collectedVolumes?: InputMaybe<Scalars['Int']['input']>;
  firstActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastRecomputedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  readByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  readByType?: InputMaybe<Scalars['JSON']['input']>;
  readVolumes?: InputMaybe<Scalars['Int']['input']>;
  releasesByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  releasesByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  releasesByStatus?: InputMaybe<Scalars['JSON']['input']>;
  releasesByType?: InputMaybe<Scalars['JSON']['input']>;
  soldByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  soldByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  soldByType?: InputMaybe<Scalars['JSON']['input']>;
  soldValue?: InputMaybe<Scalars['Decimal']['input']>;
  soldVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalListPrice?: InputMaybe<Scalars['Decimal']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  userKey?: InputMaybe<Scalars['String']['input']>;
  valueByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  valueByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  valueByType?: InputMaybe<Scalars['JSON']['input']>;
  volumesByPublisher?: InputMaybe<Scalars['JSON']['input']>;
  volumesByReleaseYear?: InputMaybe<Scalars['JSON']['input']>;
  volumesByType?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserCollectionStatsWhereInput = {
  AND?: InputMaybe<Array<UserCollectionStatsWhereInput>>;
  NOT?: InputMaybe<Array<UserCollectionStatsWhereInput>>;
  OR?: InputMaybe<Array<UserCollectionStatsWhereInput>>;
  collectedVolumes?: InputMaybe<IntNullableFilter>;
  firstActivityAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  lastRecomputedAt?: InputMaybe<DateTimeNullableFilter>;
  readVolumes?: InputMaybe<IntNullableFilter>;
  soldValue?: InputMaybe<DecimalNullableFilter>;
  soldVolumes?: InputMaybe<IntNullableFilter>;
  totalListPrice?: InputMaybe<DecimalNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  userKey?: InputMaybe<StringFilter>;
};

export type UserCollectionStatsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userKey?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  collection?: InputMaybe<UserReleaseEntryStatusRelateToManyForCreateInput>;
  customLists?: InputMaybe<UserCustomListRelateToManyForCreateInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<UserLanguageType>;
  missingIsbns?: InputMaybe<MissingIsbnRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationAddedReleaseDateToExistingReleaseCollectionItem?: InputMaybe<Scalars['Boolean']['input']>;
  notificationAtsumeRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem?: InputMaybe<Scalars['Boolean']['input']>;
  notificationFcmTokens?: InputMaybe<Scalars['String']['input']>;
  notificationNewReleasesFromAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  notificationNewReleasesFromAuthorsList?: InputMaybe<Scalars['String']['input']>;
  notificationNewReleasesFromPublishers?: InputMaybe<Scalars['Boolean']['input']>;
  notificationNewReleasesFromPublishersList?: InputMaybe<Scalars['String']['input']>;
  notificationReleaseCollectionItemAlternativeVersionRelease?: InputMaybe<Scalars['Boolean']['input']>;
  notificationReleaseCollectionItemAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationScannedItemAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<NotificationRelateToManyForCreateInput>;
  profilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  profileVisibility?: InputMaybe<UserProfileVisibilityType>;
  showProfileStatistics?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCustomList = {
  __typename?: 'UserCustomList';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curatedNovelties?: Maybe<Array<UserCustomListNoveltyItem>>;
  curatedNoveltiesCount?: Maybe<Scalars['Int']['output']>;
  curatedReleaseEntries?: Maybe<Array<UserCustomListReleaseEntryItem>>;
  curatedReleaseEntriesCount?: Maybe<Scalars['Int']['output']>;
  customIcon?: Maybe<Scalars['String']['output']>;
  customTagName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isCustomTag?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<UserCustomListModeType>;
  name?: Maybe<Scalars['String']['output']>;
  noveltyKind?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  removeWhenCollected?: Maybe<Scalars['Boolean']['output']>;
  removeWhenRead?: Maybe<Scalars['Boolean']['output']>;
  showTotalNumber?: Maybe<Scalars['Boolean']['output']>;
  showTotalValue?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<Scalars['JSON']['output']>;
  statusFilter?: Maybe<UserCustomListStatusFilterType>;
  targetType?: Maybe<UserCustomListTargetTypeType>;
  urlName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


export type UserCustomListCuratedNoveltiesArgs = {
  cursor?: InputMaybe<UserCustomListNoveltyItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListNoveltyItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListNoveltyItemWhereInput;
};


export type UserCustomListCuratedNoveltiesCountArgs = {
  where?: UserCustomListNoveltyItemWhereInput;
};


export type UserCustomListCuratedReleaseEntriesArgs = {
  cursor?: InputMaybe<UserCustomListReleaseEntryItemWhereUniqueInput>;
  orderBy?: Array<UserCustomListReleaseEntryItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserCustomListReleaseEntryItemWhereInput;
};


export type UserCustomListCuratedReleaseEntriesCountArgs = {
  where?: UserCustomListReleaseEntryItemWhereInput;
};

export type UserCustomListCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curatedNovelties?: InputMaybe<UserCustomListNoveltyItemRelateToManyForCreateInput>;
  curatedReleaseEntries?: InputMaybe<UserCustomListReleaseEntryItemRelateToManyForCreateInput>;
  customIcon?: InputMaybe<Scalars['String']['input']>;
  customTagName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  isCustomTag?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<UserCustomListModeType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  removeWhenCollected?: InputMaybe<Scalars['Boolean']['input']>;
  removeWhenRead?: InputMaybe<Scalars['Boolean']['input']>;
  showTotalNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showTotalValue?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  statusFilter?: InputMaybe<UserCustomListStatusFilterType>;
  targetType?: InputMaybe<UserCustomListTargetTypeType>;
  urlName?: InputMaybe<Scalars['String']['input']>;
};

export type UserCustomListManyRelationFilter = {
  every?: InputMaybe<UserCustomListWhereInput>;
  none?: InputMaybe<UserCustomListWhereInput>;
  some?: InputMaybe<UserCustomListWhereInput>;
};

export enum UserCustomListModeType {
  Curated = 'curated',
  Filtered = 'filtered'
}

export type UserCustomListModeTypeNullableFilter = {
  equals?: InputMaybe<UserCustomListModeType>;
  in?: InputMaybe<Array<UserCustomListModeType>>;
  not?: InputMaybe<UserCustomListModeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserCustomListModeType>>;
};

export type UserCustomListNoveltyItem = {
  __typename?: 'UserCustomListNoveltyItem';
  compoundKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  list?: Maybe<UserCustomList>;
  novelty?: Maybe<Novelty>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type UserCustomListNoveltyItemCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  list?: InputMaybe<UserCustomListRelateToOneForCreateInput>;
  novelty?: InputMaybe<NoveltyRelateToOneForCreateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCustomListNoveltyItemManyRelationFilter = {
  every?: InputMaybe<UserCustomListNoveltyItemWhereInput>;
  none?: InputMaybe<UserCustomListNoveltyItemWhereInput>;
  some?: InputMaybe<UserCustomListNoveltyItemWhereInput>;
};

export type UserCustomListNoveltyItemOrderByInput = {
  compoundKey?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  orderNumber?: InputMaybe<OrderDirection>;
};

export type UserCustomListNoveltyItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserCustomListNoveltyItemWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListNoveltyItemCreateInput>>;
};

export type UserCustomListNoveltyItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserCustomListNoveltyItemWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListNoveltyItemCreateInput>>;
  disconnect?: InputMaybe<Array<UserCustomListNoveltyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCustomListNoveltyItemWhereUniqueInput>>;
};

export type UserCustomListNoveltyItemUpdateArgs = {
  data: UserCustomListNoveltyItemUpdateInput;
  where: UserCustomListNoveltyItemWhereUniqueInput;
};

export type UserCustomListNoveltyItemUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  list?: InputMaybe<UserCustomListRelateToOneForUpdateInput>;
  novelty?: InputMaybe<NoveltyRelateToOneForUpdateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCustomListNoveltyItemWhereInput = {
  AND?: InputMaybe<Array<UserCustomListNoveltyItemWhereInput>>;
  NOT?: InputMaybe<Array<UserCustomListNoveltyItemWhereInput>>;
  OR?: InputMaybe<Array<UserCustomListNoveltyItemWhereInput>>;
  compoundKey?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  list?: InputMaybe<UserCustomListWhereInput>;
  novelty?: InputMaybe<NoveltyWhereInput>;
  orderNumber?: InputMaybe<IntNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserCustomListNoveltyItemWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserCustomListOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  customIcon?: InputMaybe<OrderDirection>;
  customTagName?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isCustomTag?: InputMaybe<OrderDirection>;
  isPublic?: InputMaybe<OrderDirection>;
  mode?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  removeWhenCollected?: InputMaybe<OrderDirection>;
  removeWhenRead?: InputMaybe<OrderDirection>;
  showTotalNumber?: InputMaybe<OrderDirection>;
  showTotalValue?: InputMaybe<OrderDirection>;
  statusFilter?: InputMaybe<OrderDirection>;
  targetType?: InputMaybe<OrderDirection>;
  urlName?: InputMaybe<OrderDirection>;
};

export type UserCustomListRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserCustomListWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListCreateInput>>;
};

export type UserCustomListRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserCustomListWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListCreateInput>>;
  disconnect?: InputMaybe<Array<UserCustomListWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCustomListWhereUniqueInput>>;
};

export type UserCustomListRelateToOneForCreateInput = {
  connect?: InputMaybe<UserCustomListWhereUniqueInput>;
  create?: InputMaybe<UserCustomListCreateInput>;
};

export type UserCustomListRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserCustomListWhereUniqueInput>;
  create?: InputMaybe<UserCustomListCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCustomListReleaseEntryItem = {
  __typename?: 'UserCustomListReleaseEntryItem';
  compoundKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  list?: Maybe<UserCustomList>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  releaseEntry?: Maybe<ReleaseEntry>;
  user?: Maybe<User>;
};

export type UserCustomListReleaseEntryItemCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  list?: InputMaybe<UserCustomListRelateToOneForCreateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
};

export type UserCustomListReleaseEntryItemManyRelationFilter = {
  every?: InputMaybe<UserCustomListReleaseEntryItemWhereInput>;
  none?: InputMaybe<UserCustomListReleaseEntryItemWhereInput>;
  some?: InputMaybe<UserCustomListReleaseEntryItemWhereInput>;
};

export type UserCustomListReleaseEntryItemOrderByInput = {
  compoundKey?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  orderNumber?: InputMaybe<OrderDirection>;
};

export type UserCustomListReleaseEntryItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListReleaseEntryItemCreateInput>>;
};

export type UserCustomListReleaseEntryItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCustomListReleaseEntryItemCreateInput>>;
  disconnect?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereUniqueInput>>;
};

export type UserCustomListReleaseEntryItemUpdateArgs = {
  data: UserCustomListReleaseEntryItemUpdateInput;
  where: UserCustomListReleaseEntryItemWhereUniqueInput;
};

export type UserCustomListReleaseEntryItemUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  list?: InputMaybe<UserCustomListRelateToOneForUpdateInput>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
};

export type UserCustomListReleaseEntryItemWhereInput = {
  AND?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereInput>>;
  NOT?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereInput>>;
  OR?: InputMaybe<Array<UserCustomListReleaseEntryItemWhereInput>>;
  compoundKey?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  list?: InputMaybe<UserCustomListWhereInput>;
  orderNumber?: InputMaybe<IntNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserCustomListReleaseEntryItemWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserCustomListStats = {
  __typename?: 'UserCustomListStats';
  itemCount: Scalars['Int']['output'];
  seriesCount: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
  volumeCount: Scalars['Int']['output'];
};

export enum UserCustomListStatusFilterType {
  Collection = 'collection',
  Read = 'read'
}

export type UserCustomListStatusFilterTypeNullableFilter = {
  equals?: InputMaybe<UserCustomListStatusFilterType>;
  in?: InputMaybe<Array<UserCustomListStatusFilterType>>;
  not?: InputMaybe<UserCustomListStatusFilterTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserCustomListStatusFilterType>>;
};

export enum UserCustomListTargetTypeType {
  Novelty = 'novelty',
  ReleaseEntry = 'releaseEntry'
}

export type UserCustomListTargetTypeTypeNullableFilter = {
  equals?: InputMaybe<UserCustomListTargetTypeType>;
  in?: InputMaybe<Array<UserCustomListTargetTypeType>>;
  not?: InputMaybe<UserCustomListTargetTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserCustomListTargetTypeType>>;
};

export type UserCustomListUpdateArgs = {
  data: UserCustomListUpdateInput;
  where: UserCustomListWhereUniqueInput;
};

export type UserCustomListUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curatedNovelties?: InputMaybe<UserCustomListNoveltyItemRelateToManyForUpdateInput>;
  curatedReleaseEntries?: InputMaybe<UserCustomListReleaseEntryItemRelateToManyForUpdateInput>;
  customIcon?: InputMaybe<Scalars['String']['input']>;
  customTagName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  isCustomTag?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<UserCustomListModeType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  removeWhenCollected?: InputMaybe<Scalars['Boolean']['input']>;
  removeWhenRead?: InputMaybe<Scalars['Boolean']['input']>;
  showTotalNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showTotalValue?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  statusFilter?: InputMaybe<UserCustomListStatusFilterType>;
  targetType?: InputMaybe<UserCustomListTargetTypeType>;
  urlName?: InputMaybe<Scalars['String']['input']>;
};

export type UserCustomListWhereInput = {
  AND?: InputMaybe<Array<UserCustomListWhereInput>>;
  NOT?: InputMaybe<Array<UserCustomListWhereInput>>;
  OR?: InputMaybe<Array<UserCustomListWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  curatedNovelties?: InputMaybe<UserCustomListNoveltyItemManyRelationFilter>;
  curatedReleaseEntries?: InputMaybe<UserCustomListReleaseEntryItemManyRelationFilter>;
  customIcon?: InputMaybe<StringFilter>;
  customTagName?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isCustomTag?: InputMaybe<BooleanFilter>;
  isPublic?: InputMaybe<BooleanFilter>;
  mode?: InputMaybe<UserCustomListModeTypeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  removeWhenCollected?: InputMaybe<BooleanFilter>;
  removeWhenRead?: InputMaybe<BooleanFilter>;
  showTotalNumber?: InputMaybe<BooleanFilter>;
  showTotalValue?: InputMaybe<BooleanFilter>;
  statusFilter?: InputMaybe<UserCustomListStatusFilterTypeNullableFilter>;
  targetType?: InputMaybe<UserCustomListTargetTypeTypeNullableFilter>;
  urlName?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserCustomListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserDeltaPage = {
  __typename?: 'UserDeltaPage';
  hasMore: Scalars['Boolean']['output'];
  headSeq: Scalars['String']['output'];
  nextSeq: Scalars['String']['output'];
  resyncRequired: Scalars['Boolean']['output'];
  tombstones: Array<UserTombstone>;
  userAdmins: Array<UserAdmin>;
  userCustomListNoveltyItems: Array<UserCustomListNoveltyItem>;
  userCustomListReleaseEntryItems: Array<UserCustomListReleaseEntryItem>;
  userCustomLists: Array<UserCustomList>;
  userReleaseEntryStatuses: Array<UserReleaseEntryStatus>;
};

export type UserHandleClaimResult = {
  __typename?: 'UserHandleClaimResult';
  accepted: Scalars['Boolean']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  nextRenameAllowedAt?: Maybe<Scalars['String']['output']>;
  rejection?: Maybe<Scalars['String']['output']>;
};

export type UserImage = {
  __typename?: 'UserImage';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  byteSize?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<UserImageKindType>;
  mimeType?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  providerScores?: Maybe<Scalars['JSON']['output']>;
  purgedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<UserImageRejectionReasonType>;
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  sourceSha256?: Maybe<Scalars['String']['output']>;
  state?: Maybe<UserImageStateType>;
  storageKey?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UserImageCreateInput = {
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  byteSize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserImageKindType>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['DateTime']['input']>;
  providerScores?: InputMaybe<Scalars['JSON']['input']>;
  purgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectionReason?: InputMaybe<UserImageRejectionReasonType>;
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sha256?: InputMaybe<Scalars['String']['input']>;
  sourceSha256?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserImageStateType>;
  storageKey?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum UserImageKindType {
  Avatar = 'avatar',
  Banner = 'banner'
}

export type UserImageKindTypeNullableFilter = {
  equals?: InputMaybe<UserImageKindType>;
  in?: InputMaybe<Array<UserImageKindType>>;
  not?: InputMaybe<UserImageKindTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserImageKindType>>;
};

export type UserImageManyRelationFilter = {
  every?: InputMaybe<UserImageWhereInput>;
  none?: InputMaybe<UserImageWhereInput>;
  some?: InputMaybe<UserImageWhereInput>;
};

export type UserImageOrderByInput = {
  attemptCount?: InputMaybe<OrderDirection>;
  byteSize?: InputMaybe<OrderDirection>;
  height?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  kind?: InputMaybe<OrderDirection>;
  mimeType?: InputMaybe<OrderDirection>;
  nextAttemptAt?: InputMaybe<OrderDirection>;
  purgedAt?: InputMaybe<OrderDirection>;
  rejectionReason?: InputMaybe<OrderDirection>;
  reportedAt?: InputMaybe<OrderDirection>;
  reviewedAt?: InputMaybe<OrderDirection>;
  sha256?: InputMaybe<OrderDirection>;
  sourceSha256?: InputMaybe<OrderDirection>;
  state?: InputMaybe<OrderDirection>;
  storageKey?: InputMaybe<OrderDirection>;
  uploadedAt?: InputMaybe<OrderDirection>;
  width?: InputMaybe<OrderDirection>;
};

export enum UserImageRejectionReasonType {
  ClassifierUnavailable = 'classifier_unavailable',
  Copyright = 'copyright',
  HateSymbols = 'hate_symbols',
  Other = 'other',
  SexualContent = 'sexual_content',
  Violence = 'violence'
}

export type UserImageRejectionReasonTypeNullableFilter = {
  equals?: InputMaybe<UserImageRejectionReasonType>;
  in?: InputMaybe<Array<UserImageRejectionReasonType>>;
  not?: InputMaybe<UserImageRejectionReasonTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserImageRejectionReasonType>>;
};

export type UserImageRelateToOneForCreateInput = {
  connect?: InputMaybe<UserImageWhereUniqueInput>;
  create?: InputMaybe<UserImageCreateInput>;
};

export type UserImageRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserImageWhereUniqueInput>;
  create?: InputMaybe<UserImageCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserImageStateType {
  Live = 'live',
  Pending = 'pending',
  Purged = 'purged',
  Rejected = 'rejected',
  Reported = 'reported'
}

export type UserImageStateTypeNullableFilter = {
  equals?: InputMaybe<UserImageStateType>;
  in?: InputMaybe<Array<UserImageStateType>>;
  not?: InputMaybe<UserImageStateTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserImageStateType>>;
};

export type UserImageUpdateArgs = {
  data: UserImageUpdateInput;
  where: UserImageWhereUniqueInput;
};

export type UserImageUpdateInput = {
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  byteSize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserImageKindType>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['DateTime']['input']>;
  providerScores?: InputMaybe<Scalars['JSON']['input']>;
  purgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectionReason?: InputMaybe<UserImageRejectionReasonType>;
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sha256?: InputMaybe<Scalars['String']['input']>;
  sourceSha256?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserImageStateType>;
  storageKey?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UserImageWhereInput = {
  AND?: InputMaybe<Array<UserImageWhereInput>>;
  NOT?: InputMaybe<Array<UserImageWhereInput>>;
  OR?: InputMaybe<Array<UserImageWhereInput>>;
  attemptCount?: InputMaybe<IntNullableFilter>;
  byteSize?: InputMaybe<IntNullableFilter>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IdFilter>;
  kind?: InputMaybe<UserImageKindTypeNullableFilter>;
  mimeType?: InputMaybe<StringFilter>;
  nextAttemptAt?: InputMaybe<DateTimeNullableFilter>;
  purgedAt?: InputMaybe<DateTimeNullableFilter>;
  rejectionReason?: InputMaybe<UserImageRejectionReasonTypeNullableFilter>;
  reportedAt?: InputMaybe<DateTimeNullableFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  sha256?: InputMaybe<StringFilter>;
  sourceSha256?: InputMaybe<StringFilter>;
  state?: InputMaybe<UserImageStateTypeNullableFilter>;
  storageKey?: InputMaybe<StringFilter>;
  uploadedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  width?: InputMaybe<IntNullableFilter>;
};

export type UserImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  storageKey?: InputMaybe<Scalars['String']['input']>;
};

export enum UserLanguageType {
  De = 'de',
  En = 'en'
}

export type UserLanguageTypeNullableFilter = {
  equals?: InputMaybe<UserLanguageType>;
  in?: InputMaybe<Array<UserLanguageType>>;
  not?: InputMaybe<UserLanguageTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserLanguageType>>;
};

export type UserMiscPossessionActivity = {
  __typename?: 'UserMiscPossessionActivity';
  activityType?: Maybe<UserMiscPossessionActivityActivityTypeType>;
  id: Scalars['ID']['output'];
  miscId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<UserMiscPossessionActivityReasonType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<UserMiscPossessionActivityTypeType>;
  user?: Maybe<User>;
};

export enum UserMiscPossessionActivityActivityTypeType {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type UserMiscPossessionActivityActivityTypeTypeNullableFilter = {
  equals?: InputMaybe<UserMiscPossessionActivityActivityTypeType>;
  in?: InputMaybe<Array<UserMiscPossessionActivityActivityTypeType>>;
  not?: InputMaybe<UserMiscPossessionActivityActivityTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserMiscPossessionActivityActivityTypeType>>;
};

export type UserMiscPossessionActivityCreateInput = {
  activityType?: InputMaybe<UserMiscPossessionActivityActivityTypeType>;
  miscId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserMiscPossessionActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<UserMiscPossessionActivityTypeType>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type UserMiscPossessionActivityOrderByInput = {
  activityType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  miscId?: InputMaybe<OrderDirection>;
  reason?: InputMaybe<OrderDirection>;
  timestamp?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export enum UserMiscPossessionActivityReasonType {
  Manual = 'manual',
  Sale = 'sale',
  Unsale = 'unsale'
}

export type UserMiscPossessionActivityReasonTypeNullableFilter = {
  equals?: InputMaybe<UserMiscPossessionActivityReasonType>;
  in?: InputMaybe<Array<UserMiscPossessionActivityReasonType>>;
  not?: InputMaybe<UserMiscPossessionActivityReasonTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserMiscPossessionActivityReasonType>>;
};

export enum UserMiscPossessionActivityTypeType {
  Collection = 'collection'
}

export type UserMiscPossessionActivityTypeTypeNullableFilter = {
  equals?: InputMaybe<UserMiscPossessionActivityTypeType>;
  in?: InputMaybe<Array<UserMiscPossessionActivityTypeType>>;
  not?: InputMaybe<UserMiscPossessionActivityTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserMiscPossessionActivityTypeType>>;
};

export type UserMiscPossessionActivityUpdateArgs = {
  data: UserMiscPossessionActivityUpdateInput;
  where: UserMiscPossessionActivityWhereUniqueInput;
};

export type UserMiscPossessionActivityUpdateInput = {
  activityType?: InputMaybe<UserMiscPossessionActivityActivityTypeType>;
  miscId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserMiscPossessionActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<UserMiscPossessionActivityTypeType>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type UserMiscPossessionActivityWhereInput = {
  AND?: InputMaybe<Array<UserMiscPossessionActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserMiscPossessionActivityWhereInput>>;
  OR?: InputMaybe<Array<UserMiscPossessionActivityWhereInput>>;
  activityType?: InputMaybe<UserMiscPossessionActivityActivityTypeTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  miscId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<UserMiscPossessionActivityReasonTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  timestamp?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<UserMiscPossessionActivityTypeTypeNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserMiscPossessionActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserOrderByInput = {
  bio?: InputMaybe<OrderDirection>;
  handle?: InputMaybe<OrderDirection>;
  handleChangedAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  language?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  notificationAddedReleaseDateToExistingReleaseCollectionItem?: InputMaybe<OrderDirection>;
  notificationAtsumeRecommendations?: InputMaybe<OrderDirection>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem?: InputMaybe<OrderDirection>;
  notificationFcmTokens?: InputMaybe<OrderDirection>;
  notificationNewReleasesFromAuthors?: InputMaybe<OrderDirection>;
  notificationNewReleasesFromAuthorsList?: InputMaybe<OrderDirection>;
  notificationNewReleasesFromPublishers?: InputMaybe<OrderDirection>;
  notificationNewReleasesFromPublishersList?: InputMaybe<OrderDirection>;
  notificationReleaseCollectionItemAlternativeVersionRelease?: InputMaybe<OrderDirection>;
  notificationReleaseCollectionItemAvailable?: InputMaybe<OrderDirection>;
  notificationScannedItemAvailable?: InputMaybe<OrderDirection>;
  profilePublic?: InputMaybe<OrderDirection>;
  profileVisibility?: InputMaybe<OrderDirection>;
  showProfileStatistics?: InputMaybe<OrderDirection>;
};

export type UserPossessionActivity = {
  __typename?: 'UserPossessionActivity';
  activityType?: Maybe<UserPossessionActivityActivityTypeType>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<UserPossessionActivityReasonType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseYear?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  volumeNumber?: Maybe<Scalars['String']['output']>;
};

export enum UserPossessionActivityActivityTypeType {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type UserPossessionActivityActivityTypeTypeNullableFilter = {
  equals?: InputMaybe<UserPossessionActivityActivityTypeType>;
  in?: InputMaybe<Array<UserPossessionActivityActivityTypeType>>;
  not?: InputMaybe<UserPossessionActivityActivityTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserPossessionActivityActivityTypeType>>;
};

export type UserPossessionActivityCreateInput = {
  activityType?: InputMaybe<UserPossessionActivityActivityTypeType>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserPossessionActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
  volumeNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserPossessionActivityOrderByInput = {
  activityType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  price?: InputMaybe<OrderDirection>;
  publisherId?: InputMaybe<OrderDirection>;
  reason?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  timestamp?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  volumeNumber?: InputMaybe<OrderDirection>;
};

export enum UserPossessionActivityReasonType {
  Manual = 'manual',
  Sale = 'sale',
  Unsale = 'unsale'
}

export type UserPossessionActivityReasonTypeNullableFilter = {
  equals?: InputMaybe<UserPossessionActivityReasonType>;
  in?: InputMaybe<Array<UserPossessionActivityReasonType>>;
  not?: InputMaybe<UserPossessionActivityReasonTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserPossessionActivityReasonType>>;
};

export type UserPossessionActivityUpdateArgs = {
  data: UserPossessionActivityUpdateInput;
  where: UserPossessionActivityWhereUniqueInput;
};

export type UserPossessionActivityUpdateInput = {
  activityType?: InputMaybe<UserPossessionActivityActivityTypeType>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserPossessionActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  volumeNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserPossessionActivityWhereInput = {
  AND?: InputMaybe<Array<UserPossessionActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserPossessionActivityWhereInput>>;
  OR?: InputMaybe<Array<UserPossessionActivityWhereInput>>;
  activityType?: InputMaybe<UserPossessionActivityActivityTypeTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  publisherId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<UserPossessionActivityReasonTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  releaseYear?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
  volumeNumber?: InputMaybe<StringFilter>;
};

export type UserPossessionActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserPremiumChange = {
  __typename?: 'UserPremiumChange';
  changeType?: Maybe<UserPremiumChangeChangeTypeType>;
  id: Scalars['ID']['output'];
  previousTier?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userAdmin?: Maybe<UserAdmin>;
};

export enum UserPremiumChangeChangeTypeType {
  Grant = 'grant',
  Revoke = 'revoke',
  TierChange = 'tierChange'
}

export type UserPremiumChangeChangeTypeTypeNullableFilter = {
  equals?: InputMaybe<UserPremiumChangeChangeTypeType>;
  in?: InputMaybe<Array<UserPremiumChangeChangeTypeType>>;
  not?: InputMaybe<UserPremiumChangeChangeTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserPremiumChangeChangeTypeType>>;
};

export type UserPremiumChangeCreateInput = {
  changeType?: InputMaybe<UserPremiumChangeChangeTypeType>;
  previousTier?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  userAdmin?: InputMaybe<UserAdminRelateToOneForCreateInput>;
};

export type UserPremiumChangeOrderByInput = {
  changeType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  previousTier?: InputMaybe<OrderDirection>;
  tier?: InputMaybe<OrderDirection>;
  timestamp?: InputMaybe<OrderDirection>;
};

export type UserPremiumChangeUpdateArgs = {
  data: UserPremiumChangeUpdateInput;
  where: UserPremiumChangeWhereUniqueInput;
};

export type UserPremiumChangeUpdateInput = {
  changeType?: InputMaybe<UserPremiumChangeChangeTypeType>;
  previousTier?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  userAdmin?: InputMaybe<UserAdminRelateToOneForUpdateInput>;
};

export type UserPremiumChangeWhereInput = {
  AND?: InputMaybe<Array<UserPremiumChangeWhereInput>>;
  NOT?: InputMaybe<Array<UserPremiumChangeWhereInput>>;
  OR?: InputMaybe<Array<UserPremiumChangeWhereInput>>;
  changeType?: InputMaybe<UserPremiumChangeChangeTypeTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  previousTier?: InputMaybe<StringFilter>;
  tier?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userAdmin?: InputMaybe<UserAdminWhereInput>;
};

export type UserPremiumChangeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserProfileVisibilityType {
  Followers = 'followers',
  Private = 'private',
  Public = 'public'
}

export type UserProfileVisibilityTypeNullableFilter = {
  equals?: InputMaybe<UserProfileVisibilityType>;
  in?: InputMaybe<Array<UserProfileVisibilityType>>;
  not?: InputMaybe<UserProfileVisibilityTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserProfileVisibilityType>>;
};

export type UserReadActivity = {
  __typename?: 'UserReadActivity';
  activityType?: Maybe<UserReadActivityActivityTypeType>;
  id: Scalars['ID']['output'];
  publisherId?: Maybe<Scalars['String']['output']>;
  readEntry?: Maybe<UserReleaseReadStatus>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseYear?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  volumeNumber?: Maybe<Scalars['String']['output']>;
};

export enum UserReadActivityActivityTypeType {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type UserReadActivityActivityTypeTypeNullableFilter = {
  equals?: InputMaybe<UserReadActivityActivityTypeType>;
  in?: InputMaybe<Array<UserReadActivityActivityTypeType>>;
  not?: InputMaybe<UserReadActivityActivityTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReadActivityActivityTypeType>>;
};

export type UserReadActivityCreateInput = {
  activityType?: InputMaybe<UserReadActivityActivityTypeType>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  readEntry?: InputMaybe<UserReleaseReadStatusRelateToOneForCreateInput>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
  volumeNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserReadActivityOrderByInput = {
  activityType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  publisherId?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  timestamp?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  volumeNumber?: InputMaybe<OrderDirection>;
};

export type UserReadActivityUpdateArgs = {
  data: UserReadActivityUpdateInput;
  where: UserReadActivityWhereUniqueInput;
};

export type UserReadActivityUpdateInput = {
  activityType?: InputMaybe<UserReadActivityActivityTypeType>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  readEntry?: InputMaybe<UserReleaseReadStatusRelateToOneForUpdateInput>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  volumeNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserReadActivityWhereInput = {
  AND?: InputMaybe<Array<UserReadActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserReadActivityWhereInput>>;
  OR?: InputMaybe<Array<UserReadActivityWhereInput>>;
  activityType?: InputMaybe<UserReadActivityActivityTypeTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  publisherId?: InputMaybe<StringFilter>;
  readEntry?: InputMaybe<UserReleaseReadStatusWhereInput>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  releaseYear?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
  volumeNumber?: InputMaybe<StringFilter>;
};

export type UserReadActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserRelateToOneForCreateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
};

export type UserRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserReleaseActivity = {
  __typename?: 'UserReleaseActivity';
  activityType?: Maybe<UserReleaseActivityActivityTypeType>;
  id: Scalars['ID']['output'];
  publisherId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<UserReleaseActivityReasonType>;
  releaseEntry?: Maybe<ReleaseEntry>;
  releaseYear?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum UserReleaseActivityActivityTypeType {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type UserReleaseActivityActivityTypeTypeNullableFilter = {
  equals?: InputMaybe<UserReleaseActivityActivityTypeType>;
  in?: InputMaybe<Array<UserReleaseActivityActivityTypeType>>;
  not?: InputMaybe<UserReleaseActivityActivityTypeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReleaseActivityActivityTypeType>>;
};

export type UserReleaseActivityCreateInput = {
  activityType?: InputMaybe<UserReleaseActivityActivityTypeType>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserReleaseActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type UserReleaseActivityOrderByInput = {
  activityType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  publisherId?: InputMaybe<OrderDirection>;
  reason?: InputMaybe<OrderDirection>;
  releaseYear?: InputMaybe<OrderDirection>;
  timestamp?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export enum UserReleaseActivityReasonType {
  Manual = 'manual',
  Sale = 'sale',
  Unsale = 'unsale'
}

export type UserReleaseActivityReasonTypeNullableFilter = {
  equals?: InputMaybe<UserReleaseActivityReasonType>;
  in?: InputMaybe<Array<UserReleaseActivityReasonType>>;
  not?: InputMaybe<UserReleaseActivityReasonTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReleaseActivityReasonType>>;
};

export type UserReleaseActivityUpdateArgs = {
  data: UserReleaseActivityUpdateInput;
  where: UserReleaseActivityWhereUniqueInput;
};

export type UserReleaseActivityUpdateInput = {
  activityType?: InputMaybe<UserReleaseActivityActivityTypeType>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserReleaseActivityReasonType>;
  releaseEntry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  releaseYear?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type UserReleaseActivityWhereInput = {
  AND?: InputMaybe<Array<UserReleaseActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserReleaseActivityWhereInput>>;
  OR?: InputMaybe<Array<UserReleaseActivityWhereInput>>;
  activityType?: InputMaybe<UserReleaseActivityActivityTypeTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  publisherId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<UserReleaseActivityReasonTypeNullableFilter>;
  releaseEntry?: InputMaybe<ReleaseEntryWhereInput>;
  releaseYear?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserReleaseActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserReleaseEntryStatus = {
  __typename?: 'UserReleaseEntryStatus';
  collectionStatus?: Maybe<UserReleaseEntryStatusCollectionStatusType>;
  compoundKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentReadStatus?: Maybe<UserReleaseEntryStatusCurrentReadStatusType>;
  demographySearchField?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['CalendarDay']['output']>;
  entry?: Maybe<ReleaseEntry>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  itemStatus?: Maybe<Scalars['JSON']['output']>;
  lastCollectionChanged?: Maybe<Scalars['DateTime']['output']>;
  lastReadChanged?: Maybe<Scalars['DateTime']['output']>;
  miscItemStatus?: Maybe<Scalars['JSON']['output']>;
  popularityScore?: Maybe<Scalars['Decimal']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  readStatus?: Maybe<Array<UserReleaseReadStatus>>;
  readStatusCount?: Maybe<Scalars['Int']['output']>;
  recommendationScore?: Maybe<Scalars['Decimal']['output']>;
  startDate?: Maybe<Scalars['CalendarDay']['output']>;
  tagSearchField?: Maybe<Scalars['String']['output']>;
  titleSearch?: Maybe<Scalars['String']['output']>;
  totalNotReleasedVolumes?: Maybe<Scalars['Int']['output']>;
  totalReleasedVolumes?: Maybe<Scalars['Int']['output']>;
  totalVolumes?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


export type UserReleaseEntryStatusReadStatusArgs = {
  cursor?: InputMaybe<UserReleaseReadStatusWhereUniqueInput>;
  orderBy?: Array<UserReleaseReadStatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserReleaseReadStatusWhereInput;
};


export type UserReleaseEntryStatusReadStatusCountArgs = {
  where?: UserReleaseReadStatusWhereInput;
};

export enum UserReleaseEntryStatusCollectionStatusType {
  Aborted = 'aborted',
  Collecting = 'collecting',
  Done = 'done',
  Paused = 'paused',
  Planned = 'planned',
  Sold = 'sold'
}

export type UserReleaseEntryStatusCollectionStatusTypeNullableFilter = {
  equals?: InputMaybe<UserReleaseEntryStatusCollectionStatusType>;
  in?: InputMaybe<Array<UserReleaseEntryStatusCollectionStatusType>>;
  not?: InputMaybe<UserReleaseEntryStatusCollectionStatusTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReleaseEntryStatusCollectionStatusType>>;
};

export type UserReleaseEntryStatusCreateInput = {
  collectionStatus?: InputMaybe<UserReleaseEntryStatusCollectionStatusType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentReadStatus?: InputMaybe<UserReleaseEntryStatusCurrentReadStatusType>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  entry?: InputMaybe<ReleaseEntryRelateToOneForCreateInput>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  itemStatus?: InputMaybe<Scalars['JSON']['input']>;
  lastCollectionChanged?: InputMaybe<Scalars['DateTime']['input']>;
  lastReadChanged?: InputMaybe<Scalars['DateTime']['input']>;
  miscItemStatus?: InputMaybe<Scalars['JSON']['input']>;
  popularityScore?: InputMaybe<Scalars['Decimal']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  readStatus?: InputMaybe<UserReleaseReadStatusRelateToManyForCreateInput>;
  recommendationScore?: InputMaybe<Scalars['Decimal']['input']>;
  startDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  totalNotReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalVolumes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum UserReleaseEntryStatusCurrentReadStatusType {
  Aborted = 'aborted',
  Done = 'done',
  NotPlanned = 'notPlanned',
  Paused = 'paused',
  Planned = 'planned',
  Reading = 'reading'
}

export type UserReleaseEntryStatusCurrentReadStatusTypeNullableFilter = {
  equals?: InputMaybe<UserReleaseEntryStatusCurrentReadStatusType>;
  in?: InputMaybe<Array<UserReleaseEntryStatusCurrentReadStatusType>>;
  not?: InputMaybe<UserReleaseEntryStatusCurrentReadStatusTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReleaseEntryStatusCurrentReadStatusType>>;
};

export type UserReleaseEntryStatusManyRelationFilter = {
  every?: InputMaybe<UserReleaseEntryStatusWhereInput>;
  none?: InputMaybe<UserReleaseEntryStatusWhereInput>;
  some?: InputMaybe<UserReleaseEntryStatusWhereInput>;
};

export type UserReleaseEntryStatusOrderByInput = {
  collectionStatus?: InputMaybe<OrderDirection>;
  compoundKey?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  currentReadStatus?: InputMaybe<OrderDirection>;
  demographySearchField?: InputMaybe<OrderDirection>;
  endDate?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  internalName?: InputMaybe<OrderDirection>;
  lastCollectionChanged?: InputMaybe<OrderDirection>;
  lastReadChanged?: InputMaybe<OrderDirection>;
  popularityScore?: InputMaybe<OrderDirection>;
  publisherName?: InputMaybe<OrderDirection>;
  recommendationScore?: InputMaybe<OrderDirection>;
  startDate?: InputMaybe<OrderDirection>;
  tagSearchField?: InputMaybe<OrderDirection>;
  titleSearch?: InputMaybe<OrderDirection>;
  totalNotReleasedVolumes?: InputMaybe<OrderDirection>;
  totalReleasedVolumes?: InputMaybe<OrderDirection>;
  totalVolumes?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type UserReleaseEntryStatusRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserReleaseEntryStatusWhereUniqueInput>>;
  create?: InputMaybe<Array<UserReleaseEntryStatusCreateInput>>;
};

export type UserReleaseEntryStatusRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserReleaseEntryStatusWhereUniqueInput>>;
  create?: InputMaybe<Array<UserReleaseEntryStatusCreateInput>>;
  disconnect?: InputMaybe<Array<UserReleaseEntryStatusWhereUniqueInput>>;
  set?: InputMaybe<Array<UserReleaseEntryStatusWhereUniqueInput>>;
};

export type UserReleaseEntryStatusRelateToOneForCreateInput = {
  connect?: InputMaybe<UserReleaseEntryStatusWhereUniqueInput>;
  create?: InputMaybe<UserReleaseEntryStatusCreateInput>;
};

export type UserReleaseEntryStatusRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserReleaseEntryStatusWhereUniqueInput>;
  create?: InputMaybe<UserReleaseEntryStatusCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserReleaseEntryStatusUpdateArgs = {
  data: UserReleaseEntryStatusUpdateInput;
  where: UserReleaseEntryStatusWhereUniqueInput;
};

export type UserReleaseEntryStatusUpdateInput = {
  collectionStatus?: InputMaybe<UserReleaseEntryStatusCollectionStatusType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentReadStatus?: InputMaybe<UserReleaseEntryStatusCurrentReadStatusType>;
  demographySearchField?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  entry?: InputMaybe<ReleaseEntryRelateToOneForUpdateInput>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  itemStatus?: InputMaybe<Scalars['JSON']['input']>;
  lastCollectionChanged?: InputMaybe<Scalars['DateTime']['input']>;
  lastReadChanged?: InputMaybe<Scalars['DateTime']['input']>;
  miscItemStatus?: InputMaybe<Scalars['JSON']['input']>;
  popularityScore?: InputMaybe<Scalars['Decimal']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  readStatus?: InputMaybe<UserReleaseReadStatusRelateToManyForUpdateInput>;
  recommendationScore?: InputMaybe<Scalars['Decimal']['input']>;
  startDate?: InputMaybe<Scalars['CalendarDay']['input']>;
  tagSearchField?: InputMaybe<Scalars['String']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
  totalNotReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalReleasedVolumes?: InputMaybe<Scalars['Int']['input']>;
  totalVolumes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UserReleaseEntryStatusWhereInput = {
  AND?: InputMaybe<Array<UserReleaseEntryStatusWhereInput>>;
  NOT?: InputMaybe<Array<UserReleaseEntryStatusWhereInput>>;
  OR?: InputMaybe<Array<UserReleaseEntryStatusWhereInput>>;
  collectionStatus?: InputMaybe<UserReleaseEntryStatusCollectionStatusTypeNullableFilter>;
  compoundKey?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currentReadStatus?: InputMaybe<UserReleaseEntryStatusCurrentReadStatusTypeNullableFilter>;
  demographySearchField?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<CalendarDayNullableFilter>;
  entry?: InputMaybe<ReleaseEntryWhereInput>;
  id?: InputMaybe<IdFilter>;
  internalName?: InputMaybe<StringFilter>;
  lastCollectionChanged?: InputMaybe<DateTimeNullableFilter>;
  lastReadChanged?: InputMaybe<DateTimeNullableFilter>;
  popularityScore?: InputMaybe<DecimalNullableFilter>;
  publisherName?: InputMaybe<StringFilter>;
  readStatus?: InputMaybe<UserReleaseReadStatusManyRelationFilter>;
  recommendationScore?: InputMaybe<DecimalNullableFilter>;
  startDate?: InputMaybe<CalendarDayNullableFilter>;
  tagSearchField?: InputMaybe<StringFilter>;
  titleSearch?: InputMaybe<StringFilter>;
  totalNotReleasedVolumes?: InputMaybe<IntNullableFilter>;
  totalReleasedVolumes?: InputMaybe<IntNullableFilter>;
  totalVolumes?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserReleaseEntryStatusWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserReleaseReadStatus = {
  __typename?: 'UserReleaseReadStatus';
  collectAll?: Maybe<Scalars['Boolean']['output']>;
  entry?: Maybe<UserReleaseEntryStatus>;
  finishedRead?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastReadChanged?: Maybe<Scalars['DateTime']['output']>;
  readNumber?: Maybe<Scalars['Int']['output']>;
  readStatus?: Maybe<Scalars['JSON']['output']>;
  startedRead?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<UserReleaseReadStatusStatusType>;
};

export type UserReleaseReadStatusCreateInput = {
  collectAll?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<UserReleaseEntryStatusRelateToOneForCreateInput>;
  finishedRead?: InputMaybe<Scalars['DateTime']['input']>;
  lastReadChanged?: InputMaybe<Scalars['DateTime']['input']>;
  readNumber?: InputMaybe<Scalars['Int']['input']>;
  readStatus?: InputMaybe<Scalars['JSON']['input']>;
  startedRead?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<UserReleaseReadStatusStatusType>;
};

export type UserReleaseReadStatusManyRelationFilter = {
  every?: InputMaybe<UserReleaseReadStatusWhereInput>;
  none?: InputMaybe<UserReleaseReadStatusWhereInput>;
  some?: InputMaybe<UserReleaseReadStatusWhereInput>;
};

export type UserReleaseReadStatusOrderByInput = {
  collectAll?: InputMaybe<OrderDirection>;
  finishedRead?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastReadChanged?: InputMaybe<OrderDirection>;
  readNumber?: InputMaybe<OrderDirection>;
  startedRead?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type UserReleaseReadStatusRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserReleaseReadStatusWhereUniqueInput>>;
  create?: InputMaybe<Array<UserReleaseReadStatusCreateInput>>;
};

export type UserReleaseReadStatusRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserReleaseReadStatusWhereUniqueInput>>;
  create?: InputMaybe<Array<UserReleaseReadStatusCreateInput>>;
  disconnect?: InputMaybe<Array<UserReleaseReadStatusWhereUniqueInput>>;
  set?: InputMaybe<Array<UserReleaseReadStatusWhereUniqueInput>>;
};

export type UserReleaseReadStatusRelateToOneForCreateInput = {
  connect?: InputMaybe<UserReleaseReadStatusWhereUniqueInput>;
  create?: InputMaybe<UserReleaseReadStatusCreateInput>;
};

export type UserReleaseReadStatusRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserReleaseReadStatusWhereUniqueInput>;
  create?: InputMaybe<UserReleaseReadStatusCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserReleaseReadStatusStatusType {
  Aborted = 'aborted',
  Done = 'done',
  NotPlanned = 'notPlanned',
  Paused = 'paused',
  Planned = 'planned',
  Reading = 'reading'
}

export type UserReleaseReadStatusStatusTypeNullableFilter = {
  equals?: InputMaybe<UserReleaseReadStatusStatusType>;
  in?: InputMaybe<Array<UserReleaseReadStatusStatusType>>;
  not?: InputMaybe<UserReleaseReadStatusStatusTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserReleaseReadStatusStatusType>>;
};

export type UserReleaseReadStatusUpdateArgs = {
  data: UserReleaseReadStatusUpdateInput;
  where: UserReleaseReadStatusWhereUniqueInput;
};

export type UserReleaseReadStatusUpdateInput = {
  collectAll?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<UserReleaseEntryStatusRelateToOneForUpdateInput>;
  finishedRead?: InputMaybe<Scalars['DateTime']['input']>;
  lastReadChanged?: InputMaybe<Scalars['DateTime']['input']>;
  readNumber?: InputMaybe<Scalars['Int']['input']>;
  readStatus?: InputMaybe<Scalars['JSON']['input']>;
  startedRead?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<UserReleaseReadStatusStatusType>;
};

export type UserReleaseReadStatusWhereInput = {
  AND?: InputMaybe<Array<UserReleaseReadStatusWhereInput>>;
  NOT?: InputMaybe<Array<UserReleaseReadStatusWhereInput>>;
  OR?: InputMaybe<Array<UserReleaseReadStatusWhereInput>>;
  collectAll?: InputMaybe<BooleanFilter>;
  entry?: InputMaybe<UserReleaseEntryStatusWhereInput>;
  finishedRead?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  lastReadChanged?: InputMaybe<DateTimeNullableFilter>;
  readNumber?: InputMaybe<IntNullableFilter>;
  startedRead?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<UserReleaseReadStatusStatusTypeNullableFilter>;
};

export type UserReleaseReadStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserStatsDailyFact = {
  __typename?: 'UserStatsDailyFact';
  bucket?: Maybe<Scalars['String']['output']>;
  compoundKey?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['CalendarDay']['output']>;
  dimension?: Maybe<UserStatsDailyFactDimensionType>;
  id: Scalars['ID']['output'];
  moneySold?: Maybe<Scalars['Decimal']['output']>;
  moneySpent?: Maybe<Scalars['Decimal']['output']>;
  releasesAdded?: Maybe<Scalars['Int']['output']>;
  releasesRemoved?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  volumesAdded?: Maybe<Scalars['Int']['output']>;
  volumesRead?: Maybe<Scalars['Int']['output']>;
  volumesRemoved?: Maybe<Scalars['Int']['output']>;
  volumesSold?: Maybe<Scalars['Int']['output']>;
};

export type UserStatsDailyFactCreateInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['CalendarDay']['input']>;
  dimension?: InputMaybe<UserStatsDailyFactDimensionType>;
  moneySold?: InputMaybe<Scalars['Decimal']['input']>;
  moneySpent?: InputMaybe<Scalars['Decimal']['input']>;
  releasesAdded?: InputMaybe<Scalars['Int']['input']>;
  releasesRemoved?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
  volumesAdded?: InputMaybe<Scalars['Int']['input']>;
  volumesRead?: InputMaybe<Scalars['Int']['input']>;
  volumesRemoved?: InputMaybe<Scalars['Int']['input']>;
  volumesSold?: InputMaybe<Scalars['Int']['input']>;
};

export enum UserStatsDailyFactDimensionType {
  Publisher = 'publisher',
  ReleaseYear = 'releaseYear',
  Total = 'total',
  Type = 'type'
}

export type UserStatsDailyFactDimensionTypeNullableFilter = {
  equals?: InputMaybe<UserStatsDailyFactDimensionType>;
  in?: InputMaybe<Array<UserStatsDailyFactDimensionType>>;
  not?: InputMaybe<UserStatsDailyFactDimensionTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserStatsDailyFactDimensionType>>;
};

export type UserStatsDailyFactOrderByInput = {
  bucket?: InputMaybe<OrderDirection>;
  compoundKey?: InputMaybe<OrderDirection>;
  day?: InputMaybe<OrderDirection>;
  dimension?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  moneySold?: InputMaybe<OrderDirection>;
  moneySpent?: InputMaybe<OrderDirection>;
  releasesAdded?: InputMaybe<OrderDirection>;
  releasesRemoved?: InputMaybe<OrderDirection>;
  volumesAdded?: InputMaybe<OrderDirection>;
  volumesRead?: InputMaybe<OrderDirection>;
  volumesRemoved?: InputMaybe<OrderDirection>;
  volumesSold?: InputMaybe<OrderDirection>;
};

export type UserStatsDailyFactUpdateArgs = {
  data: UserStatsDailyFactUpdateInput;
  where: UserStatsDailyFactWhereUniqueInput;
};

export type UserStatsDailyFactUpdateInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['CalendarDay']['input']>;
  dimension?: InputMaybe<UserStatsDailyFactDimensionType>;
  moneySold?: InputMaybe<Scalars['Decimal']['input']>;
  moneySpent?: InputMaybe<Scalars['Decimal']['input']>;
  releasesAdded?: InputMaybe<Scalars['Int']['input']>;
  releasesRemoved?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  volumesAdded?: InputMaybe<Scalars['Int']['input']>;
  volumesRead?: InputMaybe<Scalars['Int']['input']>;
  volumesRemoved?: InputMaybe<Scalars['Int']['input']>;
  volumesSold?: InputMaybe<Scalars['Int']['input']>;
};

export type UserStatsDailyFactWhereInput = {
  AND?: InputMaybe<Array<UserStatsDailyFactWhereInput>>;
  NOT?: InputMaybe<Array<UserStatsDailyFactWhereInput>>;
  OR?: InputMaybe<Array<UserStatsDailyFactWhereInput>>;
  bucket?: InputMaybe<StringFilter>;
  compoundKey?: InputMaybe<StringFilter>;
  day?: InputMaybe<CalendarDayNullableFilter>;
  dimension?: InputMaybe<UserStatsDailyFactDimensionTypeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  moneySold?: InputMaybe<DecimalNullableFilter>;
  moneySpent?: InputMaybe<DecimalNullableFilter>;
  releasesAdded?: InputMaybe<IntNullableFilter>;
  releasesRemoved?: InputMaybe<IntNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  volumesAdded?: InputMaybe<IntNullableFilter>;
  volumesRead?: InputMaybe<IntNullableFilter>;
  volumesRemoved?: InputMaybe<IntNullableFilter>;
  volumesSold?: InputMaybe<IntNullableFilter>;
};

export type UserStatsDailyFactWhereUniqueInput = {
  compoundKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserTombstone = {
  __typename?: 'UserTombstone';
  entity: Scalars['String']['output'];
  rowId: Scalars['ID']['output'];
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  collection?: InputMaybe<UserReleaseEntryStatusRelateToManyForUpdateInput>;
  customLists?: InputMaybe<UserCustomListRelateToManyForUpdateInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<UserLanguageType>;
  missingIsbns?: InputMaybe<MissingIsbnRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationAddedReleaseDateToExistingReleaseCollectionItem?: InputMaybe<Scalars['Boolean']['input']>;
  notificationAtsumeRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem?: InputMaybe<Scalars['Boolean']['input']>;
  notificationFcmTokens?: InputMaybe<Scalars['String']['input']>;
  notificationNewReleasesFromAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  notificationNewReleasesFromAuthorsList?: InputMaybe<Scalars['String']['input']>;
  notificationNewReleasesFromPublishers?: InputMaybe<Scalars['Boolean']['input']>;
  notificationNewReleasesFromPublishersList?: InputMaybe<Scalars['String']['input']>;
  notificationReleaseCollectionItemAlternativeVersionRelease?: InputMaybe<Scalars['Boolean']['input']>;
  notificationReleaseCollectionItemAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationScannedItemAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<NotificationRelateToManyForUpdateInput>;
  profilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  profileVisibility?: InputMaybe<UserProfileVisibilityType>;
  showProfileStatistics?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  admin?: InputMaybe<UserAdminWhereInput>;
  avatarImage?: InputMaybe<UserImageWhereInput>;
  bannerImage?: InputMaybe<UserImageWhereInput>;
  bio?: InputMaybe<StringFilter>;
  collection?: InputMaybe<UserReleaseEntryStatusManyRelationFilter>;
  customLists?: InputMaybe<UserCustomListManyRelationFilter>;
  handle?: InputMaybe<StringNullableFilter>;
  handleChangedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  images?: InputMaybe<UserImageManyRelationFilter>;
  language?: InputMaybe<UserLanguageTypeNullableFilter>;
  missingIsbns?: InputMaybe<MissingIsbnManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notificationAddedReleaseDateToExistingReleaseCollectionItem?: InputMaybe<BooleanFilter>;
  notificationAtsumeRecommendations?: InputMaybe<BooleanFilter>;
  notificationChangedReleaseDateOfExistingReleaseCollectionItem?: InputMaybe<BooleanFilter>;
  notificationFcmTokens?: InputMaybe<StringFilter>;
  notificationNewReleasesFromAuthors?: InputMaybe<BooleanFilter>;
  notificationNewReleasesFromAuthorsList?: InputMaybe<StringFilter>;
  notificationNewReleasesFromPublishers?: InputMaybe<BooleanFilter>;
  notificationNewReleasesFromPublishersList?: InputMaybe<StringFilter>;
  notificationReleaseCollectionItemAlternativeVersionRelease?: InputMaybe<BooleanFilter>;
  notificationReleaseCollectionItemAvailable?: InputMaybe<BooleanFilter>;
  notificationScannedItemAvailable?: InputMaybe<BooleanFilter>;
  notifications?: InputMaybe<NotificationManyRelationFilter>;
  profilePublic?: InputMaybe<BooleanFilter>;
  profileVisibility?: InputMaybe<UserProfileVisibilityTypeNullableFilter>;
  showProfileStatistics?: InputMaybe<BooleanFilter>;
};

export type UserWhereUniqueInput = {
  admin?: InputMaybe<UserAdminWhereUniqueInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VlbUpdateConfig = {
  __typename?: 'VlbUpdateConfig';
  id: Scalars['ID']['output'];
  lastUpdateRun?: Maybe<Scalars['CalendarDay']['output']>;
};

export type VlbUpdateConfigCreateInput = {
  lastUpdateRun?: InputMaybe<Scalars['CalendarDay']['input']>;
};

export type VlbUpdateConfigOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  lastUpdateRun?: InputMaybe<OrderDirection>;
};

export type VlbUpdateConfigUpdateArgs = {
  data: VlbUpdateConfigUpdateInput;
  where: VlbUpdateConfigWhereUniqueInput;
};

export type VlbUpdateConfigUpdateInput = {
  lastUpdateRun?: InputMaybe<Scalars['CalendarDay']['input']>;
};

export type VlbUpdateConfigWhereInput = {
  AND?: InputMaybe<Array<VlbUpdateConfigWhereInput>>;
  NOT?: InputMaybe<Array<VlbUpdateConfigWhereInput>>;
  OR?: InputMaybe<Array<VlbUpdateConfigWhereInput>>;
  id?: InputMaybe<IdFilter>;
  lastUpdateRun?: InputMaybe<CalendarDayNullableFilter>;
};

export type VlbUpdateConfigWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VolumeSuffix = {
  __typename?: 'VolumeSuffix';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type VolumeSuffixCreateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VolumeSuffixOrderByInput = {
  abbreviation?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type VolumeSuffixUpdateArgs = {
  data: VolumeSuffixUpdateInput;
  where: VolumeSuffixWhereUniqueInput;
};

export type VolumeSuffixUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VolumeSuffixWhereInput = {
  AND?: InputMaybe<Array<VolumeSuffixWhereInput>>;
  NOT?: InputMaybe<Array<VolumeSuffixWhereInput>>;
  OR?: InputMaybe<Array<VolumeSuffixWhereInput>>;
  abbreviation?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type VolumeSuffixWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RecordUserActivityMutationVariables = Exact<{ [key: string]: never; }>;


export type RecordUserActivityMutation = { __typename?: 'Mutation', recordUserActivity: string };

export type GetPublishedDatabaseListConfigsQueryVariables = Exact<{
  where: DatabaseListConfigWhereInput;
  orderBy: Array<DatabaseListConfigOrderByInput> | DatabaseListConfigOrderByInput;
}>;


export type GetPublishedDatabaseListConfigsQuery = { __typename?: 'Query', databaseListConfigs?: Array<{ __typename?: 'DatabaseListConfig', id: string, urlName?: string | null, nameDe?: string | null, nameEn?: string | null, subtitleDe?: string | null, subtitleEn?: string | null, mode?: DatabaseListConfigModeType | null, listType?: DatabaseListConfigListTypeType | null, filter?: any | null, sort?: any | null, ignoredFilterPropsForChangeDetection?: any | null, hideSearch?: boolean | null, order?: number | null }> | null };

export type GetMyCustomListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCustomListsQuery = { __typename?: 'Query', userCustomLists?: Array<{ __typename?: 'UserCustomList', id: string, urlName?: string | null, name?: string | null, description?: string | null, targetType?: UserCustomListTargetTypeType | null, mode?: UserCustomListModeType | null, isPublic?: boolean | null, isCustomTag?: boolean | null, customTagName?: string | null, customIcon?: string | null, removeWhenCollected?: boolean | null, removeWhenRead?: boolean | null, showTotalNumber?: boolean | null, showTotalValue?: boolean | null, statusFilter?: UserCustomListStatusFilterType | null, filter?: any | null, sort?: any | null, order?: number | null }> | null };

export type UserCustomListStatsQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
}>;


export type UserCustomListStatsQuery = { __typename?: 'Query', userCustomListStats?: { __typename?: 'UserCustomListStats', itemCount: number, seriesCount: number, volumeCount: number, totalValue: number } | null };

export type GetUserCustomListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserCustomListQuery = { __typename?: 'Query', userCustomList?: { __typename?: 'UserCustomList', id: string, urlName?: string | null, name?: string | null, description?: string | null, targetType?: UserCustomListTargetTypeType | null, mode?: UserCustomListModeType | null, isPublic?: boolean | null, isCustomTag?: boolean | null, customTagName?: string | null, customIcon?: string | null, removeWhenCollected?: boolean | null, removeWhenRead?: boolean | null, showTotalNumber?: boolean | null, showTotalValue?: boolean | null, statusFilter?: UserCustomListStatusFilterType | null, filter?: any | null, sort?: any | null, order?: number | null, curatedReleaseEntriesCount?: number | null, curatedNoveltiesCount?: number | null } | null };

export type GetDatabaseListCuratedEntriesQueryVariables = Exact<{
  where: DatabaseListReleaseEntryWhereInput;
  orderBy: Array<DatabaseListReleaseEntryOrderByInput> | DatabaseListReleaseEntryOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetDatabaseListCuratedEntriesQuery = { __typename?: 'Query', databaseListReleaseEntries?: Array<{ __typename?: 'DatabaseListReleaseEntry', id: string, orderNumber?: number | null, releaseEntry?: { __typename?: 'ReleaseEntry', cover?: string | null, thumbHash?: string | null, id: string, status?: ReleaseEntryStatusType | null, internalName?: string | null, type?: ReleaseEntryTypeType | null, publisherName?: string | null, startDate?: any | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null } | null }> | null };

export type GetUserListCuratedEntriesQueryVariables = Exact<{
  where: UserCustomListReleaseEntryItemWhereInput;
  orderBy: Array<UserCustomListReleaseEntryItemOrderByInput> | UserCustomListReleaseEntryItemOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetUserListCuratedEntriesQuery = { __typename?: 'Query', userCustomListReleaseEntryItems?: Array<{ __typename?: 'UserCustomListReleaseEntryItem', id: string, orderNumber?: number | null, releaseEntry?: { __typename?: 'ReleaseEntry', cover?: string | null, thumbHash?: string | null, id: string, status?: ReleaseEntryStatusType | null, internalName?: string | null, type?: ReleaseEntryTypeType | null, publisherName?: string | null, startDate?: any | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null } | null }> | null };

export type GetUserListCuratedNoveltiesQueryVariables = Exact<{
  where: UserCustomListNoveltyItemWhereInput;
  orderBy: Array<UserCustomListNoveltyItemOrderByInput> | UserCustomListNoveltyItemOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetUserListCuratedNoveltiesQuery = { __typename?: 'Query', userCustomListNoveltyItems?: Array<{ __typename?: 'UserCustomListNoveltyItem', id: string, orderNumber?: number | null, novelty?: { __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, romanizedSeriesTitle?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null } | null }> | null };

export type GetFilteredCustomListNoveltiesQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
  where: NoveltyWhereInput;
  orderBy: Array<NoveltyOrderByInput> | NoveltyOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredCustomListNoveltiesQuery = { __typename?: 'Query', filteredCustomListNovelties?: Array<{ __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, romanizedSeriesTitle?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null, collectionVolumeInfo?: { __typename?: 'NoveltyCollectionVolumeInfo', volumeCount: number, spansEntries: boolean } | null }> | null };

export type GetFilteredCustomListReleaseEntriesQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
  where: ReleaseEntryWhereInput;
  orderBy: Array<ReleaseEntryOrderByInput> | ReleaseEntryOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredCustomListReleaseEntriesQuery = { __typename?: 'Query', filteredReleaseEntries?: Array<{ __typename?: 'ReleaseEntry', cover?: string | null, thumbHash?: string | null, id: string, status?: ReleaseEntryStatusType | null, internalName?: string | null, type?: ReleaseEntryTypeType | null, publisherName?: string | null, startDate?: any | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null }> | null };

export type CreateUserCustomListMutationVariables = Exact<{
  data: UserCustomListCreateInput;
}>;


export type CreateUserCustomListMutation = { __typename?: 'Mutation', createUserCustomList?: { __typename?: 'UserCustomList', id: string, urlName?: string | null } | null };

export type UpdateUserCustomListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UserCustomListUpdateInput;
}>;


export type UpdateUserCustomListMutation = { __typename?: 'Mutation', updateUserCustomList?: { __typename?: 'UserCustomList', id: string } | null };

export type DeleteUserCustomListWithItemsMutationVariables = Exact<{
  listId: Scalars['ID']['input'];
}>;


export type DeleteUserCustomListWithItemsMutation = { __typename?: 'Mutation', deleteUserCustomListWithItems?: { __typename?: 'UserCustomList', id: string } | null };

export type GetMyCuratedListsWithMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCuratedListsWithMembersQuery = { __typename?: 'Query', userCustomLists?: Array<{ __typename?: 'UserCustomList', id: string, name?: string | null, targetType?: UserCustomListTargetTypeType | null, isCustomTag?: boolean | null, customTagName?: string | null, removeWhenCollected?: boolean | null, removeWhenRead?: boolean | null, curatedReleaseEntries?: Array<{ __typename?: 'UserCustomListReleaseEntryItem', id: string, releaseEntry?: { __typename?: 'ReleaseEntry', id: string } | null }> | null, curatedNovelties?: Array<{ __typename?: 'UserCustomListNoveltyItem', id: string, novelty?: { __typename?: 'Novelty', id: string, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, number?: any | null, volumeSuffix?: string | null, releaseItems?: any | null, collectionVolumeInfo?: { __typename?: 'NoveltyCollectionVolumeInfo', kind: string } | null } | null }> | null }> | null };

export type GetNoveltyIdByRelationQueryVariables = Exact<{
  relationId: Scalars['String']['input'];
}>;


export type GetNoveltyIdByRelationQuery = { __typename?: 'Query', novelties?: Array<{ __typename?: 'Novelty', id: string }> | null };

export type AddReleaseEntryToCustomListMutationVariables = Exact<{
  listId: Scalars['ID']['input'];
  releaseEntryId: Scalars['ID']['input'];
}>;


export type AddReleaseEntryToCustomListMutation = { __typename?: 'Mutation', createUserCustomListReleaseEntryItem?: { __typename?: 'UserCustomListReleaseEntryItem', id: string } | null };

export type RemoveReleaseEntryFromCustomListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveReleaseEntryFromCustomListMutation = { __typename?: 'Mutation', deleteUserCustomListReleaseEntryItem?: { __typename?: 'UserCustomListReleaseEntryItem', id: string } | null };

export type AddNoveltyToCustomListMutationVariables = Exact<{
  listId: Scalars['ID']['input'];
  noveltyId: Scalars['ID']['input'];
}>;


export type AddNoveltyToCustomListMutation = { __typename?: 'Mutation', createUserCustomListNoveltyItem?: { __typename?: 'UserCustomListNoveltyItem', id: string } | null };

export type RemoveNoveltyFromCustomListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveNoveltyFromCustomListMutation = { __typename?: 'Mutation', deleteUserCustomListNoveltyItem?: { __typename?: 'UserCustomListNoveltyItem', id: string } | null };

export type GetReleaseItemsQueryVariables = Exact<{
  where: ReleaseItemWhereInput;
  orderBy: Array<ReleaseItemOrderByInput> | ReleaseItemOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetReleaseItemsQuery = { __typename?: 'Query', releaseItems?: Array<{ __typename?: 'ReleaseItem', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, title?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, originalCover?: string | null, releaseDate?: any | null, releaseDateAccuracy?: ReleaseItemReleaseDateAccuracyType | null, entryId?: string | null, extrasNote?: string | null, extrasOnlyOnFirstEdition?: boolean | null, pages?: number | null, size?: string | null, format?: string | null, description?: { __typename?: 'ReleaseItem_description_Document', document: any } | null, publisherDescription?: { __typename?: 'ReleaseItem_publisherDescription_Document', document: any } | null }> | null };

export type GetVolumeSuffixesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVolumeSuffixesQuery = { __typename?: 'Query', volumeSuffixes?: Array<{ __typename?: 'VolumeSuffix', id: string, name?: string | null, abbreviation?: string | null }> | null };

export type GetReleaseItemCollectionsQueryVariables = Exact<{
  where: ReleaseItemCollectionWhereInput;
  orderBy: Array<ReleaseItemCollectionOrderByInput> | ReleaseItemCollectionOrderByInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReleaseItemCollectionsQuery = { __typename?: 'Query', releaseItemCollections?: Array<{ __typename?: 'ReleaseItemCollection', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, price?: any | null, name?: string | null, localizedSeriesTitle?: string | null, publisherName?: string | null, format?: string | null, size?: string | null, pages?: number | null, extrasNote?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: ReleaseItemCollectionReleaseDateAccuracyType | null, entryId?: string | null, description?: { __typename?: 'ReleaseItemCollection_description_Document', document: any } | null, publisherDescription?: { __typename?: 'ReleaseItemCollection_publisherDescription_Document', document: any } | null, releaseItems?: Array<{ __typename?: 'ReleaseItem', id: string, number?: any | null, volumeSuffix?: string | null, entryId?: string | null, localizedSeriesTitle?: string | null }> | null }> | null };

export type GetNoveltiesQueryVariables = Exact<{
  where: NoveltyWhereInput;
  orderBy: Array<NoveltyOrderByInput> | NoveltyOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetNoveltiesQuery = { __typename?: 'Query', novelties?: Array<{ __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, romanizedSeriesTitle?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null }> | null };

export type GetCatalogChangesQueryVariables = Exact<{
  sinceSeq: Scalars['String']['input'];
  subscription: CatalogSubscriptionInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCatalogChangesQuery = { __typename?: 'Query', catalogChanges?: { __typename?: 'CatalogDeltaPage', nextSeq: string, headSeq: string, hasMore: boolean, resyncRequired: boolean, tombstones: Array<{ __typename?: 'CatalogTombstone', entity: string, rowId: string }>, novelties: Array<{ __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, romanizedSeriesTitle?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null, type?: string | null, releaseYear?: number | null, releaseMonth?: number | null, disabled?: boolean | null, titleSearch?: string | null, tagSearchField?: string | null, demographySearchField?: string | null }>, releaseEntries: Array<{ __typename?: 'ReleaseEntry', id: string, internalName?: string | null, disabled?: boolean | null, status?: ReleaseEntryStatusType | null, cover?: string | null, thumbHash?: string | null, endDate?: any | null, startDate?: any | null, releaseYear?: number | null, releaseMonth?: number | null, yearMonthKey?: string | null, popularityScore?: any | null, recommendationScore?: any | null, firstVolumeNumber?: any | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalVolumes?: number | null, totalNotReleasedVolumes?: number | null, totalReleasedVolumes?: number | null, publisherName?: string | null, publisherHistory?: any | null, type?: ReleaseEntryTypeType | null, creationDate?: any | null, updatedDate?: any | null, needsToBeCheckedReason?: string | null, tagSearchField?: string | null, demographySearchField?: string | null, titleSearch?: string | null, description?: { __typename?: 'ReleaseEntry_description_Document', document: any } | null, seriesInfo?: { __typename?: 'SeriesInfo', id: string } | null, size?: { __typename?: 'SizeInfo', id: string } | null, staffs?: Array<{ __typename?: 'StaffEntry', id: string }> | null, material?: Array<{ __typename?: 'MaterialInfo', id: string }> | null }>, releaseItems: Array<{ __typename?: 'ReleaseItem', id: string, disabled?: boolean | null, disableNovelty?: boolean | null, entryId?: string | null, publisherName?: string | null, type?: string | null, localizedSeriesTitle?: string | null, romanizedSeriesTitle?: string | null, volumeSuffix?: string | null, cover?: string | null, thumbHash?: string | null, originalCover?: string | null, number?: any | null, title?: string | null, isbn?: string | null, originalIsbn?: string | null, releaseDateAccuracy?: ReleaseItemReleaseDateAccuracyType | null, releaseDate?: any | null, releaseYear?: number | null, releaseMonth?: number | null, yearMonthKey?: string | null, extrasOnlyOnFirstEdition?: boolean | null, price?: any | null, creationDate?: any | null, updatedDate?: any | null, needsToBeCheckedReason?: string | null, extrasNote?: string | null, notes?: string | null, pages?: number | null, format?: string | null, currentEditionNumber?: number | null, color?: string | null, size?: string | null, tagSearchField?: string | null, description?: { __typename?: 'ReleaseItem_description_Document', document: any } | null, publisherDescription?: { __typename?: 'ReleaseItem_publisherDescription_Document', document: any } | null }>, releaseItemCollections: Array<{ __typename?: 'ReleaseItemCollection', id: string, name?: string | null, cover?: string | null, thumbHash?: string | null, entryId?: string | null, publisherName?: string | null, type?: string | null, localizedSeriesTitle?: string | null, romanizedSeriesTitle?: string | null, disabled?: boolean | null, itemsOnlyExistInThisCollection?: boolean | null, volumeSuffix?: string | null, number?: any | null, isbn?: string | null, releaseDateAccuracy?: ReleaseItemCollectionReleaseDateAccuracyType | null, releaseDate?: any | null, releaseYear?: number | null, releaseMonth?: number | null, price?: any | null, extrasNote?: string | null, notes?: string | null, pages?: number | null, format?: string | null, currentEditionNumber?: number | null, color?: string | null, size?: string | null, tagSearchField?: string | null, description?: { __typename?: 'ReleaseItemCollection_description_Document', document: any } | null, publisherDescription?: { __typename?: 'ReleaseItemCollection_publisherDescription_Document', document: any } | null, releaseItems?: Array<{ __typename?: 'ReleaseItem', id: string }> | null }>, publishers: Array<{ __typename?: 'Publisher', id: string, name?: string | null, disabled?: boolean | null, publisherChangeEvents?: any | null, sortOrder?: number | null, url?: string | null, vlbId?: string | null, vlbKeyword?: string | null, vlbSubjectFilter?: string | null, vlbTitleFilter?: string | null, colorLightTheme?: string | null, colorDarkTheme?: string | null, longName?: string | null, lastUpdateRun?: any | null, defaultVlbTextTypeCodes?: string | null, connector?: string | null, betterCoverProvider?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string | null, sortNumber?: number | null, tagType?: TagTagTypeType | null, promotionStartDate?: any | null, promotionEndDate?: any | null }>, demographies: Array<{ __typename?: 'Demography', id: string, name?: string | null }>, volumeSuffixes: Array<{ __typename?: 'VolumeSuffix', id: string, name?: string | null, abbreviation?: string | null }>, seriesInfos: Array<{ __typename?: 'SeriesInfo', id: string, country?: string | null, originalTitle?: string | null, romanizedTitle?: string | null, type?: SeriesInfoTypeType | null, status?: SeriesInfoStatusType | null, startYear?: string | null, description?: { __typename?: 'SeriesInfo_description_Document', document: any } | null, staffs?: Array<{ __typename?: 'StaffEntry', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, demography?: Array<{ __typename?: 'Demography', id: string }> | null, jpPublishers?: Array<{ __typename?: 'JpPublisher', id: string }> | null, magazines?: Array<{ __typename?: 'Magazine', id: string }> | null }>, staffEntries: Array<{ __typename?: 'StaffEntry', id: string, label?: string | null, originalVlb71Code?: string | null, individual?: { __typename?: 'Individual', id: string } | null, job?: Array<{ __typename?: 'Job', id: string }> | null }>, individuals: Array<{ __typename?: 'Individual', id: string, exId?: string | null, name?: string | null, firstName?: string | null, middleNames?: string | null, lastName?: string | null, birthDate?: any | null, handle?: string | null, disambiguator?: string | null }>, jobs: Array<{ __typename?: 'Job', id: string, title?: string | null, vlb71Codes?: string | null }>, magazines: Array<{ __typename?: 'Magazine', id: string, name?: string | null }>, jpPublishers: Array<{ __typename?: 'JpPublisher', id: string, name?: string | null }>, sizeInfos: Array<{ __typename?: 'SizeInfo', id: string, label?: string | null, sizeAliasName?: string | null, width?: any | null, height?: any | null, depth?: any | null }>, materialInfos: Array<{ __typename?: 'MaterialInfo', id: string, name?: string | null, description?: { __typename?: 'MaterialInfo_description_Document', document: any } | null }>, databaseListConfigs: Array<{ __typename?: 'DatabaseListConfig', id: string, urlName?: string | null, nameDe?: string | null, nameEn?: string | null, subtitleDe?: string | null, subtitleEn?: string | null, mode?: DatabaseListConfigModeType | null, listType?: DatabaseListConfigListTypeType | null, filter?: any | null, sort?: any | null, ignoredFilterPropsForChangeDetection?: any | null, hideSearch?: boolean | null, enabled?: boolean | null, order?: number | null }>, databaseListReleaseEntries: Array<{ __typename?: 'DatabaseListReleaseEntry', id: string, orderNumber?: number | null, compoundKey?: string | null, databaseList?: { __typename?: 'DatabaseListConfig', id: string } | null, releaseEntry?: { __typename?: 'ReleaseEntry', id: string } | null }> } | null };

export type GetFilteredNoveltiesQueryVariables = Exact<{
  where: NoveltyWhereInput;
  orderBy: Array<NoveltyOrderByInput> | NoveltyOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredNoveltiesQuery = { __typename?: 'Query', filteredNovelties?: Array<{ __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, isbn?: string | null, romanizedSeriesTitle?: string | null, price?: any | null, publisherName?: string | null, localizedSeriesTitle?: string | null, cover?: string | null, thumbHash?: string | null, releaseDate?: any | null, releaseDateAccuracy?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null, collectionVolumeInfo?: { __typename?: 'NoveltyCollectionVolumeInfo', volumeCount: number, spansEntries: boolean } | null }> | null };

export type GetTagsQueryVariables = Exact<{
  orderBy: Array<TagOrderByInput> | TagOrderByInput;
}>;


export type GetTagsQuery = { __typename?: 'Query', tags?: Array<{ __typename?: 'Tag', id: string, name?: string | null, tagType?: TagTagTypeType | null, promotionStartDate?: any | null, promotionEndDate?: any | null }> | null };

export type GetDemographiesQueryVariables = Exact<{
  orderBy: Array<DemographyOrderByInput> | DemographyOrderByInput;
}>;


export type GetDemographiesQuery = { __typename?: 'Query', demographies?: Array<{ __typename?: 'Demography', id: string, name?: string | null }> | null };

export type GetPublishersQueryVariables = Exact<{
  orderBy: Array<PublisherOrderByInput> | PublisherOrderByInput;
  where: PublisherWhereInput;
}>;


export type GetPublishersQuery = { __typename?: 'Query', publishers?: Array<{ __typename?: 'Publisher', id: string, name?: string | null, url?: string | null, colorDarkTheme?: string | null, colorLightTheme?: string | null }> | null };

export type GetUserAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAdminQuery = { __typename?: 'Query', userAdmins?: Array<{ __typename?: 'UserAdmin', id: string, userId?: string | null, adSkipTokens?: number | null, isTester?: boolean | null, premiumTier?: string | null, premiumStartDate?: any | null, premiumLastRenewalDate?: any | null, user?: { __typename?: 'User', id: string } | null }> | null };

export type GetMissingIsbnsQueryVariables = Exact<{
  where: MissingIsbnWhereInput;
}>;


export type GetMissingIsbnsQuery = { __typename?: 'Query', missingIsbns?: Array<{ __typename?: 'MissingIsbn', id: string, userExplanation?: string | null }> | null };

export type MutationMutationVariables = Exact<{
  data: MissingIsbnCreateInput;
}>;


export type MutationMutation = { __typename?: 'Mutation', createMissingIsbn?: { __typename?: 'MissingIsbn', id: string } | null };

export type UpdateMissingIsbnMutationVariables = Exact<{
  where: MissingIsbnWhereUniqueInput;
  data: MissingIsbnUpdateInput;
}>;


export type UpdateMissingIsbnMutation = { __typename?: 'Mutation', updateMissingIsbn?: { __typename?: 'MissingIsbn', id: string } | null };

export type GetUserExistingCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserExistingCollectionsQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, collection?: Array<{ __typename?: 'UserReleaseEntryStatus', id: string, collectionStatus?: UserReleaseEntryStatusCollectionStatusType | null, currentReadStatus?: UserReleaseEntryStatusCurrentReadStatusType | null, startDate?: any | null, endDate?: any | null, itemStatus?: any | null, miscItemStatus?: any | null, entry?: { __typename?: 'ReleaseEntry', id: string, status?: ReleaseEntryStatusType | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null, startDate?: any | null, endDate?: any | null } | null, readStatus?: Array<{ __typename?: 'UserReleaseReadStatus', id: string, finishedRead?: any | null, readStatus?: any | null, startedRead?: any | null, status?: UserReleaseReadStatusStatusType | null }> | null }> | null }> | null };

export type GetReleaseEntryQueryVariables = Exact<{
  where: ReleaseEntryWhereUniqueInput;
}>;


export type GetReleaseEntryQuery = { __typename?: 'Query', releaseEntry?: { __typename?: 'ReleaseEntry', internalName?: string | null, publisherName?: string | null, id: string } | null };

export type GetReleaseEntriesQueryVariables = Exact<{
  where: ReleaseEntryWhereInput;
  orderBy: Array<ReleaseEntryOrderByInput> | ReleaseEntryOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type GetReleaseEntriesQuery = { __typename?: 'Query', releaseEntries?: Array<{ __typename?: 'ReleaseEntry', cover?: string | null, thumbHash?: string | null, id: string, status?: ReleaseEntryStatusType | null, internalName?: string | null, type?: ReleaseEntryTypeType | null, publisherName?: string | null, startDate?: any | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null }> | null };

export type UserCollectionEntriesQueryVariables = Exact<{
  where: UserReleaseEntryStatusWhereInput;
  orderBy: Array<UserReleaseEntryStatusOrderByInput> | UserReleaseEntryStatusOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
}>;


export type UserCollectionEntriesQuery = { __typename?: 'Query', userReleaseEntryStatuses?: Array<{ __typename?: 'UserReleaseEntryStatus', id: string, currentReadStatus?: UserReleaseEntryStatusCurrentReadStatusType | null, internalName?: string | null, publisherName?: string | null, startDate?: any | null, endDate?: any | null, entry?: { __typename?: 'ReleaseEntry', id: string, type?: ReleaseEntryTypeType | null, cover?: string | null, thumbHash?: string | null, status?: ReleaseEntryStatusType | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null } | null }> | null };

export type FilteredUserCollectionEntriesQueryVariables = Exact<{
  where: UserReleaseEntryStatusWhereInput;
  orderBy: Array<UserReleaseEntryStatusOrderByInput> | UserReleaseEntryStatusOrderByInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Int']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilteredUserCollectionEntriesQuery = { __typename?: 'Query', filteredUserReleaseEntryStatuses?: Array<{ __typename?: 'UserReleaseEntryStatus', id: string, currentReadStatus?: UserReleaseEntryStatusCurrentReadStatusType | null, internalName?: string | null, publisherName?: string | null, startDate?: any | null, endDate?: any | null, entry?: { __typename?: 'ReleaseEntry', id: string, type?: ReleaseEntryTypeType | null, cover?: string | null, thumbHash?: string | null, status?: ReleaseEntryStatusType | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null } | null }> | null };

export type UpdateUserCollectionMutationVariables = Exact<{
  where: UserReleaseEntryStatusWhereUniqueInput;
  data: UserReleaseEntryStatusUpdateInput;
}>;


export type UpdateUserCollectionMutation = { __typename?: 'Mutation', updateUserReleaseEntryStatus?: { __typename?: 'UserReleaseEntryStatus', id: string, entry?: { __typename?: 'ReleaseEntry', internalName?: string | null, id: string } | null } | null };

export type RemoveUserCollectionMutationVariables = Exact<{
  where: UserReleaseEntryStatusWhereUniqueInput;
  eventDate: Scalars['DateTime']['input'];
}>;


export type RemoveUserCollectionMutation = { __typename?: 'Mutation', deleteUserReleaseEntryStatusWithEvent?: { __typename?: 'UserReleaseEntryStatus', id: string } | null };

export type UpdateReadStatusMutationVariables = Exact<{
  where: UserReleaseReadStatusWhereUniqueInput;
  data: UserReleaseReadStatusUpdateInput;
}>;


export type UpdateReadStatusMutation = { __typename?: 'Mutation', updateUserReleaseReadStatus?: { __typename?: 'UserReleaseReadStatus', id: string } | null };

export type CreateUserCollectionMutationVariables = Exact<{
  data: UserReleaseEntryStatusCreateInput;
}>;


export type CreateUserCollectionMutation = { __typename?: 'Mutation', createUserReleaseEntryStatus?: { __typename?: 'UserReleaseEntryStatus', id: string, entry?: { __typename?: 'ReleaseEntry', id: string, internalName?: string | null } | null, readStatus?: Array<{ __typename?: 'UserReleaseReadStatus', id: string }> | null } | null };

export type GetSharedCollectionSiblingEntriesQueryVariables = Exact<{
  where: ReleaseItemCollectionWhereInput;
}>;


export type GetSharedCollectionSiblingEntriesQuery = { __typename?: 'Query', releaseItemCollections?: Array<{ __typename?: 'ReleaseItemCollection', id: string, sharedGroup?: { __typename?: 'SharedReleaseCollection', id: string, collections?: Array<{ __typename?: 'ReleaseItemCollection', id: string, entryId?: string | null }> | null } | null }> | null };

export type GetSingleUserCollectionQueryVariables = Exact<{
  where: UserReleaseEntryStatusWhereInput;
}>;


export type GetSingleUserCollectionQuery = { __typename?: 'Query', userReleaseEntryStatuses?: Array<{ __typename?: 'UserReleaseEntryStatus', id: string, collectionStatus?: UserReleaseEntryStatusCollectionStatusType | null, currentReadStatus?: UserReleaseEntryStatusCurrentReadStatusType | null, itemStatus?: any | null, miscItemStatus?: any | null, entry?: { __typename?: 'ReleaseEntry', id: string, status?: ReleaseEntryStatusType | null, internalName?: string | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, startDate?: any | null, endDate?: any | null } | null, readStatus?: Array<{ __typename?: 'UserReleaseReadStatus', id: string, finishedRead?: any | null, readStatus?: any | null, startedRead?: any | null, status?: UserReleaseReadStatusStatusType | null }> | null }> | null };

export type GetReleaseEntryIdFromIsbnQueryVariables = Exact<{
  where: ReleaseItemWhereInput;
}>;


export type GetReleaseEntryIdFromIsbnQuery = { __typename?: 'Query', releaseItems?: Array<{ __typename?: 'ReleaseItem', number?: any | null, volumeSuffix?: string | null, entryId?: string | null, localizedSeriesTitle?: string | null, isbn?: string | null }> | null };

export type GetUserNotificationTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationTokensQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, notificationFcmTokens?: string | null }> | null };

export type UpdateUserNotificationTokensMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserNotificationTokensMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, notificationFcmTokens?: string | null } | null };

export type GetNoveltyByIsbnQueryVariables = Exact<{
  where: NoveltyWhereInput;
}>;


export type GetNoveltyByIsbnQuery = { __typename?: 'Query', novelties?: Array<{ __typename?: 'Novelty', id: string, number?: any | null, volumeSuffix?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, releaseItems?: any | null }> | null };

export type GetNoveltiesByIsbNsQueryVariables = Exact<{
  where: NoveltyWhereInput;
}>;


export type GetNoveltiesByIsbNsQuery = { __typename?: 'Query', novelties?: Array<{ __typename?: 'Novelty', id: string, isbn?: string | null, number?: any | null, volumeSuffix?: string | null, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, localizedSeriesTitle?: string | null, publisherName?: string | null, cover?: string | null, thumbHash?: string | null }> | null };

export type GetReleaseEntriesWithSeriesInfoQueryVariables = Exact<{
  where: ReleaseEntryWhereUniqueInput;
}>;


export type GetReleaseEntriesWithSeriesInfoQuery = { __typename?: 'Query', releaseEntry?: { __typename?: 'ReleaseEntry', id: string, internalName?: string | null, type?: ReleaseEntryTypeType | null, cover?: string | null, thumbHash?: string | null, publisherName?: string | null, status?: ReleaseEntryStatusType | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null, startDate?: any | null, endDate?: any | null, releaseItemsCount?: number | null, size?: { __typename?: 'SizeInfo', id: string, sizeAliasName?: string | null, width?: any | null, height?: any | null, depth?: any | null } | null, material?: Array<{ __typename?: 'MaterialInfo', id: string, name?: string | null }> | null, description?: { __typename?: 'ReleaseEntry_description_Document', document: any } | null, seriesInfo?: { __typename?: 'SeriesInfo', id: string, status?: SeriesInfoStatusType | null, originalTitle?: string | null, romanizedTitle?: string | null, country?: string | null, jpPublishers?: Array<{ __typename?: 'JpPublisher', id: string, name?: string | null }> | null, magazines?: Array<{ __typename?: 'Magazine', id: string, name?: string | null }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name?: string | null }> | null, demography?: Array<{ __typename?: 'Demography', id: string, name?: string | null }> | null, staffs?: Array<{ __typename?: 'StaffEntry', id: string, job?: Array<{ __typename?: 'Job', id: string, title?: string | null }> | null, individual?: { __typename?: 'Individual', id: string, name?: string | null } | null }> | null } | null, staffs?: Array<{ __typename?: 'StaffEntry', id: string, job?: Array<{ __typename?: 'Job', id: string, title?: string | null }> | null, individual?: { __typename?: 'Individual', id: string, name?: string | null } | null }> | null, releaseCollections?: Array<{ __typename?: 'ReleaseItemCollection', id: string, number?: any | null }> | null } | null };

export type GetUserNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationSettingsQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, notificationNewReleasesFromPublishers?: boolean | null, notificationNewReleasesFromPublishersList?: string | null, notificationNewReleasesFromAuthors?: boolean | null, notificationNewReleasesFromAuthorsList?: string | null, notificationAddedReleaseDateToExistingReleaseCollectionItem?: boolean | null, notificationChangedReleaseDateOfExistingReleaseCollectionItem?: boolean | null, notificationReleaseCollectionItemAvailable?: boolean | null, notificationReleaseCollectionItemAlternativeVersionRelease?: boolean | null, notificationScannedItemAvailable?: boolean | null, notificationAtsumeRecommendations?: boolean | null }> | null };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, notificationNewReleasesFromPublishers?: boolean | null, notificationNewReleasesFromPublishersList?: string | null, notificationNewReleasesFromAuthors?: boolean | null, notificationNewReleasesFromAuthorsList?: string | null, notificationAddedReleaseDateToExistingReleaseCollectionItem?: boolean | null, notificationChangedReleaseDateOfExistingReleaseCollectionItem?: boolean | null, notificationReleaseCollectionItemAvailable?: boolean | null, notificationReleaseCollectionItemAlternativeVersionRelease?: boolean | null, notificationScannedItemAvailable?: boolean | null, notificationAtsumeRecommendations?: boolean | null } | null };

export type SearchPublishersQueryVariables = Exact<{
  where: PublisherWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPublishersQuery = { __typename?: 'Query', publishers?: Array<{ __typename?: 'Publisher', id: string, name?: string | null }> | null };

export type GetPublishersByIdsQueryVariables = Exact<{
  where: PublisherWhereInput;
}>;


export type GetPublishersByIdsQuery = { __typename?: 'Query', publishers?: Array<{ __typename?: 'Publisher', id: string, name?: string | null }> | null };

export type SearchIndividualsQueryVariables = Exact<{
  where: IndividualWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchIndividualsQuery = { __typename?: 'Query', individuals?: Array<{ __typename?: 'Individual', id: string, name?: string | null }> | null };

export type GetIndividualsByIdsQueryVariables = Exact<{
  where: IndividualWhereInput;
}>;


export type GetIndividualsByIdsQuery = { __typename?: 'Query', individuals?: Array<{ __typename?: 'Individual', id: string, name?: string | null }> | null };

export type GetNotificationsQueryVariables = Exact<{
  orderBy: Array<NotificationOrderByInput> | NotificationOrderByInput;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', id: string, type?: string | null, content?: any | null, timeRead?: any | null, createdAt?: any | null }> | null };

export type GetUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsCountQuery = { __typename?: 'Query', notificationsCount?: number | null };

export type UpdateNotificationMutationVariables = Exact<{
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification?: { __typename?: 'Notification', id: string, timeRead?: any | null } | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, admin?: { __typename?: 'UserAdmin', id: string, createdAt?: any | null } | null }> | null };

export type UpdateUserNameMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, name?: string | null } | null };

export type GetMyCollectionStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCollectionStatsQuery = { __typename?: 'Query', userCollectionStatsItems?: Array<{ __typename?: 'UserCollectionStats', id: string, collectedVolumes?: number | null, readVolumes?: number | null, totalListPrice?: any | null, releasesByStatus?: any | null, soldVolumes?: number | null, soldValue?: any | null }> | null };

export type GetMyRecentStatsQueryVariables = Exact<{
  since: Scalars['CalendarDay']['input'];
}>;


export type GetMyRecentStatsQuery = { __typename?: 'Query', userStatsDailyFacts?: Array<{ __typename?: 'UserStatsDailyFact', id: string, volumesAdded?: number | null, volumesRead?: number | null }> | null };

export type GetUserChangesQueryVariables = Exact<{
  sinceSeq: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserChangesQuery = { __typename?: 'Query', userChanges?: { __typename?: 'UserDeltaPage', nextSeq: string, headSeq: string, hasMore: boolean, resyncRequired: boolean, userAdmins: Array<{ __typename?: 'UserAdmin', id: string, userId?: string | null, isGuest?: boolean | null, isAdmin?: boolean | null, isTester?: boolean | null, premiumTier?: string | null, premiumStartDate?: any | null, premiumLastRenewalDate?: any | null, createdAt?: any | null, adSkipTokens?: number | null }>, userReleaseEntryStatuses: Array<{ __typename?: 'UserReleaseEntryStatus', id: string, collectionStatus?: UserReleaseEntryStatusCollectionStatusType | null, currentReadStatus?: UserReleaseEntryStatusCurrentReadStatusType | null, startDate?: any | null, endDate?: any | null, itemStatus?: any | null, miscItemStatus?: any | null, internalName?: string | null, publisherName?: string | null, type?: string | null, tagSearchField?: string | null, demographySearchField?: string | null, titleSearch?: string | null, totalVolumes?: number | null, totalNotReleasedVolumes?: number | null, totalReleasedVolumes?: number | null, lastCollectionChanged?: any | null, lastReadChanged?: any | null, createdAt?: any | null, compoundKey?: string | null, popularityScore?: any | null, recommendationScore?: any | null, entry?: { __typename?: 'ReleaseEntry', id: string, status?: ReleaseEntryStatusType | null, sortedVolumeNumbers?: any | null, notReleasedVolumeNumbers?: any | null, totalReleasedVolumes?: number | null, startDate?: any | null, endDate?: any | null } | null, readStatus?: Array<{ __typename?: 'UserReleaseReadStatus', id: string, finishedRead?: any | null, readStatus?: any | null, startedRead?: any | null, status?: UserReleaseReadStatusStatusType | null }> | null }>, userCustomLists: Array<{ __typename?: 'UserCustomList', id: string, urlName?: string | null, name?: string | null, description?: string | null, targetType?: UserCustomListTargetTypeType | null, mode?: UserCustomListModeType | null, isPublic?: boolean | null, isCustomTag?: boolean | null, customTagName?: string | null, customIcon?: string | null, removeWhenCollected?: boolean | null, removeWhenRead?: boolean | null, showTotalNumber?: boolean | null, showTotalValue?: boolean | null, statusFilter?: UserCustomListStatusFilterType | null, filter?: any | null, sort?: any | null, order?: number | null }>, userCustomListReleaseEntryItems: Array<{ __typename?: 'UserCustomListReleaseEntryItem', id: string, orderNumber?: number | null, list?: { __typename?: 'UserCustomList', id: string } | null, releaseEntry?: { __typename?: 'ReleaseEntry', id: string } | null }>, userCustomListNoveltyItems: Array<{ __typename?: 'UserCustomListNoveltyItem', id: string, orderNumber?: number | null, list?: { __typename?: 'UserCustomList', id: string } | null, novelty?: { __typename?: 'Novelty', id: string, entryId?: string | null, relationType?: NoveltyRelationTypeType | null, relationId?: string | null, number?: any | null, volumeSuffix?: string | null, releaseItems?: any | null, collectionVolumeInfo?: { __typename?: 'NoveltyCollectionVolumeInfo', kind: string } | null } | null }>, tombstones: Array<{ __typename?: 'UserTombstone', entity: string, rowId: string }> } | null };

export type GetUserLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLanguageQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, language?: UserLanguageType | null }> | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, language?: UserLanguageType | null } | null };


export const RecordUserActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordUserActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordUserActivity"}}]}}]} as unknown as DocumentNode<RecordUserActivityMutation, RecordUserActivityMutationVariables>;
export const GetPublishedDatabaseListConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishedDatabaseListConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DatabaseListConfigWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DatabaseListConfigOrderByInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseListConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}},{"kind":"Field","name":{"kind":"Name","value":"nameDe"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleDe"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleEn"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"listType"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredFilterPropsForChangeDetection"}},{"kind":"Field","name":{"kind":"Name","value":"hideSearch"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<GetPublishedDatabaseListConfigsQuery, GetPublishedDatabaseListConfigsQueryVariables>;
export const GetMyCustomListsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyCustomLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomTag"}},{"kind":"Field","name":{"kind":"Name","value":"customTagName"}},{"kind":"Field","name":{"kind":"Name","value":"customIcon"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenCollected"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenRead"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"statusFilter"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<GetMyCustomListsQuery, GetMyCustomListsQueryVariables>;
export const UserCustomListStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCustomListStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomListStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCount"}},{"kind":"Field","name":{"kind":"Name","value":"seriesCount"}},{"kind":"Field","name":{"kind":"Name","value":"volumeCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]} as unknown as DocumentNode<UserCustomListStatsQuery, UserCustomListStatsQueryVariables>;
export const GetUserCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomTag"}},{"kind":"Field","name":{"kind":"Name","value":"customTagName"}},{"kind":"Field","name":{"kind":"Name","value":"customIcon"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenCollected"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenRead"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"statusFilter"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"curatedReleaseEntriesCount"}},{"kind":"Field","name":{"kind":"Name","value":"curatedNoveltiesCount"}}]}}]}}]} as unknown as DocumentNode<GetUserCustomListQuery, GetUserCustomListQueryVariables>;
export const GetDatabaseListCuratedEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDatabaseListCuratedEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DatabaseListReleaseEntryWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DatabaseListReleaseEntryOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseListReleaseEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}}]}}]}}]}}]} as unknown as DocumentNode<GetDatabaseListCuratedEntriesQuery, GetDatabaseListCuratedEntriesQueryVariables>;
export const GetUserListCuratedEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserListCuratedEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListReleaseEntryItemWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListReleaseEntryItemOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomListReleaseEntryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserListCuratedEntriesQuery, GetUserListCuratedEntriesQueryVariables>;
export const GetUserListCuratedNoveltiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserListCuratedNovelties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListNoveltyItemWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListNoveltyItemOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomListNoveltyItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"novelty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserListCuratedNoveltiesQuery, GetUserListCuratedNoveltiesQueryVariables>;
export const GetFilteredCustomListNoveltiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredCustomListNovelties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredCustomListNovelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}},{"kind":"Field","name":{"kind":"Name","value":"collectionVolumeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volumeCount"}},{"kind":"Field","name":{"kind":"Name","value":"spansEntries"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilteredCustomListNoveltiesQuery, GetFilteredCustomListNoveltiesQueryVariables>;
export const GetFilteredCustomListReleaseEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredCustomListReleaseEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredReleaseEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}}]}}]}}]} as unknown as DocumentNode<GetFilteredCustomListReleaseEntriesQuery, GetFilteredCustomListReleaseEntriesQueryVariables>;
export const CreateUserCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCustomList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}}]}}]}}]} as unknown as DocumentNode<CreateUserCustomListMutation, CreateUserCustomListMutationVariables>;
export const UpdateUserCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomListUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCustomList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserCustomListMutation, UpdateUserCustomListMutationVariables>;
export const DeleteUserCustomListWithItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserCustomListWithItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserCustomListWithItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserCustomListWithItemsMutation, DeleteUserCustomListWithItemsMutationVariables>;
export const GetMyCuratedListsWithMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyCuratedListsWithMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"curated"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomTag"}},{"kind":"Field","name":{"kind":"Name","value":"customTagName"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenCollected"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenRead"}},{"kind":"Field","name":{"kind":"Name","value":"curatedReleaseEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"curatedNovelties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"novelty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}},{"kind":"Field","name":{"kind":"Name","value":"collectionVolumeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMyCuratedListsWithMembersQuery, GetMyCuratedListsWithMembersQueryVariables>;
export const GetNoveltyIdByRelationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNoveltyIdByRelation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"novelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relationId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetNoveltyIdByRelationQuery, GetNoveltyIdByRelationQueryVariables>;
export const AddReleaseEntryToCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddReleaseEntryToCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCustomListReleaseEntryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"list"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseEntryId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddReleaseEntryToCustomListMutation, AddReleaseEntryToCustomListMutationVariables>;
export const RemoveReleaseEntryFromCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveReleaseEntryFromCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserCustomListReleaseEntryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveReleaseEntryFromCustomListMutation, RemoveReleaseEntryFromCustomListMutationVariables>;
export const AddNoveltyToCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNoveltyToCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noveltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCustomListNoveltyItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"list"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"novelty"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noveltyId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNoveltyToCustomListMutation, AddNoveltyToCustomListMutationVariables>;
export const RemoveNoveltyFromCustomListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveNoveltyFromCustomList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserCustomListNoveltyItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveNoveltyFromCustomListMutation, RemoveNoveltyFromCustomListMutationVariables>;
export const GetReleaseItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"originalCover"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"extrasNote"}},{"kind":"Field","name":{"kind":"Name","value":"extrasOnlyOnFirstEdition"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}}]}}]}}]} as unknown as DocumentNode<GetReleaseItemsQuery, GetReleaseItemsQueryVariables>;
export const GetVolumeSuffixesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVolumeSuffixes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volumeSuffixes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]} as unknown as DocumentNode<GetVolumeSuffixesQuery, GetVolumeSuffixesQueryVariables>;
export const GetReleaseItemCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseItemCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemCollectionWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemCollectionOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseItemCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extrasNote"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}}]}}]}}]} as unknown as DocumentNode<GetReleaseItemCollectionsQuery, GetReleaseItemCollectionsQueryVariables>;
export const GetNoveltiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNovelties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"novelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}}]}}]}}]} as unknown as DocumentNode<GetNoveltiesQuery, GetNoveltiesQueryVariables>;
export const GetCatalogChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCatalogChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceSeq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogSubscriptionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sinceSeq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceSeq"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscription"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextSeq"}},{"kind":"Field","name":{"kind":"Name","value":"headSeq"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"resyncRequired"}},{"kind":"Field","name":{"kind":"Name","value":"tombstones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"novelties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"releaseYear"}},{"kind":"Field","name":{"kind":"Name","value":"releaseMonth"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"titleSearch"}},{"kind":"Field","name":{"kind":"Name","value":"tagSearchField"}},{"kind":"Field","name":{"kind":"Name","value":"demographySearchField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseYear"}},{"kind":"Field","name":{"kind":"Name","value":"releaseMonth"}},{"kind":"Field","name":{"kind":"Name","value":"yearMonthKey"}},{"kind":"Field","name":{"kind":"Name","value":"popularityScore"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationScore"}},{"kind":"Field","name":{"kind":"Name","value":"firstVolumeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"totalNotReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"publisherHistory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"creationDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"needsToBeCheckedReason"}},{"kind":"Field","name":{"kind":"Name","value":"tagSearchField"}},{"kind":"Field","name":{"kind":"Name","value":"demographySearchField"}},{"kind":"Field","name":{"kind":"Name","value":"titleSearch"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seriesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"material"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"disableNovelty"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"originalCover"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"originalIsbn"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseYear"}},{"kind":"Field","name":{"kind":"Name","value":"releaseMonth"}},{"kind":"Field","name":{"kind":"Name","value":"yearMonthKey"}},{"kind":"Field","name":{"kind":"Name","value":"extrasOnlyOnFirstEdition"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"creationDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"needsToBeCheckedReason"}},{"kind":"Field","name":{"kind":"Name","value":"extrasNote"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"currentEditionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tagSearchField"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseItemCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"itemsOnlyExistInThisCollection"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseYear"}},{"kind":"Field","name":{"kind":"Name","value":"releaseMonth"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"extrasNote"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"currentEditionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tagSearchField"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"publisherChangeEvents"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"vlbId"}},{"kind":"Field","name":{"kind":"Name","value":"vlbKeyword"}},{"kind":"Field","name":{"kind":"Name","value":"vlbSubjectFilter"}},{"kind":"Field","name":{"kind":"Name","value":"vlbTitleFilter"}},{"kind":"Field","name":{"kind":"Name","value":"colorLightTheme"}},{"kind":"Field","name":{"kind":"Name","value":"colorDarkTheme"}},{"kind":"Field","name":{"kind":"Name","value":"longName"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateRun"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVlbTextTypeCodes"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"betterCoverProvider"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortNumber"}},{"kind":"Field","name":{"kind":"Name","value":"tagType"}},{"kind":"Field","name":{"kind":"Name","value":"promotionStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"promotionEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demographies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffixes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seriesInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"originalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedTitle"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demography"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jpPublishers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"magazines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"originalVlb71Code"}},{"kind":"Field","name":{"kind":"Name","value":"individual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"individuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"exId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleNames"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"disambiguator"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"vlb71Codes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"magazines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jpPublishers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sizeAliasName"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"materialInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"databaseListConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}},{"kind":"Field","name":{"kind":"Name","value":"nameDe"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleDe"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleEn"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"listType"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredFilterPropsForChangeDetection"}},{"kind":"Field","name":{"kind":"Name","value":"hideSearch"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"databaseListReleaseEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"compoundKey"}},{"kind":"Field","name":{"kind":"Name","value":"databaseList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>;
export const GetFilteredNoveltiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilteredNovelties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredNovelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDateAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}},{"kind":"Field","name":{"kind":"Name","value":"collectionVolumeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volumeCount"}},{"kind":"Field","name":{"kind":"Name","value":"spansEntries"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilteredNoveltiesQuery, GetFilteredNoveltiesQueryVariables>;
export const GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagOrderByInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tagType"}},{"kind":"Field","name":{"kind":"Name","value":"promotionStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"promotionEndDate"}}]}}]}}]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const GetDemographiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDemographies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DemographyOrderByInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demographies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDemographiesQuery, GetDemographiesQueryVariables>;
export const GetPublishersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublisherOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublisherWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"colorDarkTheme"}},{"kind":"Field","name":{"kind":"Name","value":"colorLightTheme"}}]}}]}}]} as unknown as DocumentNode<GetPublishersQuery, GetPublishersQueryVariables>;
export const GetUserAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAdmins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"adSkipTokens"}},{"kind":"Field","name":{"kind":"Name","value":"isTester"}},{"kind":"Field","name":{"kind":"Name","value":"premiumTier"}},{"kind":"Field","name":{"kind":"Name","value":"premiumStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"premiumLastRenewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserAdminQuery, GetUserAdminQueryVariables>;
export const GetMissingIsbnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMissingIsbns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MissingIsbnWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"missingIsbns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userExplanation"}}]}}]}}]} as unknown as DocumentNode<GetMissingIsbnsQuery, GetMissingIsbnsQueryVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MissingIsbnCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMissingIsbn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;
export const UpdateMissingIsbnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMissingIsbn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MissingIsbnWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MissingIsbnUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMissingIsbn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMissingIsbnMutation, UpdateMissingIsbnMutationVariables>;
export const GetUserExistingCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserExistingCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"currentReadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"miscItemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRead"}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startedRead"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserExistingCollectionsQuery, GetUserExistingCollectionsQueryVariables>;
export const GetReleaseEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetReleaseEntryQuery, GetReleaseEntryQueryVariables>;
export const GetReleaseEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}}]}}]}}]} as unknown as DocumentNode<GetReleaseEntriesQuery, GetReleaseEntriesQueryVariables>;
export const UserCollectionEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCollectionEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userReleaseEntryStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentReadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<UserCollectionEntriesQuery, UserCollectionEntriesQueryVariables>;
export const FilteredUserCollectionEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredUserCollectionEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusOrderByInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredUserReleaseEntryStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentReadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<FilteredUserCollectionEntriesQuery, FilteredUserCollectionEntriesQueryVariables>;
export const UpdateUserCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserReleaseEntryStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserCollectionMutation, UpdateUserCollectionMutationVariables>;
export const RemoveUserCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserReleaseEntryStatusWithEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveUserCollectionMutation, RemoveUserCollectionMutationVariables>;
export const UpdateReadStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReadStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseReadStatusWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseReadStatusUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserReleaseReadStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateReadStatusMutation, UpdateReadStatusMutationVariables>;
export const CreateUserCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserReleaseEntryStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserCollectionMutation, CreateUserCollectionMutationVariables>;
export const GetSharedCollectionSiblingEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSharedCollectionSiblingEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemCollectionWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseItemCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sharedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSharedCollectionSiblingEntriesQuery, GetSharedCollectionSiblingEntriesQueryVariables>;
export const GetSingleUserCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSingleUserCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserReleaseEntryStatusWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userReleaseEntryStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"currentReadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"miscItemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRead"}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startedRead"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetSingleUserCollectionQuery, GetSingleUserCollectionQueryVariables>;
export const GetReleaseEntryIdFromIsbnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseEntryIDFromISBN"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseItemWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}}]}}]}}]} as unknown as DocumentNode<GetReleaseEntryIdFromIsbnQuery, GetReleaseEntryIdFromIsbnQueryVariables>;
export const GetUserNotificationTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotificationTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationFcmTokens"}}]}}]}}]} as unknown as DocumentNode<GetUserNotificationTokensQuery, GetUserNotificationTokensQueryVariables>;
export const UpdateUserNotificationTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserNotificationTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationFcmTokens"}}]}}]}}]} as unknown as DocumentNode<UpdateUserNotificationTokensMutation, UpdateUserNotificationTokensMutationVariables>;
export const GetNoveltyByIsbnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNoveltyByISBN"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"novelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[]}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}}]}}]}}]} as unknown as DocumentNode<GetNoveltyByIsbnQuery, GetNoveltyByIsbnQueryVariables>;
export const GetNoveltiesByIsbNsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNoveltiesByISBNs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoveltyWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"novelties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[]}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedSeriesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}}]}}]}}]} as unknown as DocumentNode<GetNoveltiesByIsbNsQuery, GetNoveltiesByIsbNsQueryVariables>;
export const GetReleaseEntriesWithSeriesInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseEntriesWithSeriesInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseEntryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeAliasName"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"material"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seriesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jpPublishers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"magazines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"romanizedTitle"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demography"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"individual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"individual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]} as unknown as DocumentNode<GetReleaseEntriesWithSeriesInfoQuery, GetReleaseEntriesWithSeriesInfoQueryVariables>;
export const GetUserNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromPublishers"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromPublishersList"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromAuthors"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromAuthorsList"}},{"kind":"Field","name":{"kind":"Name","value":"notificationAddedReleaseDateToExistingReleaseCollectionItem"}},{"kind":"Field","name":{"kind":"Name","value":"notificationChangedReleaseDateOfExistingReleaseCollectionItem"}},{"kind":"Field","name":{"kind":"Name","value":"notificationReleaseCollectionItemAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"notificationReleaseCollectionItemAlternativeVersionRelease"}},{"kind":"Field","name":{"kind":"Name","value":"notificationScannedItemAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"notificationAtsumeRecommendations"}}]}}]}}]} as unknown as DocumentNode<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>;
export const UpdateUserNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromPublishers"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromPublishersList"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromAuthors"}},{"kind":"Field","name":{"kind":"Name","value":"notificationNewReleasesFromAuthorsList"}},{"kind":"Field","name":{"kind":"Name","value":"notificationAddedReleaseDateToExistingReleaseCollectionItem"}},{"kind":"Field","name":{"kind":"Name","value":"notificationChangedReleaseDateOfExistingReleaseCollectionItem"}},{"kind":"Field","name":{"kind":"Name","value":"notificationReleaseCollectionItemAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"notificationReleaseCollectionItemAlternativeVersionRelease"}},{"kind":"Field","name":{"kind":"Name","value":"notificationScannedItemAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"notificationAtsumeRecommendations"}}]}}]}}]} as unknown as DocumentNode<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>;
export const SearchPublishersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPublishers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublisherWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchPublishersQuery, SearchPublishersQueryVariables>;
export const GetPublishersByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishersByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublisherWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPublishersByIdsQuery, GetPublishersByIdsQueryVariables>;
export const SearchIndividualsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchIndividuals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IndividualWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"individuals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchIndividualsQuery, SearchIndividualsQueryVariables>;
export const GetIndividualsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIndividualsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IndividualWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"individuals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetIndividualsByIdsQuery, GetIndividualsByIdsQueryVariables>;
export const GetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrderByInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"timeRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetUnreadNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRead"},"value":{"kind":"NullValue"}}]}}]}]}}]} as unknown as DocumentNode<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>;
export const UpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeRead"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const GetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"admin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileQuery, GetProfileQueryVariables>;
export const UpdateUserNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const GetMyCollectionStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyCollectionStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCollectionStatsItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"readVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"totalListPrice"}},{"kind":"Field","name":{"kind":"Name","value":"releasesByStatus"}},{"kind":"Field","name":{"kind":"Name","value":"soldVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"soldValue"}}]}}]}}]} as unknown as DocumentNode<GetMyCollectionStatsQuery, GetMyCollectionStatsQueryVariables>;
export const GetMyRecentStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyRecentStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDay"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userStatsDailyFacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dimension"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"total"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"volumesAdded"}},{"kind":"Field","name":{"kind":"Name","value":"volumesRead"}}]}}]}}]} as unknown as DocumentNode<GetMyRecentStatsQuery, GetMyRecentStatsQueryVariables>;
export const GetUserChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceSeq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sinceSeq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceSeq"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAdmins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isGuest"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isTester"}},{"kind":"Field","name":{"kind":"Name","value":"premiumTier"}},{"kind":"Field","name":{"kind":"Name","value":"premiumStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"premiumLastRenewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"adSkipTokens"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseEntryStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"currentReadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"itemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"miscItemStatus"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"publisherName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tagSearchField"}},{"kind":"Field","name":{"kind":"Name","value":"demographySearchField"}},{"kind":"Field","name":{"kind":"Name","value":"titleSearch"}},{"kind":"Field","name":{"kind":"Name","value":"totalVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"totalNotReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"lastCollectionChanged"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadChanged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"compoundKey"}},{"kind":"Field","name":{"kind":"Name","value":"popularityScore"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationScore"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sortedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"notReleasedVolumeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"totalReleasedVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRead"}},{"kind":"Field","name":{"kind":"Name","value":"readStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startedRead"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCustomLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomTag"}},{"kind":"Field","name":{"kind":"Name","value":"customTagName"}},{"kind":"Field","name":{"kind":"Name","value":"customIcon"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenCollected"}},{"kind":"Field","name":{"kind":"Name","value":"removeWhenRead"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"showTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"statusFilter"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCustomListReleaseEntryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCustomListNoveltyItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"novelty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"volumeSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"releaseItems"}},{"kind":"Field","name":{"kind":"Name","value":"collectionVolumeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tombstones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextSeq"}},{"kind":"Field","name":{"kind":"Name","value":"headSeq"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"resyncRequired"}}]}}]}}]} as unknown as DocumentNode<GetUserChangesQuery, GetUserChangesQueryVariables>;
export const GetUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<GetUserLanguageQuery, GetUserLanguageQueryVariables>;
export const UpdateUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;